(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea3c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea3c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3oLo3", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $27985f0e2f3220bc$export$dca3b0875bd9a954; }, function (v) { return $27985f0e2f3220bc$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $27985f0e2f3220bc$export$16fa2f45be04daa8; }, function (v) { return $27985f0e2f3220bc$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27985f0e2f3220bc$export$ffb0004e005737fa; }, function (v) { return $27985f0e2f3220bc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $27985f0e2f3220bc$export$e2c29f18771995cb; }, function (v) { return $27985f0e2f3220bc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $27985f0e2f3220bc$export$221d75b3f55bb0bd; }, function (v) { return $27985f0e2f3220bc$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27985f0e2f3220bc$export$5f8d39834fd61797; }, function (v) { return $27985f0e2f3220bc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27985f0e2f3220bc$export$74bf444e3cd11ea5; }, function (v) { return $27985f0e2f3220bc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $27985f0e2f3220bc$export$ae55be85d98224ed; }, function (v) { return $27985f0e2f3220bc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $27985f0e2f3220bc$export$e530037191fcd5d7; }, function (v) { return $27985f0e2f3220bc$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $27985f0e2f3220bc$export$fd42f52fd3ae1109; }, function (v) { return $27985f0e2f3220bc$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $27985f0e2f3220bc$export$c8a8987d4410bf2d; }, function (v) { return $27985f0e2f3220bc$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $27985f0e2f3220bc$export$d38cd72104c1f0e9; }, function (v) { return $27985f0e2f3220bc$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $27985f0e2f3220bc$export$7d1e3a5e95ceca43; }, function (v) { return $27985f0e2f3220bc$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $27985f0e2f3220bc$export$257a8862b851cb5b; }, function (v) { return $27985f0e2f3220bc$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $27985f0e2f3220bc$export$a8257692ac88316c; }, function (v) { return $27985f0e2f3220bc$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $27985f0e2f3220bc$export$488013bae63b21da; }, function (v) { return $27985f0e2f3220bc$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $27985f0e2f3220bc$export$7c73462e0d25e514; }, function (v) { return $27985f0e2f3220bc$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $27985f0e2f3220bc$export$7568632d0d33d16d; }, function (v) { return $27985f0e2f3220bc$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $27985f0e2f3220bc$export$88948ce120ea2619; }, function (v) { return $27985f0e2f3220bc$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $27985f0e2f3220bc$export$35808ee640e87ca7; }, function (v) { return $27985f0e2f3220bc$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $27985f0e2f3220bc$export$fae74005e78b1a27; }, function (v) { return $27985f0e2f3220bc$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $27985f0e2f3220bc$export$dc8fbce3eb94dc1e; }, function (v) { return $27985f0e2f3220bc$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $27985f0e2f3220bc$export$6a7bc4e911dc01cf; }, function (v) { return $27985f0e2f3220bc$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $27985f0e2f3220bc$export$6d9c69b0de29b591; }, function (v) { return $27985f0e2f3220bc$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $27985f0e2f3220bc$export$f680877a34711e37; }, function (v) { return $27985f0e2f3220bc$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $27985f0e2f3220bc$export$d5a552a76deda3c2; }, function (v) { return $27985f0e2f3220bc$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $27985f0e2f3220bc$export$aaabe4eda9ed9969; }, function (v) { return $27985f0e2f3220bc$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $27985f0e2f3220bc$export$e5c5a5f917a5871c; }, function (v) { return $27985f0e2f3220bc$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $27985f0e2f3220bc$export$1538c33de8887b59; }, function (v) { return $27985f0e2f3220bc$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $27985f0e2f3220bc$export$13e3392192263954; }, function (v) { return $27985f0e2f3220bc$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $27985f0e2f3220bc$export$b8f5890fc79d6aca; }, function (v) { return $27985f0e2f3220bc$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $27985f0e2f3220bc$export$60241385465d0a34; }, function (v) { return $27985f0e2f3220bc$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $27985f0e2f3220bc$export$306c0aa65ff9ec16; }, function (v) { return $27985f0e2f3220bc$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $27985f0e2f3220bc$export$7b286972b8d8ccbf; }, function (v) { return $27985f0e2f3220bc$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $27985f0e2f3220bc$export$83d89fbfd8236492; }, function (v) { return $27985f0e2f3220bc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27985f0e2f3220bc$export$dca3b0875bd9a954;
var $27985f0e2f3220bc$export$16fa2f45be04daa8;
var $27985f0e2f3220bc$export$ffb0004e005737fa;
var $27985f0e2f3220bc$export$e2c29f18771995cb;
var $27985f0e2f3220bc$export$221d75b3f55bb0bd;
var $27985f0e2f3220bc$export$5f8d39834fd61797;
var $27985f0e2f3220bc$export$74bf444e3cd11ea5;
var $27985f0e2f3220bc$export$ae55be85d98224ed;
var $27985f0e2f3220bc$export$e530037191fcd5d7;
var $27985f0e2f3220bc$export$fd42f52fd3ae1109;
var $27985f0e2f3220bc$export$c8a8987d4410bf2d;
var $27985f0e2f3220bc$export$d38cd72104c1f0e9;
var $27985f0e2f3220bc$export$7d1e3a5e95ceca43;
var $27985f0e2f3220bc$export$257a8862b851cb5b;
var $27985f0e2f3220bc$export$a8257692ac88316c;
var $27985f0e2f3220bc$export$488013bae63b21da;
var $27985f0e2f3220bc$export$7c73462e0d25e514;
var $27985f0e2f3220bc$export$7568632d0d33d16d;
var $27985f0e2f3220bc$export$88948ce120ea2619;
var $27985f0e2f3220bc$export$35808ee640e87ca7;
var $27985f0e2f3220bc$export$fae74005e78b1a27;
var $27985f0e2f3220bc$export$dc8fbce3eb94dc1e;
var $27985f0e2f3220bc$export$6a7bc4e911dc01cf;
var $27985f0e2f3220bc$export$6d9c69b0de29b591;
var $27985f0e2f3220bc$export$f680877a34711e37;
var $27985f0e2f3220bc$export$d5a552a76deda3c2;
var $27985f0e2f3220bc$export$aaabe4eda9ed9969;
var $27985f0e2f3220bc$export$e5c5a5f917a5871c;
var $27985f0e2f3220bc$export$1538c33de8887b59;
var $27985f0e2f3220bc$export$13e3392192263954;
var $27985f0e2f3220bc$export$b8f5890fc79d6aca;
var $27985f0e2f3220bc$export$60241385465d0a34;
var $27985f0e2f3220bc$export$306c0aa65ff9ec16;
var $27985f0e2f3220bc$export$7b286972b8d8ccbf;
var $27985f0e2f3220bc$export$83d89fbfd8236492;
"use strict";
var $27985f0e2f3220bc$var$l = Symbol.for("react.element"), $27985f0e2f3220bc$var$n = Symbol.for("react.portal"), $27985f0e2f3220bc$var$p = Symbol.for("react.fragment"), $27985f0e2f3220bc$var$q = Symbol.for("react.strict_mode"), $27985f0e2f3220bc$var$r = Symbol.for("react.profiler"), $27985f0e2f3220bc$var$t = Symbol.for("react.provider"), $27985f0e2f3220bc$var$u = Symbol.for("react.context"), $27985f0e2f3220bc$var$v = Symbol.for("react.forward_ref"), $27985f0e2f3220bc$var$w = Symbol.for("react.suspense"), $27985f0e2f3220bc$var$x = Symbol.for("react.memo"), $27985f0e2f3220bc$var$y = Symbol.for("react.lazy"), $27985f0e2f3220bc$var$z = Symbol.iterator;
function $27985f0e2f3220bc$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $27985f0e2f3220bc$var$z && a[$27985f0e2f3220bc$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $27985f0e2f3220bc$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $27985f0e2f3220bc$var$C = Object.assign, $27985f0e2f3220bc$var$D = {};
function $27985f0e2f3220bc$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $27985f0e2f3220bc$var$D;
    this.updater = e || $27985f0e2f3220bc$var$B;
}
$27985f0e2f3220bc$var$E.prototype.isReactComponent = {};
$27985f0e2f3220bc$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$27985f0e2f3220bc$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $27985f0e2f3220bc$var$F() {}
$27985f0e2f3220bc$var$F.prototype = $27985f0e2f3220bc$var$E.prototype;
function $27985f0e2f3220bc$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $27985f0e2f3220bc$var$D;
    this.updater = e || $27985f0e2f3220bc$var$B;
}
var $27985f0e2f3220bc$var$H = $27985f0e2f3220bc$var$G.prototype = new $27985f0e2f3220bc$var$F;
$27985f0e2f3220bc$var$H.constructor = $27985f0e2f3220bc$var$G;
$27985f0e2f3220bc$var$C($27985f0e2f3220bc$var$H, $27985f0e2f3220bc$var$E.prototype);
$27985f0e2f3220bc$var$H.isPureReactComponent = !0;
var $27985f0e2f3220bc$var$I = Array.isArray, $27985f0e2f3220bc$var$J = Object.prototype.hasOwnProperty, $27985f0e2f3220bc$var$K = {
    current: null
}, $27985f0e2f3220bc$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $27985f0e2f3220bc$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$27985f0e2f3220bc$var$J.call(b, d) && !$27985f0e2f3220bc$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $27985f0e2f3220bc$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $27985f0e2f3220bc$var$K.current
    };
}
function $27985f0e2f3220bc$var$N(a, b) {
    return {
        $$typeof: $27985f0e2f3220bc$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $27985f0e2f3220bc$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27985f0e2f3220bc$var$l;
}
function $27985f0e2f3220bc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $27985f0e2f3220bc$var$P = /\/+/g;
function $27985f0e2f3220bc$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $27985f0e2f3220bc$var$escape("" + a.key) : b.toString(36);
}
function $27985f0e2f3220bc$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $27985f0e2f3220bc$var$l:
                case $27985f0e2f3220bc$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $27985f0e2f3220bc$var$Q(h, 0) : d, $27985f0e2f3220bc$var$I(c) ? (e = "", null != a && (e = a.replace($27985f0e2f3220bc$var$P, "$&/") + "/"), $27985f0e2f3220bc$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($27985f0e2f3220bc$var$O(c) && (c = $27985f0e2f3220bc$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($27985f0e2f3220bc$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($27985f0e2f3220bc$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $27985f0e2f3220bc$var$Q(k, g);
        h += $27985f0e2f3220bc$var$R(k, b, e, f, c);
    }
    else if (f = $27985f0e2f3220bc$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $27985f0e2f3220bc$var$Q(k, g++), h += $27985f0e2f3220bc$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $27985f0e2f3220bc$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $27985f0e2f3220bc$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $27985f0e2f3220bc$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $27985f0e2f3220bc$var$U = {
    current: null
}, $27985f0e2f3220bc$var$V = {
    transition: null
}, $27985f0e2f3220bc$var$W = {
    ReactCurrentDispatcher: $27985f0e2f3220bc$var$U,
    ReactCurrentBatchConfig: $27985f0e2f3220bc$var$V,
    ReactCurrentOwner: $27985f0e2f3220bc$var$K
};
$27985f0e2f3220bc$export$dca3b0875bd9a954 = {
    map: $27985f0e2f3220bc$var$S,
    forEach: function(a, b, e) {
        $27985f0e2f3220bc$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $27985f0e2f3220bc$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $27985f0e2f3220bc$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$27985f0e2f3220bc$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$27985f0e2f3220bc$export$16fa2f45be04daa8 = $27985f0e2f3220bc$var$E;
$27985f0e2f3220bc$export$ffb0004e005737fa = $27985f0e2f3220bc$var$p;
$27985f0e2f3220bc$export$e2c29f18771995cb = $27985f0e2f3220bc$var$r;
$27985f0e2f3220bc$export$221d75b3f55bb0bd = $27985f0e2f3220bc$var$G;
$27985f0e2f3220bc$export$5f8d39834fd61797 = $27985f0e2f3220bc$var$q;
$27985f0e2f3220bc$export$74bf444e3cd11ea5 = $27985f0e2f3220bc$var$w;
$27985f0e2f3220bc$export$ae55be85d98224ed = $27985f0e2f3220bc$var$W;
$27985f0e2f3220bc$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $27985f0e2f3220bc$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $27985f0e2f3220bc$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$27985f0e2f3220bc$var$J.call(b, f) && !$27985f0e2f3220bc$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $27985f0e2f3220bc$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$27985f0e2f3220bc$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $27985f0e2f3220bc$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $27985f0e2f3220bc$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$27985f0e2f3220bc$export$c8a8987d4410bf2d = $27985f0e2f3220bc$var$M;
$27985f0e2f3220bc$export$d38cd72104c1f0e9 = function(a) {
    var b = $27985f0e2f3220bc$var$M.bind(null, a);
    b.type = a;
    return b;
};
$27985f0e2f3220bc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$27985f0e2f3220bc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $27985f0e2f3220bc$var$v,
        render: a
    };
};
$27985f0e2f3220bc$export$a8257692ac88316c = $27985f0e2f3220bc$var$O;
$27985f0e2f3220bc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $27985f0e2f3220bc$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $27985f0e2f3220bc$var$T
    };
};
$27985f0e2f3220bc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $27985f0e2f3220bc$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$27985f0e2f3220bc$export$7568632d0d33d16d = function(a) {
    var b = $27985f0e2f3220bc$var$V.transition;
    $27985f0e2f3220bc$var$V.transition = {};
    try {
        a();
    } finally{
        $27985f0e2f3220bc$var$V.transition = b;
    }
};
$27985f0e2f3220bc$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$27985f0e2f3220bc$export$35808ee640e87ca7 = function(a, b) {
    return $27985f0e2f3220bc$var$U.current.useCallback(a, b);
};
$27985f0e2f3220bc$export$fae74005e78b1a27 = function(a) {
    return $27985f0e2f3220bc$var$U.current.useContext(a);
};
$27985f0e2f3220bc$export$dc8fbce3eb94dc1e = function() {};
$27985f0e2f3220bc$export$6a7bc4e911dc01cf = function(a) {
    return $27985f0e2f3220bc$var$U.current.useDeferredValue(a);
};
$27985f0e2f3220bc$export$6d9c69b0de29b591 = function(a, b) {
    return $27985f0e2f3220bc$var$U.current.useEffect(a, b);
};
$27985f0e2f3220bc$export$f680877a34711e37 = function() {
    return $27985f0e2f3220bc$var$U.current.useId();
};
$27985f0e2f3220bc$export$d5a552a76deda3c2 = function(a, b, e) {
    return $27985f0e2f3220bc$var$U.current.useImperativeHandle(a, b, e);
};
$27985f0e2f3220bc$export$aaabe4eda9ed9969 = function(a, b) {
    return $27985f0e2f3220bc$var$U.current.useInsertionEffect(a, b);
};
$27985f0e2f3220bc$export$e5c5a5f917a5871c = function(a, b) {
    return $27985f0e2f3220bc$var$U.current.useLayoutEffect(a, b);
};
$27985f0e2f3220bc$export$1538c33de8887b59 = function(a, b) {
    return $27985f0e2f3220bc$var$U.current.useMemo(a, b);
};
$27985f0e2f3220bc$export$13e3392192263954 = function(a, b, e) {
    return $27985f0e2f3220bc$var$U.current.useReducer(a, b, e);
};
$27985f0e2f3220bc$export$b8f5890fc79d6aca = function(a) {
    return $27985f0e2f3220bc$var$U.current.useRef(a);
};
$27985f0e2f3220bc$export$60241385465d0a34 = function(a) {
    return $27985f0e2f3220bc$var$U.current.useState(a);
};
$27985f0e2f3220bc$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $27985f0e2f3220bc$var$U.current.useSyncExternalStore(a, b, e);
};
$27985f0e2f3220bc$export$7b286972b8d8ccbf = function() {
    return $27985f0e2f3220bc$var$U.current.useTransition();
};
$27985f0e2f3220bc$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("gEPfk", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $hJwnw = parcelRequire("hJwnw");

var $70tqi = parcelRequire("70tqi");

var $ezKtH = parcelRequire("ezKtH");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$hJwnw) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $hJwnw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $70tqi({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $hJwnw.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $70tqi({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $70tqi({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $ezKtH.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $ezKtH.unstable_scheduleCallback($ezKtH.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $ezKtH.unstable_UserBlockingPriority, ed = $ezKtH.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $70tqi({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$70tqi(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $70tqi(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $70tqi({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $70tqi({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $ezKtH.unstable_runWithPriority, Jf = $ezKtH.unstable_scheduleCallback, Kf = $ezKtH.unstable_cancelCallback, Lf = $ezKtH.unstable_requestPaint, Mf = $ezKtH.unstable_now, Nf = $ezKtH.unstable_getCurrentPriorityLevel, Of = $ezKtH.unstable_ImmediatePriority, Pf = $ezKtH.unstable_UserBlockingPriority, Qf = $ezKtH.unstable_NormalPriority, Rf = $ezKtH.unstable_LowPriority, Sf = $ezKtH.unstable_IdlePriority, Tf = {}, Uf = $ezKtH.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $70tqi({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $70tqi({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $hJwnw.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $70tqi({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $70tqi({}, f, {
                    value: void 0
                });
                d = $70tqi({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $70tqi({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($70tqi({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("hJwnw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3oLo3"));

});

parcelRegister("70tqi", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $519f5b540dd3ab43$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $519f5b540dd3ab43$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $519f5b540dd3ab43$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $519f5b540dd3ab43$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $519f5b540dd3ab43$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $519f5b540dd3ab43$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $519f5b540dd3ab43$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($519f5b540dd3ab43$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($519f5b540dd3ab43$var$getOwnPropertySymbols) {
            symbols = $519f5b540dd3ab43$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($519f5b540dd3ab43$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("ezKtH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3mkwB"));

});
parcelRegister("3mkwB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $272358f6156b52f7$export$c4744153514ff05d; }, function (v) { return $272358f6156b52f7$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $272358f6156b52f7$export$d66a1c1c77bd778b; }, function (v) { return $272358f6156b52f7$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $272358f6156b52f7$export$3e506c1ccc9cc1a7; }, function (v) { return $272358f6156b52f7$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $272358f6156b52f7$export$e26fe2ed2fa76875; }, function (v) { return $272358f6156b52f7$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $272358f6156b52f7$export$502329bbf4b505b1; }, function (v) { return $272358f6156b52f7$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $272358f6156b52f7$export$6e3807111c4874c4; }, function (v) { return $272358f6156b52f7$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $272358f6156b52f7$export$c27134553091fb3a; }, function (v) { return $272358f6156b52f7$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $272358f6156b52f7$export$33ee1acdc04fd2a2; }, function (v) { return $272358f6156b52f7$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $272358f6156b52f7$export$b00a404bbd5edef2; }, function (v) { return $272358f6156b52f7$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $272358f6156b52f7$export$8352ce38b91d0c62; }, function (v) { return $272358f6156b52f7$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $272358f6156b52f7$export$d3dfb8e4810cb555; }, function (v) { return $272358f6156b52f7$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $272358f6156b52f7$export$839f9183b0465a69; }, function (v) { return $272358f6156b52f7$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $272358f6156b52f7$export$72fdf0e06517287b; }, function (v) { return $272358f6156b52f7$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $272358f6156b52f7$export$4b844e58a3e414b4; }, function (v) { return $272358f6156b52f7$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $272358f6156b52f7$export$816d2913ae6b83b1; }, function (v) { return $272358f6156b52f7$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $272358f6156b52f7$export$61bcfe829111a1d0; }, function (v) { return $272358f6156b52f7$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $272358f6156b52f7$export$7ee8c9beb337bc3f; }, function (v) { return $272358f6156b52f7$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $272358f6156b52f7$export$b5836b71941fa3ed; }, function (v) { return $272358f6156b52f7$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $272358f6156b52f7$export$cf845f2c119da08a; }, function (v) { return $272358f6156b52f7$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $272358f6156b52f7$export$c4744153514ff05d;
var $272358f6156b52f7$export$d66a1c1c77bd778b;
var $272358f6156b52f7$export$3e506c1ccc9cc1a7;
var $272358f6156b52f7$export$e26fe2ed2fa76875;
var $272358f6156b52f7$export$502329bbf4b505b1;
var $272358f6156b52f7$export$6e3807111c4874c4;
var $272358f6156b52f7$export$c27134553091fb3a;
var $272358f6156b52f7$export$33ee1acdc04fd2a2;
var $272358f6156b52f7$export$b00a404bbd5edef2;
var $272358f6156b52f7$export$8352ce38b91d0c62;
var $272358f6156b52f7$export$d3dfb8e4810cb555;
var $272358f6156b52f7$export$839f9183b0465a69;
var $272358f6156b52f7$export$72fdf0e06517287b;
var $272358f6156b52f7$export$4b844e58a3e414b4;
var $272358f6156b52f7$export$816d2913ae6b83b1;
var $272358f6156b52f7$export$61bcfe829111a1d0;
var $272358f6156b52f7$export$7ee8c9beb337bc3f;
var $272358f6156b52f7$export$b5836b71941fa3ed;
var $272358f6156b52f7$export$cf845f2c119da08a;
"use strict";
var $272358f6156b52f7$var$f, $272358f6156b52f7$var$g, $272358f6156b52f7$var$h, $272358f6156b52f7$var$k, $272358f6156b52f7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $272358f6156b52f7$var$p = null, $272358f6156b52f7$var$q = null, $272358f6156b52f7$var$t = function() {
        if (null !== $272358f6156b52f7$var$p) try {
            var a = $272358f6156b52f7$export$c4744153514ff05d();
            $272358f6156b52f7$var$p(!0, a);
            $272358f6156b52f7$var$p = null;
        } catch (b) {
            throw setTimeout($272358f6156b52f7$var$t, 0), b;
        }
    }, $272358f6156b52f7$var$u = Date.now();
    $272358f6156b52f7$export$c4744153514ff05d = function() {
        return Date.now() - $272358f6156b52f7$var$u;
    };
    $272358f6156b52f7$var$f = function(a) {
        null !== $272358f6156b52f7$var$p ? setTimeout($272358f6156b52f7$var$f, 0, a) : ($272358f6156b52f7$var$p = a, setTimeout($272358f6156b52f7$var$t, 0));
    };
    $272358f6156b52f7$var$g = function(a, b) {
        $272358f6156b52f7$var$q = setTimeout(a, b);
    };
    $272358f6156b52f7$var$h = function() {
        clearTimeout($272358f6156b52f7$var$q);
    };
    $272358f6156b52f7$var$k = function() {
        return !1;
    };
    $272358f6156b52f7$var$l = $272358f6156b52f7$export$d66a1c1c77bd778b = function() {};
} else {
    var $272358f6156b52f7$var$w = window.performance, $272358f6156b52f7$var$x = window.Date, $272358f6156b52f7$var$y = window.setTimeout, $272358f6156b52f7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $272358f6156b52f7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $272358f6156b52f7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $272358f6156b52f7$var$w && "function" === typeof $272358f6156b52f7$var$w.now) $272358f6156b52f7$export$c4744153514ff05d = function() {
        return $272358f6156b52f7$var$w.now();
    };
    else {
        var $272358f6156b52f7$var$B = $272358f6156b52f7$var$x.now();
        $272358f6156b52f7$export$c4744153514ff05d = function() {
            return $272358f6156b52f7$var$x.now() - $272358f6156b52f7$var$B;
        };
    }
    var $272358f6156b52f7$var$C = !1, $272358f6156b52f7$var$D = null, $272358f6156b52f7$var$E = -1, $272358f6156b52f7$var$F = 5, $272358f6156b52f7$var$G = 0;
    $272358f6156b52f7$var$k = function() {
        return $272358f6156b52f7$export$c4744153514ff05d() >= $272358f6156b52f7$var$G;
    };
    $272358f6156b52f7$var$l = function() {};
    $272358f6156b52f7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $272358f6156b52f7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $272358f6156b52f7$var$H = new MessageChannel, $272358f6156b52f7$var$I = $272358f6156b52f7$var$H.port2;
    $272358f6156b52f7$var$H.port1.onmessage = function() {
        if (null !== $272358f6156b52f7$var$D) {
            var a = $272358f6156b52f7$export$c4744153514ff05d();
            $272358f6156b52f7$var$G = a + $272358f6156b52f7$var$F;
            try {
                $272358f6156b52f7$var$D(!0, a) ? $272358f6156b52f7$var$I.postMessage(null) : ($272358f6156b52f7$var$C = !1, $272358f6156b52f7$var$D = null);
            } catch (b) {
                throw $272358f6156b52f7$var$I.postMessage(null), b;
            }
        } else $272358f6156b52f7$var$C = !1;
    };
    $272358f6156b52f7$var$f = function(a) {
        $272358f6156b52f7$var$D = a;
        $272358f6156b52f7$var$C || ($272358f6156b52f7$var$C = !0, $272358f6156b52f7$var$I.postMessage(null));
    };
    $272358f6156b52f7$var$g = function(a, b) {
        $272358f6156b52f7$var$E = $272358f6156b52f7$var$y(function() {
            a($272358f6156b52f7$export$c4744153514ff05d());
        }, b);
    };
    $272358f6156b52f7$var$h = function() {
        $272358f6156b52f7$var$z($272358f6156b52f7$var$E);
        $272358f6156b52f7$var$E = -1;
    };
}
function $272358f6156b52f7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $272358f6156b52f7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $272358f6156b52f7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $272358f6156b52f7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $272358f6156b52f7$var$K(n, c)) void 0 !== r && 0 > $272358f6156b52f7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $272358f6156b52f7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $272358f6156b52f7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $272358f6156b52f7$var$N = [], $272358f6156b52f7$var$O = [], $272358f6156b52f7$var$P = 1, $272358f6156b52f7$var$Q = null, $272358f6156b52f7$var$R = 3, $272358f6156b52f7$var$S = !1, $272358f6156b52f7$var$T = !1, $272358f6156b52f7$var$U = !1;
function $272358f6156b52f7$var$V(a) {
    for(var b = $272358f6156b52f7$var$L($272358f6156b52f7$var$O); null !== b;){
        if (null === b.callback) $272358f6156b52f7$var$M($272358f6156b52f7$var$O);
        else if (b.startTime <= a) $272358f6156b52f7$var$M($272358f6156b52f7$var$O), b.sortIndex = b.expirationTime, $272358f6156b52f7$var$J($272358f6156b52f7$var$N, b);
        else break;
        b = $272358f6156b52f7$var$L($272358f6156b52f7$var$O);
    }
}
function $272358f6156b52f7$var$W(a) {
    $272358f6156b52f7$var$U = !1;
    $272358f6156b52f7$var$V(a);
    if (!$272358f6156b52f7$var$T) {
        if (null !== $272358f6156b52f7$var$L($272358f6156b52f7$var$N)) $272358f6156b52f7$var$T = !0, $272358f6156b52f7$var$f($272358f6156b52f7$var$X);
        else {
            var b = $272358f6156b52f7$var$L($272358f6156b52f7$var$O);
            null !== b && $272358f6156b52f7$var$g($272358f6156b52f7$var$W, b.startTime - a);
        }
    }
}
function $272358f6156b52f7$var$X(a, b) {
    $272358f6156b52f7$var$T = !1;
    $272358f6156b52f7$var$U && ($272358f6156b52f7$var$U = !1, $272358f6156b52f7$var$h());
    $272358f6156b52f7$var$S = !0;
    var c = $272358f6156b52f7$var$R;
    try {
        $272358f6156b52f7$var$V(b);
        for($272358f6156b52f7$var$Q = $272358f6156b52f7$var$L($272358f6156b52f7$var$N); null !== $272358f6156b52f7$var$Q && (!($272358f6156b52f7$var$Q.expirationTime > b) || a && !$272358f6156b52f7$var$k());){
            var d = $272358f6156b52f7$var$Q.callback;
            if (null !== d) {
                $272358f6156b52f7$var$Q.callback = null;
                $272358f6156b52f7$var$R = $272358f6156b52f7$var$Q.priorityLevel;
                var e = d($272358f6156b52f7$var$Q.expirationTime <= b);
                b = $272358f6156b52f7$export$c4744153514ff05d();
                "function" === typeof e ? $272358f6156b52f7$var$Q.callback = e : $272358f6156b52f7$var$Q === $272358f6156b52f7$var$L($272358f6156b52f7$var$N) && $272358f6156b52f7$var$M($272358f6156b52f7$var$N);
                $272358f6156b52f7$var$V(b);
            } else $272358f6156b52f7$var$M($272358f6156b52f7$var$N);
            $272358f6156b52f7$var$Q = $272358f6156b52f7$var$L($272358f6156b52f7$var$N);
        }
        if (null !== $272358f6156b52f7$var$Q) var m = !0;
        else {
            var n = $272358f6156b52f7$var$L($272358f6156b52f7$var$O);
            null !== n && $272358f6156b52f7$var$g($272358f6156b52f7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $272358f6156b52f7$var$Q = null, $272358f6156b52f7$var$R = c, $272358f6156b52f7$var$S = !1;
    }
}
function $272358f6156b52f7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $272358f6156b52f7$var$Z = $272358f6156b52f7$var$l;
$272358f6156b52f7$export$3e506c1ccc9cc1a7 = 5;
$272358f6156b52f7$export$e26fe2ed2fa76875 = 1;
$272358f6156b52f7$export$502329bbf4b505b1 = 4;
$272358f6156b52f7$export$6e3807111c4874c4 = 3;
$272358f6156b52f7$export$c27134553091fb3a = null;
$272358f6156b52f7$export$33ee1acdc04fd2a2 = 2;
$272358f6156b52f7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$272358f6156b52f7$export$8352ce38b91d0c62 = function() {
    $272358f6156b52f7$var$T || $272358f6156b52f7$var$S || ($272358f6156b52f7$var$T = !0, $272358f6156b52f7$var$f($272358f6156b52f7$var$X));
};
$272358f6156b52f7$export$d3dfb8e4810cb555 = function() {
    return $272358f6156b52f7$var$R;
};
$272358f6156b52f7$export$839f9183b0465a69 = function() {
    return $272358f6156b52f7$var$L($272358f6156b52f7$var$N);
};
$272358f6156b52f7$export$72fdf0e06517287b = function(a) {
    switch($272358f6156b52f7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $272358f6156b52f7$var$R;
    }
    var c = $272358f6156b52f7$var$R;
    $272358f6156b52f7$var$R = b;
    try {
        return a();
    } finally{
        $272358f6156b52f7$var$R = c;
    }
};
$272358f6156b52f7$export$4b844e58a3e414b4 = function() {};
$272358f6156b52f7$export$816d2913ae6b83b1 = $272358f6156b52f7$var$Z;
$272358f6156b52f7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $272358f6156b52f7$var$R;
    $272358f6156b52f7$var$R = a;
    try {
        return b();
    } finally{
        $272358f6156b52f7$var$R = c;
    }
};
$272358f6156b52f7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $272358f6156b52f7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $272358f6156b52f7$var$Y(a);
    } else c = $272358f6156b52f7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $272358f6156b52f7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $272358f6156b52f7$var$J($272358f6156b52f7$var$O, a), null === $272358f6156b52f7$var$L($272358f6156b52f7$var$N) && a === $272358f6156b52f7$var$L($272358f6156b52f7$var$O) && ($272358f6156b52f7$var$U ? $272358f6156b52f7$var$h() : $272358f6156b52f7$var$U = !0, $272358f6156b52f7$var$g($272358f6156b52f7$var$W, e - d))) : (a.sortIndex = c, $272358f6156b52f7$var$J($272358f6156b52f7$var$N, a), $272358f6156b52f7$var$T || $272358f6156b52f7$var$S || ($272358f6156b52f7$var$T = !0, $272358f6156b52f7$var$f($272358f6156b52f7$var$X)));
    return a;
};
$272358f6156b52f7$export$b5836b71941fa3ed = function() {
    var a = $272358f6156b52f7$export$c4744153514ff05d();
    $272358f6156b52f7$var$V(a);
    var b = $272358f6156b52f7$var$L($272358f6156b52f7$var$N);
    return b !== $272358f6156b52f7$var$Q && null !== $272358f6156b52f7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $272358f6156b52f7$var$Q.expirationTime || $272358f6156b52f7$var$k();
};
$272358f6156b52f7$export$cf845f2c119da08a = function(a) {
    var b = $272358f6156b52f7$var$R;
    return function() {
        var c = $272358f6156b52f7$var$R;
        $272358f6156b52f7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $272358f6156b52f7$var$R = c;
        }
    };
};

});



parcelRegister("7fjkP", function(module, exports) {

$parcel$export(module.exports, "$mobx", function () { return $mobx; });
$parcel$export(module.exports, "createAtom", function () { return createAtom; });
$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "_allowStateReadsStart", function () { return allowStateReadsStart; });
$parcel$export(module.exports, "_allowStateReadsEnd", function () { return allowStateReadsEnd; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "makeAutoObservable", function () { return makeAutoObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    }
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    var _proto$constructor;
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    return ((_proto$constructor = proto.constructor) == null ? void 0 : _proto$constructor.toString()) === plainObjectString;
} // https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object); // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
} // From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
} // From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {}; // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
     // @override must override something
    var fieldName;
    assertNotDecorated(prototype, annotation, key); // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    } // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name); // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v; // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1
    };
}
function make_$1(adm, key) {
    var _this$options_$bound, _this$options_, _adm$target_$storedAn;
    var annotated = false;
    var source = adm.target_;
    var bound = (_this$options_$bound = (_this$options_ = this.options_) == null ? void 0 : _this$options_.bound) != null ? _this$options_$bound : false;
    while(source && source !== objectPrototype){
        var descriptor = getDescriptor(source, key);
        if (descriptor) {
            // Instance or bound
            // Keep first because the operation can be intercepted
            // and we don't want to end up with partially annotated proto chain
            if (source === adm.target_ || bound) {
                var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
                var definePropertyOutcome = adm.defineProperty_(key, actionDescriptor);
                if (!definePropertyOutcome) // Intercepted
                return;
                annotated = true; // Don't annotate protos if bound
                if (bound) break;
            } // Prototype
            if (source !== adm.target_) {
                if (isAction(descriptor.value)) {
                    // A prototype could have been annotated already by other constructor,
                    // rest of the proto chain must be annotated already
                    annotated = true;
                    break;
                }
                var _actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
                defineProperty(source, key, _actionDescriptor);
                annotated = true;
            }
        }
        source = Object.getPrototypeOf(source);
    }
    if (annotated) recordAnnotationApplied(adm, this, key);
    else if (!((_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2
    };
}
function make_$2(adm, key) {
    var _adm$target_$storedAn;
    var annotated = false;
    var source = adm.target_;
    while(source && source !== objectPrototype){
        var descriptor = getDescriptor(source, key);
        if (descriptor) {
            if (source !== adm.target_) {
                // Prototype
                if (isFlow(descriptor.value)) {
                    // A prototype could have been annotated already by other constructor,
                    // rest of the proto chain must be annotated already
                    annotated = true;
                    break;
                }
                var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false);
                defineProperty(source, key, flowDescriptor);
            } else {
                var _flowDescriptor = createFlowDescriptor(adm, this, key, descriptor);
                var definePropertyOutcome = adm.defineProperty_(key, _flowDescriptor);
                if (!definePropertyOutcome) // Intercepted
                return;
            }
            annotated = true;
        }
        source = Object.getPrototypeOf(source);
    }
    if (annotated) recordAnnotationApplied(adm, this, key);
    else if (!((_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    return {
        value: flow(descriptor.value),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3
    };
}
function make_$3(adm, key) {
    var _adm$target_$storedAn;
    var source = adm.target_;
    while(source && source !== objectPrototype){
        var descriptor = getDescriptor(source, key);
        if (descriptor) {
            assertComputedDescriptor(adm, this, key, descriptor);
            var definePropertyOutcome = adm.defineComputedProperty_(key, _extends({}, this.options_, {
                get: descriptor.get,
                set: descriptor.set
            }));
            if (!definePropertyOutcome) // Intercepted
            return;
            recordAnnotationApplied(adm, this, key);
            return;
        }
        source = Object.getPrototypeOf(source);
    }
    if (!((_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4
    };
}
function make_$4(adm, key) {
    var _adm$target_$storedAn;
    var source = adm.target_; // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    while(source && source !== objectPrototype){
        var descriptor = getDescriptor(source, key);
        if (descriptor) {
            var _this$options_$enhanc, _this$options_;
            assertObservableDescriptor(adm, this, key, descriptor);
            var definePropertyOutcome = adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer);
            if (!definePropertyOutcome) // Intercepted
            return;
            recordAnnotationApplied(adm, this, key);
            return;
        }
        source = Object.getPrototypeOf(source);
    }
    if (!((_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc2, _this$options_2;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc2 = (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.enhancer) != null ? _this$options_$enhanc2 : deepEnhancer, proxyTrap);
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation("observable");
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation("observable.ref", {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation("observable.shallow", {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation("observable.struct", {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    return options ? options.deep === true ? observableAnnotation : options.deep === false ? observableRefAnnotation : options.defaultDecorator : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    } // already observable - ignore
    if (isObservable(v)) return v; // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3); // Array
    if (Array.isArray(v)) return observable.array(v, arg2); // Map
    if (isES6Map(v)) return observable.map(v, arg2); // Set
    if (isES6Set(v)) return observable.set(v, arg2); // other object - ignore
    if (typeof v === "object" && v !== null) return v; // anything else
    return observable.box(v, arg2);
}
Object.assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
}; // eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
     // computed(expr, options?)
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || "");
    /* for generated name */ return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false; // we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        Object.defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        } // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = !!options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true; // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_"; // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_"; // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_"; // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause; // Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                     // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true); // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_; // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        } // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    } // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    } // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
} // function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_; // invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
     // invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions(); // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_; // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return true;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
} // function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_; // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    }); // invariantLOS(observable, "changed end");
} // Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    }); // invariantLOS(observable, "confirmed end");
} // Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    }); // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1); // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("	") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        if (requiresObservable_ === void 0) requiresObservable_ = false;
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return; // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_() {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0; // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return; // dead code elimination can do the rest
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction); // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction); // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
         // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts); // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule_();
    return reaction.getDisposer_();
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue = undefined; // only an issue with fireImmediately
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    r.schedule_();
    return r.getDisposer_();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed"; // const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    var descriptors = getOwnPropertyDescriptors(properties);
    var adm = asObservableObject(target, options)[$mobx];
    startBatch();
    try {
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], !annotations ? true : key in annotations ? annotations[key] : true);
        });
    } finally{
        endBatch();
    }
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
     // flow(fn)
    var generator = arg1;
    var name = generator.name || "<unnamed flow>"; // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise); // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined); // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property !== undefined) {
        if (isObservableObject(value) === false) return false;
        if (!value[$mobx].values_.has(property)) return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    } // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        keys(source); // make sure keys are observed
        var _res3 = cache(__alreadySeen, source, {});
        getPlainObjectKeys(source).forEach(function(key) {
            _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Basically, a deep clone, so that no reactive property will exist anymore.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    die("trace() is not available in production builds");
    var enterBreakPoint = false;
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    if (derivation.isTracing_ === TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
    derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") timeoutHandle = setTimeout(function() {
        if (!disposer[$mobx].isDisposed_) {
            disposer();
            var error = new Error("WHEN_TIMEOUT");
            if (opts.onError) opts.onError(error);
            else throw error;
        }
    }, opts.timeout);
    opts.name = "When";
    var effectAction = createAction("When-effect", effect); // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var cancel;
    var res = new Promise(function(resolve, reject) {
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
} // Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false; // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    var adm = asObservableObject(target, options)[$mobx];
    startBatch();
    try {
        var _annotations;
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target); // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    } finally{
        endBatch();
    }
    return target;
}
function makeAutoObservable(target, overrides, options) {
    // assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    var adm = asObservableObject(target, options)[$mobx];
    startBatch();
    try {
        // Use cached inferred annotations if available (only in classes)
        if (target[inferredAnnotationsSymbol]) target[inferredAnnotationsSymbol].forEach(function(value, key) {
            return adm.make_(key, value);
        });
        else {
            var _ignoreKeys;
            var ignoreKeys = (_ignoreKeys = {}, _ignoreKeys[$mobx] = 1, _ignoreKeys[inferredAnnotationsSymbol] = 1, _ignoreKeys.constructor = 1, _ignoreKeys);
            var make = function make(key) {
                if (ignoreKeys[key]) return;
                ignoreKeys[key] = 1;
                adm.make_(key, !overrides ? true : key in overrides ? overrides[key] : true);
            };
            var current = target;
            while(current && current !== objectPrototype){
                ownKeys(current).forEach(make);
                current = Object.getPrototypeOf(current);
            }
        }
    } finally{
        endBatch();
    }
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            var res = this.values_.slice(index, index + deleteCount);
            var oldItems = this.values_.slice(index + deleteCount);
            this.values_.length = index + newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null; // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged(); // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (index < this.values_.length) {
            this.atom_.reportObserved();
            return this.dehanceValue_(this.values_[index]);
        }
        console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else if (index === values.length) // add a new item
        this.spliceWithArray_(index, 0, [
            newValue
        ]);
        else // out of bounds
        die(17, index, values.length);
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
    addHiddenFinalProp(adm.values_, $mobx, adm);
    var proxy = new Proxy(adm.values_, arrayTraps);
    adm.proxy_ = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray_(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
} // eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc); // map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc); // reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
} // Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
} // Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
} // Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_); // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete"; // just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        this.keysAtom_ = createAtom("ObservableMap.keys()");
        this.data_ = new Map();
        this.hasMap_ = new Map();
        this.merge(initialData);
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this2 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                _this2.keysAtom_.reportChanged();
                _this2.updateHasMapEntry_(key, false);
                var observable = _this2.data_.get(key);
                observable.setNewValue_(undefined);
                _this2.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateHasMapEntry_ = function updateHasMapEntry_(key, value) {
        var entry = this.hasMap_.get(key);
        if (entry) entry.setNewValue_(value);
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var observable = new ObservableValue(newValue, _this3.enhancer_, "ObservableMap.key", false);
            _this3.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            _this3.updateHasMapEntry_(key, true);
            _this3.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this4 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this4.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this4.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this4.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this5 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this5.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this5["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this6 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map(); // Used for optimization
            var keysReportChangedCalled = false; // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this6.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this6["delete"](key); // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this6.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            } // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this6.data_.has(_key); // Add or update value
                _this6.set(_key, _value); // The addition could have been prevent by interceptor
                if (_this6.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this6.data_.get(_key);
                    orderedData.set(_key, _value2); // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            } // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this6.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this6.keysAtom_.reportChanged();
                else {
                    var iter1 = _this6.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this6.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            } // Use correctly ordered map
            _this6.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}(); // eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.atom_ = createAtom(this.name_);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        if (initialData) this.replace(initialData);
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this2 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this; // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this2.data_.add(_this2.enhancer_(value, undefined));
                _this2.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this3 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this3.atom_.reportChanged();
                _this3.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this4 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this4.clear();
                other.forEach(function(value) {
                    return _this4.add(value);
                });
            } else if (isES6Set(other)) {
                _this4.clear();
                other.forEach(function(value) {
                    return _this4.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}(); // eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var inferredAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-inferred-annotations");
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, defaultAnnotation_, autoBind_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = observable;
        if (autoBind_ === void 0) autoBind_ = false;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.autoBind_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.autoBind_ = autoBind_;
        this.keysAtom_ = new Atom("ObservableObject.keys"); // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        } // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue); // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - infer from descriptor, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    } // Trap for "in"
    ;
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - infer from object or it's prototype, false - ignore
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.inferAnnotation_(key);
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        annotation.make_(this, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - infer from descriptor, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = inferAnnotationFromDescriptor(descriptor, this.defaultAnnotation_, this.autoBind_);
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.inferAnnotation_ = function inferAnnotation_(key) {
        var _this$target_$inferre;
        // Inherited is fine - annotation cannot differ in subclass
        var annotation = (_this$target_$inferre = this.target_[inferredAnnotationsSymbol]) == null ? void 0 : _this$target_$inferre.get(key);
        if (annotation) return annotation;
        var current = this.target_;
        while(current && current !== objectPrototype){
            var descriptor = getDescriptor(current, key);
            if (descriptor) {
                annotation = inferAnnotationFromDescriptor(descriptor, this.defaultAnnotation_, this.autoBind_);
                break;
            }
            current = Object.getPrototypeOf(current);
        } // Not found (false means ignore)
        if (annotation === undefined) die(1, "true", key);
         // Cache the annotation.
        // Note we can do this only because annotation and field can't change.
        if (!this.isPlainObject_) {
            // We could also place it on furthest proto, shoudn't matter
            var closestProto = Object.getPrototypeOf(this.target_);
            if (!hasProp(closestProto, inferredAnnotationsSymbol)) addHiddenProp(closestProto, inferredAnnotationsSymbol, new Map());
            closestProto[inferredAnnotationsSymbol].set(key, annotation);
        }
        return annotation;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            } // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
             // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    } // If original descriptor becomes relevant, move this to annotation directly
    ;
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            }; // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var _observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, _observable); // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, _observable.value_);
        } finally{
            endBatch();
        }
        return true;
    } // If original descriptor becomes relevant, move this to annotation directly
    ;
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            }; // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options)); // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // No such prop
        if (!hasProp(this.target_, key)) return true;
         // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            }); // Cancelled
            if (!change) return null;
        } // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var _observable2 = this.values_.get(key); // Value needed for spies/listeners
            var value = undefined; // Optimization: don't pull the value unless we will need it
            if (!_observable2 && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            } // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
             // Allow re-annotating this field
            if (_observable2) {
                this.values_["delete"](key); // for computed, value is undefined
                if (_observable2 instanceof ObservableValue) value = _observable2.value_;
                 // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(_observable2);
            } // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged(); // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_); // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true); // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options), options == null ? void 0 : options.autoBind);
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0; // Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype); // Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
        adm.proxy_ = _assertThisInitialized(_this);
        addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
        if (initialValues && initialValues.length) {
            var prev = allowStateChangesStart(true); // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            allowStateChangesEnd(prev);
        }
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                // @ts-ignore
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing[$mobx];
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
} // Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b; // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false; // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b; // Exhaust primitive checks
    var type = typeof a;
    if (!isFunction(type) && type !== "object" && typeof b != "object") return false; // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b; // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    } // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false; // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
     // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    } // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b); // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false; // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length; // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    } // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
/**
 * Infers the best fitting annotation from property descriptor or false if the field shoudn't be annotated
 * - getter(+setter) -> computed
 * - setter w/o getter -> false (ignore)
 * - flow -> false (ignore)
 * - generator -> flow
 * - action -> false (ignore)
 * - function -> action (optionally bound)
 * - other -> defaultAnnotation
 */ function inferAnnotationFromDescriptor(desc, defaultAnnotation, autoBind) {
    if (desc.get) return computed;
    if (desc.set) return false; // ignore lone setter
    // If already wrapped in action/flow, don't do that another time, but assume it is already set up properly.
    return isFunction(desc.value) ? isGenerator(desc.value) ? isFlow(desc.value) ? false : flow : isAction(desc.value) ? false : autoBind ? autoAction.bound : autoAction : defaultAnnotation;
}
function isAnnotation(thing) {
    return thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_);
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set",
    "Symbol"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("dsaRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $3axOX = parcelRequire("3axOX");

var $bt6cS = parcelRequire("bt6cS");

var $lxHjm = parcelRequire("lxHjm");

var $3RBuV = parcelRequire("3RBuV");

var $lLGYK = parcelRequire("lLGYK");

var $8tXVm = parcelRequire("8tXVm");

var $gbD2e = parcelRequire("gbD2e");

var $gZne0 = parcelRequire("gZne0");

var $1nmAO = parcelRequire("1nmAO");
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bt6cS.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $lxHjm.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $bt6cS.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $lxHjm.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $gbD2e.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gbD2e.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8tXVm.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var ResourceStore = function(_EventEmitter) {
    (0, $lLGYK.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $bt6cS.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3RBuV.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $lxHjm.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $gbD2e.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gbD2e.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8tXVm.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $lLGYK.default)(Translator, _EventEmitter);
    var _super = _createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bt6cS.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3RBuV.default)(_this));
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $3RBuV.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = baseLogger.create("translator");
        return _this;
    }
    (0, $lxHjm.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $3axOX.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $3axOX.default)(options) === "object") options = _objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
                        interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $bt6cS.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    (0, $lxHjm.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bt6cS.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = createRules();
    }
    (0, $lxHjm.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $bt6cS.default)(this, Interpolator);
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $lxHjm.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $1nmAO.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $bt6cS.default)(this, Formatter);
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $lxHjm.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $gbD2e.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gbD2e.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8tXVm.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $lLGYK.default)(Connector, _EventEmitter);
    var _super = _createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $bt6cS.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3RBuV.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $lxHjm.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $3axOX.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $3axOX.default)(args[2]) === "object" || (0, $3axOX.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, $gZne0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gbD2e.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gbD2e.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8tXVm.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $lLGYK.default)(I18n, _EventEmitter);
    var _super = _createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $bt6cS.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3RBuV.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $3RBuV.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $8tXVm.default)(_this, (0, $3RBuV.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $lxHjm.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $3axOX.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $gZne0.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});
parcelRegister("3axOX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ec8a62212c49b2$export$2e2bcd8739ae039; });
function $24ec8a62212c49b2$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $24ec8a62212c49b2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $24ec8a62212c49b2$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("bt6cS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $859737a589e313fb$export$2e2bcd8739ae039; });
function $859737a589e313fb$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lxHjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faee46bc28a1e965$export$2e2bcd8739ae039; });

var $kFzFt = parcelRequire("kFzFt");
function $faee46bc28a1e965$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $kFzFt.default)(descriptor.key), descriptor);
    }
}
function $faee46bc28a1e965$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $faee46bc28a1e965$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $faee46bc28a1e965$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("kFzFt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0c34dde5b9d371c$export$2e2bcd8739ae039; });

var $3axOX = parcelRequire("3axOX");

var $daayP = parcelRequire("daayP");
function $f0c34dde5b9d371c$export$2e2bcd8739ae039(arg) {
    var key = (0, $daayP.default)(arg, "string");
    return (0, $3axOX.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("daayP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $995466ad3d5e6b00$export$2e2bcd8739ae039; });

var $3axOX = parcelRequire("3axOX");
function $995466ad3d5e6b00$export$2e2bcd8739ae039(input, hint) {
    if ((0, $3axOX.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $3axOX.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRegister("3RBuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d036899cc62c60a$export$2e2bcd8739ae039; });
function $2d036899cc62c60a$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("lLGYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd8f53791e2e0f33$export$2e2bcd8739ae039; });

var $dxBYa = parcelRequire("dxBYa");
function $fd8f53791e2e0f33$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $dxBYa.default)(subClass, superClass);
}

});
parcelRegister("dxBYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dbbcf60321eb561$export$2e2bcd8739ae039; });
function $9dbbcf60321eb561$export$2e2bcd8739ae039(o, p) {
    $9dbbcf60321eb561$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9dbbcf60321eb561$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("8tXVm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62cf83d7aca0bbb7$export$2e2bcd8739ae039; });

var $3axOX = parcelRequire("3axOX");

var $3RBuV = parcelRequire("3RBuV");
function $62cf83d7aca0bbb7$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $3axOX.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3RBuV.default)(self);
}

});

parcelRegister("gbD2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc8bf3f46ad012ce$export$2e2bcd8739ae039; });
function $bc8bf3f46ad012ce$export$2e2bcd8739ae039(o) {
    $bc8bf3f46ad012ce$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bc8bf3f46ad012ce$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gZne0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5e45bd57b836082$export$2e2bcd8739ae039; });

var $kFzFt = parcelRequire("kFzFt");
function $c5e45bd57b836082$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $kFzFt.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("1nmAO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $100976e04cccb067$export$2e2bcd8739ae039; });

var $dXiRp = parcelRequire("dXiRp");

var $16FmH = parcelRequire("16FmH");

var $4BiNd = parcelRequire("4BiNd");

var $4e52L = parcelRequire("4e52L");
function $100976e04cccb067$export$2e2bcd8739ae039(arr) {
    return (0, $dXiRp.default)(arr) || (0, $16FmH.default)(arr) || (0, $4BiNd.default)(arr) || (0, $4e52L.default)();
}

});
parcelRegister("dXiRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a28f6a57c1582a8a$export$2e2bcd8739ae039; });
function $a28f6a57c1582a8a$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("16FmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ce670394ff52dcd$export$2e2bcd8739ae039; });
function $0ce670394ff52dcd$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4BiNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359931f6fcd8b0c1$export$2e2bcd8739ae039; });

var $cpXZG = parcelRequire("cpXZG");
function $359931f6fcd8b0c1$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $cpXZG.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $cpXZG.default)(o, minLen);
}

});
parcelRegister("cpXZG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90a65b63f48c6251$export$2e2bcd8739ae039; });
function $90a65b63f48c6251$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("4e52L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $313c61c1d74260b4$export$2e2bcd8739ae039; });
function $313c61c1d74260b4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




var $hJwnw = parcelRequire("hJwnw");
var $a7721eb599d74a7a$exports = {};
"use strict";
function $a7721eb599d74a7a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a7721eb599d74a7a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a7721eb599d74a7a$var$checkDCE();

$a7721eb599d74a7a$exports = (parcelRequire("gEPfk"));



var $hJwnw = parcelRequire("hJwnw");
function $fcbc31c3a20ef8e6$export$34c5a9262f934fa5(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for(let i = 0; i < vars.length; i++){
        const pair = vars[i].split("=");
        if (pair[0] == variable) return decodeURIComponent(pair[1]);
    }
    return false;
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4210dc1af4009341$var$extendStatics = function(d, b) {
    $4210dc1af4009341$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4210dc1af4009341$var$extendStatics(d, b);
};
function $4210dc1af4009341$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4210dc1af4009341$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4210dc1af4009341$export$18ce0697a983be9b = function() {
    $4210dc1af4009341$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4210dc1af4009341$export$18ce0697a983be9b.apply(this, arguments);
};
function $4210dc1af4009341$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4210dc1af4009341$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4210dc1af4009341$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4210dc1af4009341$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4210dc1af4009341$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4210dc1af4009341$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4210dc1af4009341$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4210dc1af4009341$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4210dc1af4009341$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4210dc1af4009341$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4210dc1af4009341$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4210dc1af4009341$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4210dc1af4009341$export$45d3717a4c69092e(o, m, p);
}
function $4210dc1af4009341$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4210dc1af4009341$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4210dc1af4009341$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4210dc1af4009341$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4210dc1af4009341$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4210dc1af4009341$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4210dc1af4009341$export$10c90e4f7922046c(v) {
    return this instanceof $4210dc1af4009341$export$10c90e4f7922046c ? (this.v = v, this) : new $4210dc1af4009341$export$10c90e4f7922046c(v);
}
function $4210dc1af4009341$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4210dc1af4009341$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4210dc1af4009341$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4210dc1af4009341$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4210dc1af4009341$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4210dc1af4009341$export$19a8beecd37a4c45 === "function" ? $4210dc1af4009341$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4210dc1af4009341$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4210dc1af4009341$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4210dc1af4009341$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4210dc1af4009341$export$45d3717a4c69092e(result, mod, k);
    }
    $4210dc1af4009341$var$__setModuleDefault(result, mod);
    return result;
}
function $4210dc1af4009341$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4210dc1af4009341$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4210dc1af4009341$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4210dc1af4009341$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4210dc1af4009341$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4210dc1af4009341$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4210dc1af4009341$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4210dc1af4009341$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4210dc1af4009341$export$2e2bcd8739ae039 = {
    __extends: $4210dc1af4009341$export$a8ba968b8961cb8a,
    __assign: $4210dc1af4009341$export$18ce0697a983be9b,
    __rest: $4210dc1af4009341$export$3c9a16f847548506,
    __decorate: $4210dc1af4009341$export$29e00dfd3077644b,
    __param: $4210dc1af4009341$export$d5ad3fd78186038f,
    __metadata: $4210dc1af4009341$export$f1db080c865becb9,
    __awaiter: $4210dc1af4009341$export$1050f835b63b671e,
    __generator: $4210dc1af4009341$export$67ebef60e6f28a6,
    __createBinding: $4210dc1af4009341$export$45d3717a4c69092e,
    __exportStar: $4210dc1af4009341$export$f33643c0debef087,
    __values: $4210dc1af4009341$export$19a8beecd37a4c45,
    __read: $4210dc1af4009341$export$8d051b38c9118094,
    __spread: $4210dc1af4009341$export$afc72e2116322959,
    __spreadArrays: $4210dc1af4009341$export$6388937ca91ccae8,
    __spreadArray: $4210dc1af4009341$export$1216008129fb82ed,
    __await: $4210dc1af4009341$export$10c90e4f7922046c,
    __asyncGenerator: $4210dc1af4009341$export$e427f37a30a4de9b,
    __asyncDelegator: $4210dc1af4009341$export$bbd80228419bb833,
    __asyncValues: $4210dc1af4009341$export$e3b29a3d6162315f,
    __makeTemplateObject: $4210dc1af4009341$export$4fb47efe1390b86f,
    __importStar: $4210dc1af4009341$export$c21735bcef00d192,
    __importDefault: $4210dc1af4009341$export$da59b14a69baef04,
    __classPrivateFieldGet: $4210dc1af4009341$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4210dc1af4009341$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4210dc1af4009341$export$81fdc39f203e4e04,
    __addDisposableResource: $4210dc1af4009341$export$88ac25d8e944e405,
    __disposeResources: $4210dc1af4009341$export$8f076105dc360e92
};



var $7fjkP = parcelRequire("7fjkP");
const $8e272ff57971c6ac$export$da3bc2f57520e3c3 = {
    pageConsent: {
        page: "consent"
    },
    pageError: {
        page: "error"
    },
    pageSuccess: {
        page: "success"
    }
};


class $ce86999d70e24b03$export$a7fbe9ff12d812bf {
    constructor(rootStore){
        this.activePage = "";
        this.providers = [];
        this.payment = {};
        this.selectedProvider = "";
        this.currentScreen = (0, $8e272ff57971c6ac$export$da3bc2f57520e3c3).pageConsent;
        // currentScreen = {
        //   page: 'success'
        // }
        this.sgncBrand = true;
        this.modalVisible = false;
        this.themeId = "bootz";
        (0, $7fjkP.makeAutoObservable)(this);
        this.rootStore = rootStore;
    }
    setActivePage(activePage) {
        this.activePage = activePage;
        this.changePage(activePage);
    }
    changePage(page) {
        this.currentScreen = {
            page: page
        };
    }
    setProviders(providers) {
        this.providers = providers;
    }
    setPayment(payment) {
        this.payment = payment;
    }
    setSelectProvider(provider) {
        this.selectedProvider = provider;
    }
    setsgncBrand(sgncBrand) {
        this.sgncBrand = sgncBrand;
    }
    setModalVisible(visible) {
        this.modalVisible = visible;
    }
    setThemeId(themeId) {
        this.themeId = themeId;
    }
}
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setActivePage", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "changePage", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setProviders", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setPayment", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setSelectProvider", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setsgncBrand", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setModalVisible", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $7fjkP.action).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setThemeId", null);


class $6a0b0eac07d647c3$export$5b19c597f1926e87 {
    constructor(){
        this.AppState = new (0, $ce86999d70e24b03$export$a7fbe9ff12d812bf)(this);
    }
}
const $6a0b0eac07d647c3$export$8ee67b622d91e484 = new $6a0b0eac07d647c3$export$5b19c597f1926e87();



var $hJwnw = parcelRequire("hJwnw");

var $7fjkP = parcelRequire("7fjkP");

var $hJwnw = parcelRequire("hJwnw");

var $7fjkP = parcelRequire("7fjkP");

var $hJwnw = parcelRequire("hJwnw");
if (!(0, $hJwnw.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $7fjkP.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






var $7fjkP = parcelRequire("7fjkP");
function $b09c9a6feabd9421$export$fb2daceae6f5097a(callback) {
    callback();
}
function $b09c9a6feabd9421$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $b09c9a6feabd9421$export$fb2daceae6f5097a;
    (0, $7fjkP.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $b09c9a6feabd9421$export$13ce1459b9a04b51 = function() {
    return true;
};


var $589f28171f8ba90c$var$deprecatedMessages = [];
function $589f28171f8ba90c$export$be38475be17599d(msg) {
    if (!$589f28171f8ba90c$var$deprecatedMessages.includes(msg)) {
        $589f28171f8ba90c$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $7fjkP = parcelRequire("7fjkP");

var $hJwnw = parcelRequire("hJwnw");

var $7fjkP = parcelRequire("7fjkP");
function $d54431f9be088843$export$ef795f1f307682c7(v) {
    return (0, $7fjkP.getDependencyTree)(v);
}


var $2210f8342103c155$export$e901ba0ffe10ba41 = 10000;
var $2210f8342103c155$export$1ae22ce5a82f26b6 = 10000;
var $2210f8342103c155$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $2210f8342103c155$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $2210f8342103c155$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $2210f8342103c155$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $2210f8342103c155$export$b7a00d372cedeedd;


var $5ef9048bc741f6c6$export$10e8a12fbfd8583c = new (0, $2210f8342103c155$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $57fce153bb7d82b4$var$globalIsUsingStaticRendering = false;
function $57fce153bb7d82b4$export$5d52eaa7c0f24c9e(enable) {
    $57fce153bb7d82b4$var$globalIsUsingStaticRendering = enable;
}
function $57fce153bb7d82b4$export$55979271896d643e() {
    return $57fce153bb7d82b4$var$globalIsUsingStaticRendering;
}


var $4d62ffbebb6f386e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $4d62ffbebb6f386e$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $4d62ffbebb6f386e$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $4d62ffbebb6f386e$var$objectToBeRetainedByReactFactory() {
    return new $4d62ffbebb6f386e$var$ObjectToBeRetainedByReact();
}
function $4d62ffbebb6f386e$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)()) return fn();
    var _a = $4d62ffbebb6f386e$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useState($4d62ffbebb6f386e$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $4d62ffbebb6f386e$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $7fjkP.Reaction)($4d62ffbebb6f386e$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $5ef9048bc741f6c6$export$10e8a12fbfd8583c).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useDebugValue(adm.reaction, (0, $d54431f9be088843$export$ef795f1f307682c7));
    (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useEffect(function() {
        (0, $5ef9048bc741f6c6$export$10e8a12fbfd8583c).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $7fjkP.Reaction)($4d62ffbebb6f386e$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}





var $hJwnw = parcelRequire("hJwnw");


var $7eec34e2bbf7c2a1$var$warnObserverOptionsDeprecated = true;
var $7eec34e2bbf7c2a1$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $7eec34e2bbf7c2a1$var$ReactForwardRefSymbol = $7eec34e2bbf7c2a1$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $hJwnw.forwardRef) === "function" && (0, $hJwnw.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $7eec34e2bbf7c2a1$var$ReactMemoSymbol = $7eec34e2bbf7c2a1$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $hJwnw.memo) === "function" && (0, $hJwnw.memo)(function(props) {
    return null;
})["$$typeof"];
function $7eec34e2bbf7c2a1$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($7eec34e2bbf7c2a1$var$ReactMemoSymbol && baseComponent["$$typeof"] === $7eec34e2bbf7c2a1$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($7eec34e2bbf7c2a1$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $7eec34e2bbf7c2a1$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $4d62ffbebb6f386e$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $hJwnw.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $hJwnw.memo)(observerComponent);
    $7eec34e2bbf7c2a1$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $7eec34e2bbf7c2a1$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $7eec34e2bbf7c2a1$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$7eec34e2bbf7c2a1$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $ff3e86dda4e11099$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $4d62ffbebb6f386e$export$b9c7ecd090a87b14)(component);
}
$ff3e86dda4e11099$export$c1cbdee04e18ea8b.displayName = "Observer";
function $ff3e86dda4e11099$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $7fjkP = parcelRequire("7fjkP");

var $hJwnw = parcelRequire("hJwnw");
function $2d0f9c1cac2091c2$export$aa207039f277c5f(initializer, annotations) {
    return (0, $hJwnw.useState)(function() {
        return (0, $7fjkP.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $7fjkP = parcelRequire("7fjkP");

var $hJwnw = parcelRequire("hJwnw");



var $7fjkP = parcelRequire("7fjkP");

var $hJwnw = parcelRequire("hJwnw");
var $18b98c593583ac55$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $18b98c593583ac55$export$e0ded3646391939c(current) {
    var _a = $18b98c593583ac55$var$__read((0, $hJwnw.useState)(function() {
        return (0, $7fjkP.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $7fjkP.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $aa6264bbbfc077aa$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $18b98c593583ac55$export$e0ded3646391939c)(current);
    return (0, $hJwnw.useState)(function() {
        return (0, $7fjkP.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $7b9abd83d0e7c592$var$_a;
(0, $b09c9a6feabd9421$export$294943bbc3c74f4f)((0, $a7721eb599d74a7a$exports.unstable_batchedUpdates));
var $7b9abd83d0e7c592$export$469d51fb8d268227 = ($7b9abd83d0e7c592$var$_a = (0, $5ef9048bc741f6c6$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $7b9abd83d0e7c592$var$_a !== void 0 ? $7b9abd83d0e7c592$var$_a : function() {};
function $7b9abd83d0e7c592$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $4d62ffbebb6f386e$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $7b9abd83d0e7c592$export$7613124ee4202834(enable) {
    (0, $57fce153bb7d82b4$export$5d52eaa7c0f24c9e)(enable);
}


var $b9e73c0b2a621f3b$var$symbolId = 0;
function $b9e73c0b2a621f3b$var$createSymbol(name) {
    if (typeof Symbol === "function") return Symbol(name);
    var symbol = "__$mobx-react " + name + " (" + $b9e73c0b2a621f3b$var$symbolId + ")";
    $b9e73c0b2a621f3b$var$symbolId++;
    return symbol;
}
var $b9e73c0b2a621f3b$var$createdSymbols = {};
function $b9e73c0b2a621f3b$var$newSymbol(name) {
    if (!$b9e73c0b2a621f3b$var$createdSymbols[name]) $b9e73c0b2a621f3b$var$createdSymbols[name] = $b9e73c0b2a621f3b$var$createSymbol(name);
    return $b9e73c0b2a621f3b$var$createdSymbols[name];
}
function $b9e73c0b2a621f3b$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($b9e73c0b2a621f3b$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$b9e73c0b2a621f3b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $b9e73c0b2a621f3b$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
} // based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $b9e73c0b2a621f3b$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    propTypes: 1
};
function $b9e73c0b2a621f3b$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$b9e73c0b2a621f3b$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */ function $b9e73c0b2a621f3b$var$setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty.call(target, prop)) Object.defineProperty(target, prop, {
        enumerable: false,
        configurable: true,
        writable: true,
        value: value
    });
    else target[prop] = value;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $b9e73c0b2a621f3b$var$mobxMixins = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("patchMixins");
var $b9e73c0b2a621f3b$var$mobxPatchedDefinition = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("patchedDefinition");
function $b9e73c0b2a621f3b$var$getMixins(target, methodName) {
    var mixins = target[$b9e73c0b2a621f3b$var$mobxMixins] = target[$b9e73c0b2a621f3b$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $b9e73c0b2a621f3b$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $b9e73c0b2a621f3b$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $b9e73c0b2a621f3b$var$wrapper.call.apply($b9e73c0b2a621f3b$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $b9e73c0b2a621f3b$var$patch(target, methodName, mixinMethod) {
    var mixins = $b9e73c0b2a621f3b$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$b9e73c0b2a621f3b$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $b9e73c0b2a621f3b$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $b9e73c0b2a621f3b$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $b9e73c0b2a621f3b$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$b9e73c0b2a621f3b$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $b9e73c0b2a621f3b$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $b9e73c0b2a621f3b$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $b9e73c0b2a621f3b$var$mobxAdminProperty = (0, $7fjkP.$mobx) || "$mobx";
var $b9e73c0b2a621f3b$var$mobxObserverProperty = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("isMobXReactObserver");
var $b9e73c0b2a621f3b$var$mobxIsUnmounted = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("isUnmounted");
var $b9e73c0b2a621f3b$var$skipRenderKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("skipRender");
var $b9e73c0b2a621f3b$var$isForcingUpdateKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("isForcingUpdate");
function $b9e73c0b2a621f3b$var$makeClassComponentObserver(componentClass) {
    var target = componentClass.prototype;
    if (componentClass[$b9e73c0b2a621f3b$var$mobxObserverProperty]) {
        var displayName = $b9e73c0b2a621f3b$var$getDisplayName(target);
        console.warn("The provided component class (" + displayName + ") \n                has already been declared as an observer component.");
    } else componentClass[$b9e73c0b2a621f3b$var$mobxObserverProperty] = true;
    if (target.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $hJwnw.PureComponent)) {
        if (!target.shouldComponentUpdate) target.shouldComponentUpdate = $b9e73c0b2a621f3b$var$observerSCU;
        else if (target.shouldComponentUpdate !== $b9e73c0b2a621f3b$var$observerSCU) throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    } // this.props and this.state are made observable, just to make sure @computed fields that
    // are defined inside the component, and which rely on state or props, re-compute if state or props change
    // (otherwise the computed wouldn't update and become stale on props change, since props are not observable)
    // However, this solution is not without it's own problems: https://github.com/mobxjs/mobx-react/issues?utf8=%E2%9C%93&q=is%3Aissue+label%3Aobservable-props-or-not+
    $b9e73c0b2a621f3b$var$makeObservableProp(target, "props");
    $b9e73c0b2a621f3b$var$makeObservableProp(target, "state");
    var baseRender = target.render;
    target.render = function() {
        return $b9e73c0b2a621f3b$var$makeComponentReactive.call(this, baseRender);
    };
    $b9e73c0b2a621f3b$var$patch(target, "componentWillUnmount", function() {
        var _this$render$mobxAdmi;
        if ((0, $57fce153bb7d82b4$export$55979271896d643e)() === true) return;
        (_this$render$mobxAdmi = this.render[$b9e73c0b2a621f3b$var$mobxAdminProperty]) == null || _this$render$mobxAdmi.dispose();
        this[$b9e73c0b2a621f3b$var$mobxIsUnmounted] = true;
        if (!this.render[$b9e73c0b2a621f3b$var$mobxAdminProperty]) {
            // Render may have been hot-swapped and/or overriden by a subclass.
            var _displayName = $b9e73c0b2a621f3b$var$getDisplayName(this);
            console.warn("The reactive render of an observer class component (" + _displayName + ") \n                was overriden after MobX attached. This may result in a memory leak if the \n                overriden reactive render was not properly disposed.");
        }
    });
    return componentClass;
} // Generates a friendly name for debugging
function $b9e73c0b2a621f3b$var$getDisplayName(comp) {
    return comp.displayName || comp.name || comp.constructor && (comp.constructor.displayName || comp.constructor.name) || "<component>";
}
function $b9e73c0b2a621f3b$var$makeComponentReactive(render) {
    var _this = this;
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)() === true) return render.call(this);
    /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */ $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$skipRenderKey, false);
    /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */ $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$isForcingUpdateKey, false);
    var initialName = $b9e73c0b2a621f3b$var$getDisplayName(this);
    var baseRender = render.bind(this);
    var isRenderingPending = false;
    var reaction = new (0, $7fjkP.Reaction)(initialName + ".render()", function() {
        if (!isRenderingPending) {
            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
            // See #85 / Pull #44
            isRenderingPending = true;
            if (_this[$b9e73c0b2a621f3b$var$mobxIsUnmounted] !== true) {
                var hasError = true;
                try {
                    $b9e73c0b2a621f3b$var$setHiddenProp(_this, $b9e73c0b2a621f3b$var$isForcingUpdateKey, true);
                    if (!_this[$b9e73c0b2a621f3b$var$skipRenderKey]) (0, $hJwnw.Component).prototype.forceUpdate.call(_this);
                    hasError = false;
                } finally{
                    $b9e73c0b2a621f3b$var$setHiddenProp(_this, $b9e73c0b2a621f3b$var$isForcingUpdateKey, false);
                    if (hasError) reaction.dispose();
                }
            }
        }
    });
    reaction["reactComponent"] = this;
    reactiveRender[$b9e73c0b2a621f3b$var$mobxAdminProperty] = reaction;
    this.render = reactiveRender;
    function reactiveRender() {
        isRenderingPending = false;
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function() {
            try {
                rendering = (0, $7fjkP._allowStateChanges)(false, baseRender);
            } catch (e) {
                exception = e;
            }
        });
        if (exception) throw exception;
        return rendering;
    }
    return reactiveRender.call(this);
}
function $b9e73c0b2a621f3b$var$observerSCU(nextProps, nextState) {
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
     // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
     // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$b9e73c0b2a621f3b$var$shallowEqual(this.props, nextProps);
}
function $b9e73c0b2a621f3b$var$makeObservableProp(target, propName) {
    var valueHolderKey = $b9e73c0b2a621f3b$var$newSymbol("reactProp_" + propName + "_valueHolder");
    var atomHolderKey = $b9e73c0b2a621f3b$var$newSymbol("reactProp_" + propName + "_atomHolder");
    function getAtom() {
        if (!this[atomHolderKey]) $b9e73c0b2a621f3b$var$setHiddenProp(this, atomHolderKey, (0, $7fjkP.createAtom)("reactive " + propName));
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var prevReadState = false;
            if ((0, $7fjkP._allowStateReadsStart) && (0, $7fjkP._allowStateReadsEnd)) prevReadState = (0, $7fjkP._allowStateReadsStart)(true);
            getAtom.call(this).reportObserved();
            if ((0, $7fjkP._allowStateReadsStart) && (0, $7fjkP._allowStateReadsEnd)) (0, $7fjkP._allowStateReadsEnd)(prevReadState);
            return this[valueHolderKey];
        },
        set: function set(v) {
            if (!this[$b9e73c0b2a621f3b$var$isForcingUpdateKey] && !$b9e73c0b2a621f3b$var$shallowEqual(this[valueHolderKey], v)) {
                $b9e73c0b2a621f3b$var$setHiddenProp(this, valueHolderKey, v);
                $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$skipRenderKey, true);
                getAtom.call(this).reportChanged();
                $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$skipRenderKey, false);
            } else $b9e73c0b2a621f3b$var$setHiddenProp(this, valueHolderKey, v);
        }
    });
}
var $b9e73c0b2a621f3b$var$hasSymbol = typeof Symbol === "function" && Symbol["for"]; // Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $b9e73c0b2a621f3b$var$ReactForwardRefSymbol = $b9e73c0b2a621f3b$var$hasSymbol ? /*#__PURE__*/ Symbol["for"]("react.forward_ref") : typeof (0, $hJwnw.forwardRef) === "function" && /*#__PURE__*/ (0, $hJwnw.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $b9e73c0b2a621f3b$var$ReactMemoSymbol = $b9e73c0b2a621f3b$var$hasSymbol ? /*#__PURE__*/ Symbol["for"]("react.memo") : typeof (0, $hJwnw.memo) === "function" && /*#__PURE__*/ (0, $hJwnw.memo)(function(props) {
    return null;
})["$$typeof"];
/**
 * Observer function / decorator
 */ function $b9e73c0b2a621f3b$export$b6ae1bc530f4c149(component) {
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    if ($b9e73c0b2a621f3b$var$ReactMemoSymbol && component["$$typeof"] === $b9e73c0b2a621f3b$var$ReactMemoSymbol) throw new Error("Mobx observer: You are trying to use 'observer' on a function component wrapped in either another observer or 'React.memo'. The observer already applies 'React.memo' for you.");
     // Unwrap forward refs into `<Observer>` component
    // we need to unwrap the render, because it is the inner render that needs to be tracked,
    // not the ForwardRef HoC
    if ($b9e73c0b2a621f3b$var$ReactForwardRefSymbol && component["$$typeof"] === $b9e73c0b2a621f3b$var$ReactForwardRefSymbol) {
        var baseRender = component["render"];
        if (typeof baseRender !== "function") throw new Error("render property of ForwardRef was not a function");
        return (0, $hJwnw.forwardRef)(function ObserverForwardRef() {
            var args = arguments;
            return (0, $hJwnw.createElement)((0, $ff3e86dda4e11099$export$c1cbdee04e18ea8b), null, function() {
                return baseRender.apply(undefined, args);
            });
        });
    } // Function component
    if (typeof component === "function" && (!component.prototype || !component.prototype.render) && !component["isReactClass"] && !Object.prototype.isPrototypeOf.call((0, $hJwnw.Component), component)) return (0, $7eec34e2bbf7c2a1$export$b6ae1bc530f4c149)(component);
    return $b9e73c0b2a621f3b$var$makeClassComponentObserver(component);
}
function $b9e73c0b2a621f3b$var$_extends() {
    $b9e73c0b2a621f3b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9e73c0b2a621f3b$var$_extends.apply(this, arguments);
}
function $b9e73c0b2a621f3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b9e73c0b2a621f3b$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createContext({});
function $b9e73c0b2a621f3b$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $b9e73c0b2a621f3b$var$_objectWithoutPropertiesLoose(props, [
        "children"
    ]);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($b9e73c0b2a621f3b$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useRef($b9e73c0b2a621f3b$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($b9e73c0b2a621f3b$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$b9e73c0b2a621f3b$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $b9e73c0b2a621f3b$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).forwardRef(function(props, ref) {
        var newProps = $b9e73c0b2a621f3b$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($b9e73c0b2a621f3b$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $b9e73c0b2a621f3b$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $b9e73c0b2a621f3b$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $b9e73c0b2a621f3b$var$getInjectName(component, injectNames);
    return Injector;
}
function $b9e73c0b2a621f3b$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $b9e73c0b2a621f3b$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $b9e73c0b2a621f3b$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $b9e73c0b2a621f3b$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $b9e73c0b2a621f3b$var$createStoreInjector($b9e73c0b2a621f3b$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $b9e73c0b2a621f3b$var$protoStoreKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("disposeOnUnmountProto");
var $b9e73c0b2a621f3b$var$instStoreKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("disposeOnUnmountInst");
function $b9e73c0b2a621f3b$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$b9e73c0b2a621f3b$var$protoStoreKey] || [], this[$b9e73c0b2a621f3b$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
function $b9e73c0b2a621f3b$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $b9e73c0b2a621f3b$export$4e749cb731da87a9(target, fn);
    });
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor); // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
     // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string"; // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$b9e73c0b2a621f3b$var$protoStoreKey] || !!target[$b9e73c0b2a621f3b$var$instStoreKey];
    var store = isDecorator ? target[$b9e73c0b2a621f3b$var$protoStoreKey] || (target[$b9e73c0b2a621f3b$var$protoStoreKey] = []) : target[$b9e73c0b2a621f3b$var$instStoreKey] || (target[$b9e73c0b2a621f3b$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $b9e73c0b2a621f3b$var$patch(target, "componentWillUnmount", $b9e73c0b2a621f3b$var$runDisposersOnWillUnmount);
     // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
function $b9e73c0b2a621f3b$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $7fjkP.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false); // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
} // Copied from React.PropTypes
function $b9e73c0b2a621f3b$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
     // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
     // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
} // Copied from React.PropTypes
function $b9e73c0b2a621f3b$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($b9e73c0b2a621f3b$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $b9e73c0b2a621f3b$var$getPreciseType(propValue) {
    var propType = $b9e73c0b2a621f3b$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $b9e73c0b2a621f3b$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $7fjkP.untracked)(function() {
            if (allowNativeType) {
                if ($b9e73c0b2a621f3b$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $7fjkP.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $7fjkP.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $7fjkP.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $b9e73c0b2a621f3b$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $b9e73c0b2a621f3b$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $b9e73c0b2a621f3b$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $7fjkP.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $b9e73c0b2a621f3b$var$observableArray = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(false, "Array");
var $b9e73c0b2a621f3b$var$observableArrayOf = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableArrayOfTypeChecker.bind(null, false);
var $b9e73c0b2a621f3b$var$observableMap = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(false, "Map");
var $b9e73c0b2a621f3b$var$observableObject = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(false, "Object");
var $b9e73c0b2a621f3b$var$arrayOrObservableArray = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(true, "Array");
var $b9e73c0b2a621f3b$var$arrayOrObservableArrayOf = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableArrayOfTypeChecker.bind(null, true);
var $b9e73c0b2a621f3b$var$objectOrObservableObject = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(true, "Object");
var $b9e73c0b2a621f3b$export$e0c95a451cd220b7 = {
    observableArray: $b9e73c0b2a621f3b$var$observableArray,
    observableArrayOf: $b9e73c0b2a621f3b$var$observableArrayOf,
    observableMap: $b9e73c0b2a621f3b$var$observableMap,
    observableObject: $b9e73c0b2a621f3b$var$observableObject,
    arrayOrObservableArray: $b9e73c0b2a621f3b$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $b9e73c0b2a621f3b$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $b9e73c0b2a621f3b$var$objectOrObservableObject
};
if (!(0, $hJwnw.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $7fjkP.observable)) throw new Error("mobx-react requires mobx to be available");



var $hJwnw = parcelRequire("hJwnw");

var $dsaRL = parcelRequire("dsaRL");
var $6e7797ab6282f7ea$exports = {};
$6e7797ab6282f7ea$exports = JSON.parse('{"title":"Verification","providers":{"header":"Confirm Your Identity","listHeader":"Choose your digital ID","missingProvider":"I do not see my Digital ID Provider"},"consent":{"shareInfo":"You are about to pay:","amount":"Amount:","notShareInfo":"You are <u>not</u> sharing the following data:","consentConfirm":"Approve","consentDeny":"Decline","firstAndLastName":"First and last name","firstNameInitials":"First name initials","lastName":"Last name","lastNamePrefix":"Last name prefix","firstName":"First name","dateOfBirth":"Date of Birth","emailAddress":"E-mail address","phoneNumber":"Phone number","gender":"Gender","finishId":"Finnish personal identification numbers (HETU)."},"bankSelection":{"header":"Choose your bank","ftnHeader":"Choose your method","description":"Log in to your bank with iDIN and verify your identity","descriptionFtn":"By selecting an ID provider in the list, I accept that Signicat transfers my personal data (personal identification code, name) to the service provider.","descriptionFtnLink":"Identification principles","cancel":"Back","continue":"Next"},"error":{"title":"Error","description":"Unfortunately, you cannot continue the process because of an error."},"modal":{"header":"Do you want to decline?","desc":"Please choose one option:","continue":"Continue","cancel":"Cancel"}}');


var $8cfb8e505e51d4b0$exports = {};
$8cfb8e505e51d4b0$exports = JSON.parse('{"title":"Verification","providers":{"header":"Bevestig je identiteit","listHeader":"Kies uw digitale id-provider","missingProvider":"I do not see my Digital ID Provider"},"consent":{"shareInfo":"Je staat op het punt de volgende gegevens te delen met Visa","notShareInfo":"Je deelt de volgende gegevens <u>niet</u>","consentConfirm":"Ik stem ermee in","consentDeny":"Ik geef geen toestemming","firstAndLastName":"First and last name","firstNameInitials":"Initialen","lastName":"Achternaam","lastNamePrefix":"Tussenvoegsel(s)","firstName":"Voornaam","dateOfBirth":"Geboortedatum","emailAddress":"E-mail addres","phoneNumber":"Telefoonnummer","gender":"Geslacht"},"bankSelection":{"header":"Kies je bank","ftnHeader":"Kies je methode","description":"Log in bij uw bank met iDIN en verifieer uw identiteit","descriptionFtn":"By selecting an ID provider in the list, I accept that Signicat transfers my personal data (personal identification code, name) to the service provider.","descriptionFtnLink":"Identification principles","cancel":"Annuleren","continue":"Doorgaan"},"error":{"title":"Fout","description":"Helaas kun je het proces niet vervolgen in verband met een fout"}}');


var $4fbb3ecb94dca8c8$exports = {};
$4fbb3ecb94dca8c8$exports = JSON.parse('{"title":"Verification","providers":{"header":"Vahvista henkil\xf6llisyytesi","listHeader":"Valitse tunnistustapa","missingProvider":"I do not see my Digital ID Provider"},"consent":{"shareInfo":"Olet jakamassa seuraavat tiedot Visa in kanssa","notShareInfo":"Et jaa seuraavia tietoja","consentConfirm":"Hyv\xe4ksyn","consentDeny":"En hyv\xe4ksy","firstAndLastName":"First and last name","firstNameInitials":"Etunimien nimikirjaimet","lastName":"Sukunimi","lastNamePrefix":"Last name prefix","firstName":"Etunimi","dateOfBirth":"Syntym\xe4aika","emailAddress":"S\xe4hk\xf6postiosoite","phoneNumber":"Puhelinnumero","gender":"Sukupuoli","finishId":"HETU"},"bankSelection":{"header":"Valitse pankkisi tai Mobiilivarmenne","ftnHeader":"Valitse tunnistustapa","description":"Kirjaudu omilla tunnuksillasi ja vahvista henkil\xf6llisyytesi","descriptionFtn":"Valitsemalla tunnistuksen toteuttajan allaolevasta valikosta (pankki tai mobiilivarmenne) hyv\xe4ksyn sen, ett\xe4 Signicat tunnistusv\xe4lityspalvelu v\xe4litt\xe4\xe4 tunnistusta varten henkil\xf6tietoni (hetu, nimi) pankilta tai mobiilivarmenteen tarjoajalta palvelun tarjoamista varten.","descriptionFtnLink":"Tunnistusperiaatteet","cancel":"Peruuta","continue":"Jatka"},"error":{"title":"Tapahtui virhe","description":"Valitettavasti et voi jatkaa toimintoa virheen takia"}}');


var $d8f34b09a79ac39a$exports = {};
var $4b1acad0d17392c1$exports = {};
var $1ce8ca38444e95ba$exports = {};
function $1ce8ca38444e95ba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1ce8ca38444e95ba$exports = $1ce8ca38444e95ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1ce8ca38444e95ba$exports.__esModule = true, $1ce8ca38444e95ba$exports["default"] = $1ce8ca38444e95ba$exports, $1ce8ca38444e95ba$var$_typeof(obj);
}
$1ce8ca38444e95ba$exports = $1ce8ca38444e95ba$var$_typeof, $1ce8ca38444e95ba$exports.__esModule = true, $1ce8ca38444e95ba$exports["default"] = $1ce8ca38444e95ba$exports;


var $4b1acad0d17392c1$var$_typeof = $1ce8ca38444e95ba$exports.default;
var $dde72cbed0ab12ee$exports = {};

var $dde72cbed0ab12ee$var$_typeof = $1ce8ca38444e95ba$exports.default;
function $dde72cbed0ab12ee$var$_toPrimitive(input, hint) {
    if ($dde72cbed0ab12ee$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dde72cbed0ab12ee$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$dde72cbed0ab12ee$exports = $dde72cbed0ab12ee$var$_toPrimitive, $dde72cbed0ab12ee$exports.__esModule = true, $dde72cbed0ab12ee$exports["default"] = $dde72cbed0ab12ee$exports;


function $4b1acad0d17392c1$var$_toPropertyKey(arg) {
    var key = $dde72cbed0ab12ee$exports(arg, "string");
    return $4b1acad0d17392c1$var$_typeof(key) === "symbol" ? key : String(key);
}
$4b1acad0d17392c1$exports = $4b1acad0d17392c1$var$_toPropertyKey, $4b1acad0d17392c1$exports.__esModule = true, $4b1acad0d17392c1$exports["default"] = $4b1acad0d17392c1$exports;


function $d8f34b09a79ac39a$var$_defineProperty(obj, key, value) {
    key = $4b1acad0d17392c1$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$d8f34b09a79ac39a$exports = $d8f34b09a79ac39a$var$_defineProperty, $d8f34b09a79ac39a$exports.__esModule = true, $d8f34b09a79ac39a$exports["default"] = $d8f34b09a79ac39a$exports;


var $b03fc5ebc4cad8d7$exports = {};
var $eed655b0e5d9a64a$exports = {};
function $eed655b0e5d9a64a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$eed655b0e5d9a64a$exports = $eed655b0e5d9a64a$var$_objectWithoutPropertiesLoose, $eed655b0e5d9a64a$exports.__esModule = true, $eed655b0e5d9a64a$exports["default"] = $eed655b0e5d9a64a$exports;


function $b03fc5ebc4cad8d7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eed655b0e5d9a64a$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$b03fc5ebc4cad8d7$exports = $b03fc5ebc4cad8d7$var$_objectWithoutProperties, $b03fc5ebc4cad8d7$exports.__esModule = true, $b03fc5ebc4cad8d7$exports["default"] = $b03fc5ebc4cad8d7$exports;



var $hJwnw = parcelRequire("hJwnw");




var $hJwnw = parcelRequire("hJwnw");
var $c9d92f60da36e266$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $c9d92f60da36e266$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $5d1e4a81fb434ade$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $5d1e4a81fb434ade$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($c9d92f60da36e266$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($5d1e4a81fb434ade$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $5d1e4a81fb434ade$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $5d1e4a81fb434ade$var$i = /^\s*$/, $5d1e4a81fb434ade$var$s = Object.create(null);
function $5d1e4a81fb434ade$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($5d1e4a81fb434ade$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $5d1e4a81fb434ade$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $5d1e4a81fb434ade$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($5d1e4a81fb434ade$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $5d1e4a81fb434ade$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $5d1e4a81fb434ade$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $5d1e4a81fb434ade$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $5d1e4a81fb434ade$var$a("", t);
        }, "");
    }
};
var $5d1e4a81fb434ade$export$2e2bcd8739ae039 = $5d1e4a81fb434ade$var$c;


function $351d3fce2412dde7$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $351d3fce2412dde7$var$alreadyWarned = {};
function $351d3fce2412dde7$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $351d3fce2412dde7$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $351d3fce2412dde7$var$alreadyWarned[args[0]] = new Date();
    $351d3fce2412dde7$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $351d3fce2412dde7$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $351d3fce2412dde7$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $351d3fce2412dde7$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $351d3fce2412dde7$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $351d3fce2412dde7$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $351d3fce2412dde7$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}



var $6322c9b322fc8401$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $6322c9b322fc8401$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $6322c9b322fc8401$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $6322c9b322fc8401$var$htmlEntities[m];
};
var $6322c9b322fc8401$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($6322c9b322fc8401$var$matchHtmlEntity, $6322c9b322fc8401$var$unescapeHtmlEntity);
};


function $ab42eb87c36f8e59$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ab42eb87c36f8e59$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ab42eb87c36f8e59$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ab42eb87c36f8e59$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ab42eb87c36f8e59$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $6322c9b322fc8401$export$e8bacd2802a88316)
};
function $ab42eb87c36f8e59$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $ab42eb87c36f8e59$var$defaultOptions = $ab42eb87c36f8e59$var$_objectSpread($ab42eb87c36f8e59$var$_objectSpread({}, $ab42eb87c36f8e59$var$defaultOptions), options);
}
function $ab42eb87c36f8e59$export$212bb2fc580a90a8() {
    return $ab42eb87c36f8e59$var$defaultOptions;
}


var $47fae79ddf0d4a65$var$i18nInstance;
function $47fae79ddf0d4a65$export$a039134f2fc7e0(instance) {
    $47fae79ddf0d4a65$var$i18nInstance = instance;
}
function $47fae79ddf0d4a65$export$64af334f494c2f47() {
    return $47fae79ddf0d4a65$var$i18nInstance;
}


var $a44a82a6d2e956e1$var$_excluded = [
    "format"
], $a44a82a6d2e956e1$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $a44a82a6d2e956e1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a44a82a6d2e956e1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a44a82a6d2e956e1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a44a82a6d2e956e1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a44a82a6d2e956e1$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $a44a82a6d2e956e1$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $a44a82a6d2e956e1$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $hJwnw.isValidElement)(child);
    });
}
function $a44a82a6d2e956e1$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $a44a82a6d2e956e1$var$mergeProps(source, target) {
    var newTarget = $a44a82a6d2e956e1$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $a44a82a6d2e956e1$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $a44a82a6d2e956e1$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $hJwnw.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $a44a82a6d2e956e1$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $351d3fce2412dde7$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($1ce8ca38444e95ba$exports)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($b03fc5ebc4cad8d7$exports)))(child, $a44a82a6d2e956e1$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $351d3fce2412dde7$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $351d3fce2412dde7$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $a44a82a6d2e956e1$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $a44a82a6d2e956e1$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($a44a82a6d2e956e1$var$hasChildren(child)) getData($a44a82a6d2e956e1$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($1ce8ca38444e95ba$exports)))(child) === "object" && !(0, $hJwnw.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $5d1e4a81fb434ade$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $a44a82a6d2e956e1$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $a44a82a6d2e956e1$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $hJwnw.cloneElement)(child, $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $a44a82a6d2e956e1$var$getAsArray(reactNode);
        var astNodes = $a44a82a6d2e956e1$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $a44a82a6d2e956e1$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $hJwnw.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $a44a82a6d2e956e1$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($1ce8ca38444e95ba$exports)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($1ce8ca38444e95ba$exports)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($a44a82a6d2e956e1$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $hJwnw.cloneElement)(child, $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $hJwnw.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $hJwnw.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($1ce8ca38444e95ba$exports)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $hJwnw.cloneElement)(child, $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $hJwnw.cloneElement)(child, $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $hJwnw.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $a44a82a6d2e956e1$var$getAsArray(children || []));
    return $a44a82a6d2e956e1$var$getChildren(result[0]);
}
function $a44a82a6d2e956e1$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($b03fc5ebc4cad8d7$exports)))(_ref, $a44a82a6d2e956e1$var$_excluded2);
    var i18n = i18nFromProps || (0, $47fae79ddf0d4a65$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $351d3fce2412dde7$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, (0, $ab42eb87c36f8e59$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $a44a82a6d2e956e1$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread($a44a82a6d2e956e1$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $a44a82a6d2e956e1$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $hJwnw.createElement)(useAsParent, additionalProps, content) : content;
}



var $11fd14be30727a5f$exports = {};
function $11fd14be30727a5f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$11fd14be30727a5f$exports = $11fd14be30727a5f$var$_classCallCheck, $11fd14be30727a5f$exports.__esModule = true, $11fd14be30727a5f$exports["default"] = $11fd14be30727a5f$exports;


var $6f35b439cd2328e1$exports = {};

function $6f35b439cd2328e1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4b1acad0d17392c1$exports(descriptor.key), descriptor);
    }
}
function $6f35b439cd2328e1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6f35b439cd2328e1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6f35b439cd2328e1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$6f35b439cd2328e1$exports = $6f35b439cd2328e1$var$_createClass, $6f35b439cd2328e1$exports.__esModule = true, $6f35b439cd2328e1$exports["default"] = $6f35b439cd2328e1$exports;



var $hJwnw = parcelRequire("hJwnw");




var $f09823ff1610ac3d$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $ab42eb87c36f8e59$export$2e2366488d12e20d)(instance.options.react);
        (0, $47fae79ddf0d4a65$export$a039134f2fc7e0)(instance);
    }
};


function $4c921b65fff95c60$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4c921b65fff95c60$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4c921b65fff95c60$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4c921b65fff95c60$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4c921b65fff95c60$export$5603ab5ced17ce64 = (0, $hJwnw.createContext)();
var $4c921b65fff95c60$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($11fd14be30727a5f$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6f35b439cd2328e1$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $4c921b65fff95c60$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $4c921b65fff95c60$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($4c921b65fff95c60$var$_objectSpread($4c921b65fff95c60$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $4c921b65fff95c60$export$704200e5d0b9e8f() {
    var i18n = (0, $47fae79ddf0d4a65$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $7ac3cb44e18fd6f3$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $7ac3cb44e18fd6f3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7ac3cb44e18fd6f3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7ac3cb44e18fd6f3$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7ac3cb44e18fd6f3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7ac3cb44e18fd6f3$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($b03fc5ebc4cad8d7$exports)))(_ref, $7ac3cb44e18fd6f3$var$_excluded);
    var _ref2 = (0, $hJwnw.useContext)((0, $4c921b65fff95c60$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $47fae79ddf0d4a65$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $a44a82a6d2e956e1$export$8d6a9236f2e3f2ce)($7ac3cb44e18fd6f3$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}



var $aaf078b464693cd5$exports = {};
var $ac6267b3aec9f508$exports = {};
function $ac6267b3aec9f508$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$ac6267b3aec9f508$exports = $ac6267b3aec9f508$var$_arrayWithHoles, $ac6267b3aec9f508$exports.__esModule = true, $ac6267b3aec9f508$exports["default"] = $ac6267b3aec9f508$exports;


var $f2b72a245f92163f$exports = {};
function $f2b72a245f92163f$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$f2b72a245f92163f$exports = $f2b72a245f92163f$var$_iterableToArrayLimit, $f2b72a245f92163f$exports.__esModule = true, $f2b72a245f92163f$exports["default"] = $f2b72a245f92163f$exports;


var $bcd3142b072b2172$exports = {};
var $f310b7a288e750a9$exports = {};
function $f310b7a288e750a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$f310b7a288e750a9$exports = $f310b7a288e750a9$var$_arrayLikeToArray, $f310b7a288e750a9$exports.__esModule = true, $f310b7a288e750a9$exports["default"] = $f310b7a288e750a9$exports;


function $bcd3142b072b2172$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f310b7a288e750a9$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f310b7a288e750a9$exports(o, minLen);
}
$bcd3142b072b2172$exports = $bcd3142b072b2172$var$_unsupportedIterableToArray, $bcd3142b072b2172$exports.__esModule = true, $bcd3142b072b2172$exports["default"] = $bcd3142b072b2172$exports;


var $9279a2ed3747bcb2$exports = {};
function $9279a2ed3747bcb2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9279a2ed3747bcb2$exports = $9279a2ed3747bcb2$var$_nonIterableRest, $9279a2ed3747bcb2$exports.__esModule = true, $9279a2ed3747bcb2$exports["default"] = $9279a2ed3747bcb2$exports;


function $aaf078b464693cd5$var$_slicedToArray(arr, i) {
    return $ac6267b3aec9f508$exports(arr) || $f2b72a245f92163f$exports(arr, i) || $bcd3142b072b2172$exports(arr, i) || $9279a2ed3747bcb2$exports();
}
$aaf078b464693cd5$exports = $aaf078b464693cd5$var$_slicedToArray, $aaf078b464693cd5$exports.__esModule = true, $aaf078b464693cd5$exports["default"] = $aaf078b464693cd5$exports;





var $hJwnw = parcelRequire("hJwnw");


function $264e5bf5cf964d1b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $264e5bf5cf964d1b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $264e5bf5cf964d1b$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $264e5bf5cf964d1b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $264e5bf5cf964d1b$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $hJwnw.useRef)();
    (0, $hJwnw.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $264e5bf5cf964d1b$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $hJwnw.useContext)((0, $4c921b65fff95c60$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $47fae79ddf0d4a65$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $4c921b65fff95c60$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $351d3fce2412dde7$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, (/*@__PURE__*/$parcel$interopDefault($1ce8ca38444e95ba$exports)))(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $351d3fce2412dde7$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $264e5bf5cf964d1b$var$_objectSpread($264e5bf5cf964d1b$var$_objectSpread($264e5bf5cf964d1b$var$_objectSpread({}, (0, $ab42eb87c36f8e59$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $351d3fce2412dde7$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $hJwnw.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($aaf078b464693cd5$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $264e5bf5cf964d1b$var$usePrevious(joinedNS);
    var isMounted = (0, $hJwnw.useRef)(true);
    (0, $hJwnw.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $351d3fce2412dde7$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $hJwnw.useRef)(true);
    (0, $hJwnw.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $351d3fce2412dde7$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}






var $hJwnw = parcelRequire("hJwnw");


var $6864e501f3ec1e98$var$_excluded = [
    "forwardedRef"
];
function $6864e501f3ec1e98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6864e501f3ec1e98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6864e501f3ec1e98$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6864e501f3ec1e98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6864e501f3ec1e98$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($b03fc5ebc4cad8d7$exports)))(_ref, $6864e501f3ec1e98$var$_excluded);
            var _useTranslation = (0, $264e5bf5cf964d1b$export$9fc83ad70ead8663)(ns, $6864e501f3ec1e98$var$_objectSpread($6864e501f3ec1e98$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($aaf078b464693cd5$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $6864e501f3ec1e98$var$_objectSpread($6864e501f3ec1e98$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $hJwnw.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $351d3fce2412dde7$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $hJwnw.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $hJwnw.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $c0aa87f53ad27453$var$_excluded = [
    "ns",
    "children"
];
function $c0aa87f53ad27453$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, (/*@__PURE__*/$parcel$interopDefault($b03fc5ebc4cad8d7$exports)))(props, $c0aa87f53ad27453$var$_excluded);
    var _useTranslation = (0, $264e5bf5cf964d1b$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($aaf078b464693cd5$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $hJwnw = parcelRequire("hJwnw");

function $ac0eba742e6e198d$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $hJwnw.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $hJwnw.createElement)((0, $4c921b65fff95c60$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $hJwnw = parcelRequire("hJwnw");

var $hJwnw = parcelRequire("hJwnw");

function $634cc3da723dee96$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $hJwnw.useContext)((0, $4c921b65fff95c60$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $47fae79ddf0d4a65$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $f3be6a7a75246c9f$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $f3be6a7a75246c9f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f3be6a7a75246c9f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f3be6a7a75246c9f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d8f34b09a79ac39a$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f3be6a7a75246c9f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f3be6a7a75246c9f$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, (/*@__PURE__*/$parcel$interopDefault($b03fc5ebc4cad8d7$exports)))(_ref, $f3be6a7a75246c9f$var$_excluded);
            (0, $634cc3da723dee96$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $hJwnw.createElement)(WrappedComponent, $f3be6a7a75246c9f$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $4c921b65fff95c60$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $351d3fce2412dde7$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







var $27b41010dd3f928a$export$324d90190a8b822a = function date() {
    return "";
};
var $27b41010dd3f928a$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $27b41010dd3f928a$export$98e628dec113755e = function number() {
    return "";
};
var $27b41010dd3f928a$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $27b41010dd3f928a$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $27b41010dd3f928a$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};



var $bt6cS = parcelRequire("bt6cS");

var $lxHjm = parcelRequire("lxHjm");
var $938d7bb9dd90e3dc$var$arr = [];
var $938d7bb9dd90e3dc$var$each = $938d7bb9dd90e3dc$var$arr.forEach;
var $938d7bb9dd90e3dc$var$slice = $938d7bb9dd90e3dc$var$arr.slice;
function $938d7bb9dd90e3dc$var$defaults(obj) {
    $938d7bb9dd90e3dc$var$each.call($938d7bb9dd90e3dc$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $938d7bb9dd90e3dc$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $938d7bb9dd90e3dc$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = name + "=" + value;
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$938d7bb9dd90e3dc$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$938d7bb9dd90e3dc$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $938d7bb9dd90e3dc$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $938d7bb9dd90e3dc$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $938d7bb9dd90e3dc$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $938d7bb9dd90e3dc$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $938d7bb9dd90e3dc$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $938d7bb9dd90e3dc$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var query = window.location.search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $938d7bb9dd90e3dc$var$hasLocalStorageSupport = null;
var $938d7bb9dd90e3dc$var$localStorageAvailable = function localStorageAvailable() {
    if ($938d7bb9dd90e3dc$var$hasLocalStorageSupport !== null) return $938d7bb9dd90e3dc$var$hasLocalStorageSupport;
    try {
        $938d7bb9dd90e3dc$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $938d7bb9dd90e3dc$var$hasLocalStorageSupport = false;
    }
    return $938d7bb9dd90e3dc$var$hasLocalStorageSupport;
};
var $938d7bb9dd90e3dc$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $938d7bb9dd90e3dc$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $938d7bb9dd90e3dc$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $938d7bb9dd90e3dc$var$hasSessionStorageSupport = null;
var $938d7bb9dd90e3dc$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($938d7bb9dd90e3dc$var$hasSessionStorageSupport !== null) return $938d7bb9dd90e3dc$var$hasSessionStorageSupport;
    try {
        $938d7bb9dd90e3dc$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $938d7bb9dd90e3dc$var$hasSessionStorageSupport = false;
    }
    return $938d7bb9dd90e3dc$var$hasSessionStorageSupport;
};
var $938d7bb9dd90e3dc$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $938d7bb9dd90e3dc$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $938d7bb9dd90e3dc$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $938d7bb9dd90e3dc$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $938d7bb9dd90e3dc$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $938d7bb9dd90e3dc$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $938d7bb9dd90e3dc$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
            if (language instanceof Array) {
                if (typeof options.lookupFromSubdomainIndex === "number") found = language[options.lookupFromSubdomainIndex].replace("http://", "").replace("https://", "").replace(".", "");
                else found = language[0].replace("http://", "").replace("https://", "").replace(".", "");
            }
        }
        return found;
    }
};
function $938d7bb9dd90e3dc$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] //cookieMinutes: 10,
    };
}
var $938d7bb9dd90e3dc$var$Browser = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bt6cS.default)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $lxHjm.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $938d7bb9dd90e3dc$var$defaults(options, this.options || {}, $938d7bb9dd90e3dc$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($938d7bb9dd90e3dc$var$cookie$1);
                this.addDetector($938d7bb9dd90e3dc$var$querystring);
                this.addDetector($938d7bb9dd90e3dc$var$localStorage);
                this.addDetector($938d7bb9dd90e3dc$var$sessionStorage);
                this.addDetector($938d7bb9dd90e3dc$var$navigator$1);
                this.addDetector($938d7bb9dd90e3dc$var$htmlTag);
                this.addDetector($938d7bb9dd90e3dc$var$path);
                this.addDetector($938d7bb9dd90e3dc$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$938d7bb9dd90e3dc$var$Browser.type = "languageDetector";
var $938d7bb9dd90e3dc$export$2e2bcd8739ae039 = $938d7bb9dd90e3dc$var$Browser;


const $e8b39eddd5f05901$var$detector = new (0, $938d7bb9dd90e3dc$export$2e2bcd8739ae039)();
$e8b39eddd5f05901$var$detector.init({
    order: [
        "navigator",
        "queryString",
        "path",
        "cookie"
    ],
    lookupFromPathIndex: 0,
    lookupQuerystring: "lng"
});
const $e8b39eddd5f05901$export$bc99aaabaf7b70a7 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($6e7797ab6282f7ea$exports)))
    },
    nl: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($8cfb8e505e51d4b0$exports)))
    },
    fi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($4fbb3ecb94dca8c8$exports)))
    }
};
(0, $dsaRL.default).use((0, $938d7bb9dd90e3dc$export$2e2bcd8739ae039)).use((0, $f09823ff1610ac3d$export$ae7e14d40d89f296)).init({
    resources: // lng: 'en',
    $e8b39eddd5f05901$export$bc99aaabaf7b70a7,
    fallbackLng: "en",
    supportedLngs: [
        "en",
        "nl",
        "fi"
    ],
    // keySeparator: false,
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: [
            "navigator",
            "queryString",
            "path",
            "cookie"
        ],
        lookupFromPathIndex: 0
    }
});






"use strict";
function $ca8521541aab6ce6$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $bc95957a5e7e0c39$var$toString } = Object.prototype;
const { getPrototypeOf: $bc95957a5e7e0c39$var$getPrototypeOf } = Object;
const $bc95957a5e7e0c39$var$kindOf = ((cache)=>(thing)=>{
        const str = $bc95957a5e7e0c39$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $bc95957a5e7e0c39$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$bc95957a5e7e0c39$var$kindOf(thing) === type;
};
const $bc95957a5e7e0c39$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $bc95957a5e7e0c39$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $bc95957a5e7e0c39$var$isUndefined = $bc95957a5e7e0c39$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $bc95957a5e7e0c39$var$isBuffer(val) {
    return val !== null && !$bc95957a5e7e0c39$var$isUndefined(val) && val.constructor !== null && !$bc95957a5e7e0c39$var$isUndefined(val.constructor) && $bc95957a5e7e0c39$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $bc95957a5e7e0c39$var$isArrayBuffer = $bc95957a5e7e0c39$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $bc95957a5e7e0c39$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $bc95957a5e7e0c39$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $bc95957a5e7e0c39$var$isString = $bc95957a5e7e0c39$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $bc95957a5e7e0c39$var$isFunction = $bc95957a5e7e0c39$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $bc95957a5e7e0c39$var$isNumber = $bc95957a5e7e0c39$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $bc95957a5e7e0c39$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $bc95957a5e7e0c39$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $bc95957a5e7e0c39$var$isPlainObject = (val)=>{
    if ($bc95957a5e7e0c39$var$kindOf(val) !== "object") return false;
    const prototype = $bc95957a5e7e0c39$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $bc95957a5e7e0c39$var$isDate = $bc95957a5e7e0c39$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $bc95957a5e7e0c39$var$isFile = $bc95957a5e7e0c39$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $bc95957a5e7e0c39$var$isBlob = $bc95957a5e7e0c39$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $bc95957a5e7e0c39$var$isFileList = $bc95957a5e7e0c39$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $bc95957a5e7e0c39$var$isStream = (val)=>$bc95957a5e7e0c39$var$isObject(val) && $bc95957a5e7e0c39$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $bc95957a5e7e0c39$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $bc95957a5e7e0c39$var$isFunction(thing.append) && ((kind = $bc95957a5e7e0c39$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $bc95957a5e7e0c39$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $bc95957a5e7e0c39$var$isURLSearchParams = $bc95957a5e7e0c39$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $bc95957a5e7e0c39$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $bc95957a5e7e0c39$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($bc95957a5e7e0c39$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $bc95957a5e7e0c39$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $bc95957a5e7e0c39$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $bc95957a5e7e0c39$var$isContextDefined = (context)=>!$bc95957a5e7e0c39$var$isUndefined(context) && context !== $bc95957a5e7e0c39$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $bc95957a5e7e0c39$var$merge() {
    const { caseless: caseless } = $bc95957a5e7e0c39$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $bc95957a5e7e0c39$var$findKey(result, key) || key;
        if ($bc95957a5e7e0c39$var$isPlainObject(result[targetKey]) && $bc95957a5e7e0c39$var$isPlainObject(val)) result[targetKey] = $bc95957a5e7e0c39$var$merge(result[targetKey], val);
        else if ($bc95957a5e7e0c39$var$isPlainObject(val)) result[targetKey] = $bc95957a5e7e0c39$var$merge({}, val);
        else if ($bc95957a5e7e0c39$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $bc95957a5e7e0c39$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $bc95957a5e7e0c39$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $bc95957a5e7e0c39$var$forEach(b, (val, key)=>{
        if (thisArg && $bc95957a5e7e0c39$var$isFunction(val)) a[key] = (0, $ca8521541aab6ce6$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $bc95957a5e7e0c39$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $bc95957a5e7e0c39$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $bc95957a5e7e0c39$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $bc95957a5e7e0c39$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $bc95957a5e7e0c39$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $bc95957a5e7e0c39$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($bc95957a5e7e0c39$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$bc95957a5e7e0c39$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $bc95957a5e7e0c39$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $bc95957a5e7e0c39$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $bc95957a5e7e0c39$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $bc95957a5e7e0c39$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $bc95957a5e7e0c39$var$isHTMLForm = $bc95957a5e7e0c39$var$kindOfTest("HTMLFormElement");
const $bc95957a5e7e0c39$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $bc95957a5e7e0c39$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $bc95957a5e7e0c39$var$isRegExp = $bc95957a5e7e0c39$var$kindOfTest("RegExp");
const $bc95957a5e7e0c39$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $bc95957a5e7e0c39$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $bc95957a5e7e0c39$var$freezeMethods = (obj)=>{
    $bc95957a5e7e0c39$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($bc95957a5e7e0c39$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$bc95957a5e7e0c39$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $bc95957a5e7e0c39$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $bc95957a5e7e0c39$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $bc95957a5e7e0c39$var$noop = ()=>{};
const $bc95957a5e7e0c39$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $bc95957a5e7e0c39$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $bc95957a5e7e0c39$var$DIGIT = "0123456789";
const $bc95957a5e7e0c39$var$ALPHABET = {
    DIGIT: $bc95957a5e7e0c39$var$DIGIT,
    ALPHA: $bc95957a5e7e0c39$var$ALPHA,
    ALPHA_DIGIT: $bc95957a5e7e0c39$var$ALPHA + $bc95957a5e7e0c39$var$ALPHA.toUpperCase() + $bc95957a5e7e0c39$var$DIGIT
};
const $bc95957a5e7e0c39$var$generateString = (size = 16, alphabet = $bc95957a5e7e0c39$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $bc95957a5e7e0c39$var$isSpecCompliantForm(thing) {
    return !!(thing && $bc95957a5e7e0c39$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $bc95957a5e7e0c39$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($bc95957a5e7e0c39$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $bc95957a5e7e0c39$var$isArray(source) ? [] : {};
                $bc95957a5e7e0c39$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$bc95957a5e7e0c39$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $bc95957a5e7e0c39$var$isAsyncFn = $bc95957a5e7e0c39$var$kindOfTest("AsyncFunction");
const $bc95957a5e7e0c39$var$isThenable = (thing)=>thing && ($bc95957a5e7e0c39$var$isObject(thing) || $bc95957a5e7e0c39$var$isFunction(thing)) && $bc95957a5e7e0c39$var$isFunction(thing.then) && $bc95957a5e7e0c39$var$isFunction(thing.catch);
var $bc95957a5e7e0c39$export$2e2bcd8739ae039 = {
    isArray: $bc95957a5e7e0c39$var$isArray,
    isArrayBuffer: $bc95957a5e7e0c39$var$isArrayBuffer,
    isBuffer: $bc95957a5e7e0c39$var$isBuffer,
    isFormData: $bc95957a5e7e0c39$var$isFormData,
    isArrayBufferView: $bc95957a5e7e0c39$var$isArrayBufferView,
    isString: $bc95957a5e7e0c39$var$isString,
    isNumber: $bc95957a5e7e0c39$var$isNumber,
    isBoolean: $bc95957a5e7e0c39$var$isBoolean,
    isObject: $bc95957a5e7e0c39$var$isObject,
    isPlainObject: $bc95957a5e7e0c39$var$isPlainObject,
    isUndefined: $bc95957a5e7e0c39$var$isUndefined,
    isDate: $bc95957a5e7e0c39$var$isDate,
    isFile: $bc95957a5e7e0c39$var$isFile,
    isBlob: $bc95957a5e7e0c39$var$isBlob,
    isRegExp: $bc95957a5e7e0c39$var$isRegExp,
    isFunction: $bc95957a5e7e0c39$var$isFunction,
    isStream: $bc95957a5e7e0c39$var$isStream,
    isURLSearchParams: $bc95957a5e7e0c39$var$isURLSearchParams,
    isTypedArray: $bc95957a5e7e0c39$var$isTypedArray,
    isFileList: $bc95957a5e7e0c39$var$isFileList,
    forEach: $bc95957a5e7e0c39$var$forEach,
    merge: $bc95957a5e7e0c39$var$merge,
    extend: $bc95957a5e7e0c39$var$extend,
    trim: $bc95957a5e7e0c39$var$trim,
    stripBOM: $bc95957a5e7e0c39$var$stripBOM,
    inherits: $bc95957a5e7e0c39$var$inherits,
    toFlatObject: $bc95957a5e7e0c39$var$toFlatObject,
    kindOf: $bc95957a5e7e0c39$var$kindOf,
    kindOfTest: $bc95957a5e7e0c39$var$kindOfTest,
    endsWith: $bc95957a5e7e0c39$var$endsWith,
    toArray: $bc95957a5e7e0c39$var$toArray,
    forEachEntry: $bc95957a5e7e0c39$var$forEachEntry,
    matchAll: $bc95957a5e7e0c39$var$matchAll,
    isHTMLForm: $bc95957a5e7e0c39$var$isHTMLForm,
    hasOwnProperty: $bc95957a5e7e0c39$var$hasOwnProperty,
    hasOwnProp: $bc95957a5e7e0c39$var$hasOwnProperty,
    reduceDescriptors: $bc95957a5e7e0c39$var$reduceDescriptors,
    freezeMethods: $bc95957a5e7e0c39$var$freezeMethods,
    toObjectSet: $bc95957a5e7e0c39$var$toObjectSet,
    toCamelCase: $bc95957a5e7e0c39$var$toCamelCase,
    noop: $bc95957a5e7e0c39$var$noop,
    toFiniteNumber: $bc95957a5e7e0c39$var$toFiniteNumber,
    findKey: $bc95957a5e7e0c39$var$findKey,
    global: $bc95957a5e7e0c39$var$_global,
    isContextDefined: $bc95957a5e7e0c39$var$isContextDefined,
    ALPHABET: $bc95957a5e7e0c39$var$ALPHABET,
    generateString: $bc95957a5e7e0c39$var$generateString,
    isSpecCompliantForm: $bc95957a5e7e0c39$var$isSpecCompliantForm,
    toJSONObject: $bc95957a5e7e0c39$var$toJSONObject,
    isAsyncFn: $bc95957a5e7e0c39$var$isAsyncFn,
    isThenable: $bc95957a5e7e0c39$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $637759389b2d8179$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).inherits($637759389b2d8179$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $637759389b2d8179$var$prototype = $637759389b2d8179$var$AxiosError.prototype;
const $637759389b2d8179$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $637759389b2d8179$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($637759389b2d8179$var$AxiosError, $637759389b2d8179$var$descriptors);
Object.defineProperty($637759389b2d8179$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$637759389b2d8179$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($637759389b2d8179$var$prototype);
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $637759389b2d8179$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $637759389b2d8179$export$2e2bcd8739ae039 = $637759389b2d8179$var$AxiosError;


// eslint-disable-next-line strict
var $dc533cf245b452e2$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $650295a739324ed1$export$a143d493d941bafc;
var $650295a739324ed1$export$e4cf37d7f6fb9e0a;
var $650295a739324ed1$export$f99ded8fe4b79145;
var $650295a739324ed1$export$599f31c3813fae4d;
"use strict";
var $49889c39bbce8f14$export$a48f0734ac7c2329;
var $49889c39bbce8f14$export$d622b2ad8d90c771;
var $49889c39bbce8f14$export$6100ba28696e12de;
"use strict";
$49889c39bbce8f14$export$a48f0734ac7c2329 = $49889c39bbce8f14$var$byteLength;
$49889c39bbce8f14$export$d622b2ad8d90c771 = $49889c39bbce8f14$var$toByteArray;
$49889c39bbce8f14$export$6100ba28696e12de = $49889c39bbce8f14$var$fromByteArray;
var $49889c39bbce8f14$var$lookup = [];
var $49889c39bbce8f14$var$revLookup = [];
var $49889c39bbce8f14$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $49889c39bbce8f14$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $49889c39bbce8f14$var$i = 0, $49889c39bbce8f14$var$len = $49889c39bbce8f14$var$code.length; $49889c39bbce8f14$var$i < $49889c39bbce8f14$var$len; ++$49889c39bbce8f14$var$i){
    $49889c39bbce8f14$var$lookup[$49889c39bbce8f14$var$i] = $49889c39bbce8f14$var$code[$49889c39bbce8f14$var$i];
    $49889c39bbce8f14$var$revLookup[$49889c39bbce8f14$var$code.charCodeAt($49889c39bbce8f14$var$i)] = $49889c39bbce8f14$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$49889c39bbce8f14$var$revLookup["-".charCodeAt(0)] = 62;
$49889c39bbce8f14$var$revLookup["_".charCodeAt(0)] = 63;
function $49889c39bbce8f14$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $49889c39bbce8f14$var$byteLength(b64) {
    var lens = $49889c39bbce8f14$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $49889c39bbce8f14$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $49889c39bbce8f14$var$toByteArray(b64) {
    var tmp;
    var lens = $49889c39bbce8f14$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $49889c39bbce8f14$var$Arr($49889c39bbce8f14$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i)] << 18 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i)] << 2 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i)] << 10 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $49889c39bbce8f14$var$tripletToBase64(num) {
    return $49889c39bbce8f14$var$lookup[num >> 18 & 0x3F] + $49889c39bbce8f14$var$lookup[num >> 12 & 0x3F] + $49889c39bbce8f14$var$lookup[num >> 6 & 0x3F] + $49889c39bbce8f14$var$lookup[num & 0x3F];
}
function $49889c39bbce8f14$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($49889c39bbce8f14$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $49889c39bbce8f14$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($49889c39bbce8f14$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($49889c39bbce8f14$var$lookup[tmp >> 2] + $49889c39bbce8f14$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($49889c39bbce8f14$var$lookup[tmp >> 10] + $49889c39bbce8f14$var$lookup[tmp >> 4 & 0x3F] + $49889c39bbce8f14$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d29f0355f5b6c666$export$aafa59e2e03f2942;
var $d29f0355f5b6c666$export$68d8715fc104d294;
$d29f0355f5b6c666$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d29f0355f5b6c666$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $650295a739324ed1$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$650295a739324ed1$export$a143d493d941bafc = $650295a739324ed1$var$Buffer;
$650295a739324ed1$export$e4cf37d7f6fb9e0a = $650295a739324ed1$var$SlowBuffer;
$650295a739324ed1$export$f99ded8fe4b79145 = 50;
const $650295a739324ed1$var$K_MAX_LENGTH = 0x7fffffff;
$650295a739324ed1$export$599f31c3813fae4d = $650295a739324ed1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $650295a739324ed1$var$Buffer.TYPED_ARRAY_SUPPORT = $650295a739324ed1$var$typedArraySupport();
if (!$650295a739324ed1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $650295a739324ed1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($650295a739324ed1$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$650295a739324ed1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($650295a739324ed1$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$650295a739324ed1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $650295a739324ed1$var$createBuffer(length) {
    if (length > $650295a739324ed1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $650295a739324ed1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $650295a739324ed1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $650295a739324ed1$var$allocUnsafe(arg);
    }
    return $650295a739324ed1$var$from(arg, encodingOrOffset, length);
}
$650295a739324ed1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $650295a739324ed1$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $650295a739324ed1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $650295a739324ed1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($650295a739324ed1$var$isInstance(value, ArrayBuffer) || value && $650295a739324ed1$var$isInstance(value.buffer, ArrayBuffer)) return $650295a739324ed1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($650295a739324ed1$var$isInstance(value, SharedArrayBuffer) || value && $650295a739324ed1$var$isInstance(value.buffer, SharedArrayBuffer))) return $650295a739324ed1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $650295a739324ed1$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $650295a739324ed1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $650295a739324ed1$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $650295a739324ed1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $650295a739324ed1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($650295a739324ed1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($650295a739324ed1$var$Buffer, Uint8Array);
function $650295a739324ed1$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $650295a739324ed1$var$alloc(size, fill, encoding) {
    $650295a739324ed1$var$assertSize(size);
    if (size <= 0) return $650295a739324ed1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $650295a739324ed1$var$createBuffer(size).fill(fill, encoding) : $650295a739324ed1$var$createBuffer(size).fill(fill);
    return $650295a739324ed1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $650295a739324ed1$var$Buffer.alloc = function(size, fill, encoding) {
    return $650295a739324ed1$var$alloc(size, fill, encoding);
};
function $650295a739324ed1$var$allocUnsafe(size) {
    $650295a739324ed1$var$assertSize(size);
    return $650295a739324ed1$var$createBuffer(size < 0 ? 0 : $650295a739324ed1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $650295a739324ed1$var$Buffer.allocUnsafe = function(size) {
    return $650295a739324ed1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $650295a739324ed1$var$Buffer.allocUnsafeSlow = function(size) {
    return $650295a739324ed1$var$allocUnsafe(size);
};
function $650295a739324ed1$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$650295a739324ed1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $650295a739324ed1$var$byteLength(string, encoding) | 0;
    let buf = $650295a739324ed1$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $650295a739324ed1$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $650295a739324ed1$var$checked(array.length) | 0;
    const buf = $650295a739324ed1$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $650295a739324ed1$var$fromArrayView(arrayView) {
    if ($650295a739324ed1$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $650295a739324ed1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $650295a739324ed1$var$fromArrayLike(arrayView);
}
function $650295a739324ed1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $650295a739324ed1$var$Buffer.prototype);
    return buf;
}
function $650295a739324ed1$var$fromObject(obj) {
    if ($650295a739324ed1$var$Buffer.isBuffer(obj)) {
        const len = $650295a739324ed1$var$checked(obj.length) | 0;
        const buf = $650295a739324ed1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $650295a739324ed1$var$numberIsNaN(obj.length)) return $650295a739324ed1$var$createBuffer(0);
        return $650295a739324ed1$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $650295a739324ed1$var$fromArrayLike(obj.data);
}
function $650295a739324ed1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $650295a739324ed1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $650295a739324ed1$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $650295a739324ed1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $650295a739324ed1$var$Buffer.alloc(+length);
}
$650295a739324ed1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $650295a739324ed1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$650295a739324ed1$var$Buffer.compare = function compare(a, b) {
    if ($650295a739324ed1$var$isInstance(a, Uint8Array)) a = $650295a739324ed1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($650295a739324ed1$var$isInstance(b, Uint8Array)) b = $650295a739324ed1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$650295a739324ed1$var$Buffer.isBuffer(a) || !$650295a739324ed1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$650295a739324ed1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$650295a739324ed1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $650295a739324ed1$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $650295a739324ed1$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($650295a739324ed1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$650295a739324ed1$var$Buffer.isBuffer(buf)) buf = $650295a739324ed1$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$650295a739324ed1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $650295a739324ed1$var$byteLength(string, encoding) {
    if ($650295a739324ed1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $650295a739324ed1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $650295a739324ed1$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $650295a739324ed1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $650295a739324ed1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$650295a739324ed1$var$Buffer.byteLength = $650295a739324ed1$var$byteLength;
function $650295a739324ed1$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $650295a739324ed1$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $650295a739324ed1$var$utf8Slice(this, start, end);
        case "ascii":
            return $650295a739324ed1$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $650295a739324ed1$var$latin1Slice(this, start, end);
        case "base64":
            return $650295a739324ed1$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $650295a739324ed1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$650295a739324ed1$var$Buffer.prototype._isBuffer = true;
function $650295a739324ed1$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$650295a739324ed1$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$650295a739324ed1$var$swap(this, i, i + 1);
    return this;
};
$650295a739324ed1$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $650295a739324ed1$var$swap(this, i, i + 3);
        $650295a739324ed1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$650295a739324ed1$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $650295a739324ed1$var$swap(this, i, i + 7);
        $650295a739324ed1$var$swap(this, i + 1, i + 6);
        $650295a739324ed1$var$swap(this, i + 2, i + 5);
        $650295a739324ed1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$650295a739324ed1$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $650295a739324ed1$var$utf8Slice(this, 0, length);
    return $650295a739324ed1$var$slowToString.apply(this, arguments);
};
$650295a739324ed1$var$Buffer.prototype.toLocaleString = $650295a739324ed1$var$Buffer.prototype.toString;
$650295a739324ed1$var$Buffer.prototype.equals = function equals(b) {
    if (!$650295a739324ed1$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $650295a739324ed1$var$Buffer.compare(this, b) === 0;
};
$650295a739324ed1$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $650295a739324ed1$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($650295a739324ed1$var$customInspectSymbol) $650295a739324ed1$var$Buffer.prototype[$650295a739324ed1$var$customInspectSymbol] = $650295a739324ed1$var$Buffer.prototype.inspect;
$650295a739324ed1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($650295a739324ed1$var$isInstance(target, Uint8Array)) target = $650295a739324ed1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$650295a739324ed1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $650295a739324ed1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($650295a739324ed1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $650295a739324ed1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($650295a739324ed1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $650295a739324ed1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $650295a739324ed1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $650295a739324ed1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$650295a739324ed1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$650295a739324ed1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $650295a739324ed1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$650295a739324ed1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $650295a739324ed1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $650295a739324ed1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($650295a739324ed1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $650295a739324ed1$var$utf8Write(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $650295a739324ed1$var$asciiWrite(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$asciiToBytes(string), buf, offset, length);
}
function $650295a739324ed1$var$base64Write(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$base64ToBytes(string), buf, offset, length);
}
function $650295a739324ed1$var$ucs2Write(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$650295a739324ed1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $650295a739324ed1$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $650295a739324ed1$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $650295a739324ed1$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $650295a739324ed1$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $650295a739324ed1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$650295a739324ed1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $650295a739324ed1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $49889c39bbce8f14$export$6100ba28696e12de(buf);
    else return $49889c39bbce8f14$export$6100ba28696e12de(buf.slice(start, end));
}
function $650295a739324ed1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $650295a739324ed1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $650295a739324ed1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $650295a739324ed1$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $650295a739324ed1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $650295a739324ed1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $650295a739324ed1$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $650295a739324ed1$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $650295a739324ed1$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $650295a739324ed1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $650295a739324ed1$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$650295a739324ed1$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $650295a739324ed1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $650295a739324ed1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$650295a739324ed1$var$Buffer.prototype.readUintLE = $650295a739324ed1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readUintBE = $650295a739324ed1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readUint8 = $650295a739324ed1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$650295a739324ed1$var$Buffer.prototype.readUint16LE = $650295a739324ed1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$650295a739324ed1$var$Buffer.prototype.readUint16BE = $650295a739324ed1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$650295a739324ed1$var$Buffer.prototype.readUint32LE = $650295a739324ed1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$650295a739324ed1$var$Buffer.prototype.readUint32BE = $650295a739324ed1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$650295a739324ed1$var$Buffer.prototype.readBigUInt64LE = $650295a739324ed1$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $650295a739324ed1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $650295a739324ed1$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$650295a739324ed1$var$Buffer.prototype.readBigUInt64BE = $650295a739324ed1$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $650295a739324ed1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $650295a739324ed1$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$650295a739324ed1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$650295a739324ed1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$650295a739324ed1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$650295a739324ed1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$650295a739324ed1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$650295a739324ed1$var$Buffer.prototype.readBigInt64LE = $650295a739324ed1$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $650295a739324ed1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $650295a739324ed1$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$650295a739324ed1$var$Buffer.prototype.readBigInt64BE = $650295a739324ed1$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $650295a739324ed1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $650295a739324ed1$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$650295a739324ed1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$650295a739324ed1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$650295a739324ed1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 8, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$650295a739324ed1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 8, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $650295a739324ed1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$650295a739324ed1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$650295a739324ed1$var$Buffer.prototype.writeUintLE = $650295a739324ed1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeUintBE = $650295a739324ed1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeUint8 = $650295a739324ed1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$650295a739324ed1$var$Buffer.prototype.writeUint16LE = $650295a739324ed1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeUint16BE = $650295a739324ed1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeUint32LE = $650295a739324ed1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$650295a739324ed1$var$Buffer.prototype.writeUint32BE = $650295a739324ed1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $650295a739324ed1$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $650295a739324ed1$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $650295a739324ed1$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $650295a739324ed1$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$650295a739324ed1$var$Buffer.prototype.writeBigUInt64LE = $650295a739324ed1$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $650295a739324ed1$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$650295a739324ed1$var$Buffer.prototype.writeBigUInt64BE = $650295a739324ed1$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $650295a739324ed1$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$650295a739324ed1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$650295a739324ed1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$650295a739324ed1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$650295a739324ed1$var$Buffer.prototype.writeBigInt64LE = $650295a739324ed1$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $650295a739324ed1$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$650295a739324ed1$var$Buffer.prototype.writeBigInt64BE = $650295a739324ed1$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $650295a739324ed1$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $650295a739324ed1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $650295a739324ed1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $d29f0355f5b6c666$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$650295a739324ed1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeFloat(this, value, offset, true, noAssert);
};
$650295a739324ed1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeFloat(this, value, offset, false, noAssert);
};
function $650295a739324ed1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $d29f0355f5b6c666$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$650295a739324ed1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeDouble(this, value, offset, true, noAssert);
};
$650295a739324ed1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$650295a739324ed1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$650295a739324ed1$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$650295a739324ed1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$650295a739324ed1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $650295a739324ed1$var$Buffer.isBuffer(val) ? val : $650295a739324ed1$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $650295a739324ed1$var$errors = {};
function $650295a739324ed1$var$E(sym, getMessage, Base) {
    $650295a739324ed1$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$650295a739324ed1$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$650295a739324ed1$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$650295a739324ed1$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $650295a739324ed1$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $650295a739324ed1$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $650295a739324ed1$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $650295a739324ed1$var$checkBounds(buf, offset, byteLength) {
    $650295a739324ed1$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $650295a739324ed1$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $650295a739324ed1$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $650295a739324ed1$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $650295a739324ed1$var$checkBounds(buf, offset, byteLength);
}
function $650295a739324ed1$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $650295a739324ed1$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $650295a739324ed1$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $650295a739324ed1$var$validateNumber(value, type);
        throw new $650295a739324ed1$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $650295a739324ed1$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $650295a739324ed1$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $650295a739324ed1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $650295a739324ed1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($650295a739324ed1$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $650295a739324ed1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $650295a739324ed1$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $650295a739324ed1$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $650295a739324ed1$var$base64ToBytes(str) {
    return $49889c39bbce8f14$export$d622b2ad8d90c771($650295a739324ed1$var$base64clean(str));
}
function $650295a739324ed1$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $650295a739324ed1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $650295a739324ed1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $650295a739324ed1$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $650295a739324ed1$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $650295a739324ed1$var$BufferBigIntNotDefined : fn;
}
function $650295a739324ed1$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $29926b85f190cc00$require$Buffer = $650295a739324ed1$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $29926b85f190cc00$var$isVisitable(thing) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $29926b85f190cc00$var$removeBrackets(key) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $29926b85f190cc00$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $29926b85f190cc00$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $29926b85f190cc00$var$isFlatArray(arr) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(arr) && !arr.some($29926b85f190cc00$var$isVisitable);
}
const $29926b85f190cc00$var$predicates = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toFlatObject((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $29926b85f190cc00$var$toFormData(obj, formData, options) {
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $dc533cf245b452e2$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $29926b85f190cc00$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(value) && $29926b85f190cc00$var$isFlatArray(value) || ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFileList(value) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $29926b85f190cc00$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $29926b85f190cc00$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($29926b85f190cc00$var$isVisitable(value)) return true;
        formData.append($29926b85f190cc00$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($29926b85f190cc00$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $29926b85f190cc00$var$isVisitable
    });
    function build(value, path) {
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $29926b85f190cc00$export$2e2bcd8739ae039 = $29926b85f190cc00$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $fc14c25407d98aa2$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $fc14c25407d98aa2$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $29926b85f190cc00$export$2e2bcd8739ae039)(params, this, options);
}
const $fc14c25407d98aa2$var$prototype = $fc14c25407d98aa2$var$AxiosURLSearchParams.prototype;
$fc14c25407d98aa2$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$fc14c25407d98aa2$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $fc14c25407d98aa2$var$encode);
    } : $fc14c25407d98aa2$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $fc14c25407d98aa2$export$2e2bcd8739ae039 = $fc14c25407d98aa2$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $d1c352dffd6c37f8$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $d1c352dffd6c37f8$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $d1c352dffd6c37f8$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $fc14c25407d98aa2$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $cac6c0aeb085b4f1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $cac6c0aeb085b4f1$export$2e2bcd8739ae039 = $cac6c0aeb085b4f1$var$InterceptorManager;





"use strict";
var $742f8ca1004f36cf$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $824300454ef6f06d$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $fc14c25407d98aa2$export$2e2bcd8739ae039);


"use strict";
var $b9beeee9d03e6871$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $804e230012604cc4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2b3c464133eb8a7c$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $824300454ef6f06d$export$2e2bcd8739ae039,
        FormData: $b9beeee9d03e6871$export$2e2bcd8739ae039,
        Blob: $804e230012604cc4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $4524f791c8d6a57e$exports = {};

$parcel$export($4524f791c8d6a57e$exports, "hasBrowserEnv", function () { return $4524f791c8d6a57e$export$c4996c4b7b93b0bf; });
$parcel$export($4524f791c8d6a57e$exports, "hasStandardBrowserEnv", function () { return $4524f791c8d6a57e$export$c0bcc9250309d66; });
$parcel$export($4524f791c8d6a57e$exports, "hasStandardBrowserWebWorkerEnv", function () { return $4524f791c8d6a57e$export$c81692cf5af97dac; });
const $4524f791c8d6a57e$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $4524f791c8d6a57e$export$c0bcc9250309d66 = ((product)=>{
    return $4524f791c8d6a57e$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $4524f791c8d6a57e$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $66f0fd32aa1c7d39$export$2e2bcd8739ae039 = {
    ...$4524f791c8d6a57e$exports,
    ...(0, $2b3c464133eb8a7c$export$2e2bcd8739ae039)
};


"use strict";
function $49a617acb9dfa85e$export$2e2bcd8739ae039(data, options) {
    return (0, $29926b85f190cc00$export$2e2bcd8739ae039)(data, new (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).isNode && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $d73a975fa518ebeb$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $d73a975fa518ebeb$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $d73a975fa518ebeb$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $d73a975fa518ebeb$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFormData(formData) && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($d73a975fa518ebeb$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $d73a975fa518ebeb$export$2e2bcd8739ae039 = $d73a975fa518ebeb$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $64102e3a924041e9$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $64102e3a924041e9$var$defaults = {
    transitional: (0, $742f8ca1004f36cf$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $d73a975fa518ebeb$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBuffer(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isStream(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFile(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $49a617acb9dfa85e$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $29926b85f190cc00$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $64102e3a924041e9$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $64102e3a924041e9$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $637759389b2d8179$export$2e2bcd8739ae039).from(e, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $64102e3a924041e9$var$defaults.headers[method] = {};
});
var $64102e3a924041e9$export$2e2bcd8739ae039 = $64102e3a924041e9$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $66aa18902245fdef$var$ignoreDuplicateOf = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $66aa18902245fdef$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $66aa18902245fdef$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c44fec3be66b208e$var$$internals = Symbol("internals");
function $c44fec3be66b208e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c44fec3be66b208e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(value) ? value.map($c44fec3be66b208e$var$normalizeValue) : String(value);
}
function $c44fec3be66b208e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c44fec3be66b208e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c44fec3be66b208e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c44fec3be66b208e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c44fec3be66b208e$var$buildAccessors(obj, header) {
    const accessorName = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c44fec3be66b208e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c44fec3be66b208e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c44fec3be66b208e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c44fec3be66b208e$var$isValidHeaderName(header)) setHeaders((0, $66aa18902245fdef$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c44fec3be66b208e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c44fec3be66b208e$var$parseTokens(value);
                if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c44fec3be66b208e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c44fec3be66b208e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c44fec3be66b208e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c44fec3be66b208e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c44fec3be66b208e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c44fec3be66b208e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c44fec3be66b208e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c44fec3be66b208e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c44fec3be66b208e$var$$internals] = this[$c44fec3be66b208e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c44fec3be66b208e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c44fec3be66b208e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c44fec3be66b208e$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).reduceDescriptors($c44fec3be66b208e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).freezeMethods($c44fec3be66b208e$var$AxiosHeaders);
var $c44fec3be66b208e$export$2e2bcd8739ae039 = $c44fec3be66b208e$var$AxiosHeaders;


"use strict";
function $c1a1b13357d0a140$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $64102e3a924041e9$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $9b9075f5b4b4a6ff$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $26bae45c8db1f1d9$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $637759389b2d8179$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).inherits($26bae45c8db1f1d9$var$CanceledError, (0, $637759389b2d8179$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $26bae45c8db1f1d9$export$2e2bcd8739ae039 = $26bae45c8db1f1d9$var$CanceledError;







"use strict";
function $e952e434899d7c98$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $16d3d1c46f3bf7d7$export$2e2bcd8739ae039 = (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $3f515d5eeddff0d0$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $1ef7e307329b6570$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $788e5dad59537aca$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $3f515d5eeddff0d0$export$2e2bcd8739ae039)(requestedURL)) return (0, $1ef7e307329b6570$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $546edfc2eed161c9$export$2e2bcd8739ae039 = (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $3c329c250ab05a1c$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $74c620fbb6ed3830$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $74c620fbb6ed3830$export$2e2bcd8739ae039 = $74c620fbb6ed3830$var$speedometer;


"use strict";
function $8a47eaadb4f44311$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $74c620fbb6ed3830$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $8a47eaadb4f44311$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $8a47eaadb4f44311$export$2e2bcd8739ae039 = $8a47eaadb4f44311$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $788e5dad59537aca$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $d1c352dffd6c37f8$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $e952e434899d7c98$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Request aborted", (0, $637759389b2d8179$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Network Error", (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $742f8ca1004f36cf$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $637759389b2d8179$export$2e2bcd8739ae039).ETIMEDOUT : (0, $637759389b2d8179$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $546edfc2eed161c9$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $16d3d1c46f3bf7d7$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $8a47eaadb4f44311$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $8a47eaadb4f44311$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $3c329c250ab05a1c$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $8957550d004fb8e7$var$knownAdapters = {
    http: (0, $dc533cf245b452e2$export$2e2bcd8739ae039),
    xhr: (0, $8a47eaadb4f44311$export$2e2bcd8739ae039)
};
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach($8957550d004fb8e7$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $8957550d004fb8e7$var$renderReason = (reason)=>`- ${reason}`;
const $8957550d004fb8e7$var$isResolvedHandle = (adapter)=>(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $8957550d004fb8e7$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$8957550d004fb8e7$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $8957550d004fb8e7$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($8957550d004fb8e7$var$renderReason).join("\n") : " " + $8957550d004fb8e7$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $8957550d004fb8e7$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a90e695ce52f20ae$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039)(null, config);
}
function $a90e695ce52f20ae$export$2e2bcd8739ae039(config) {
    $a90e695ce52f20ae$var$throwIfCancellationRequested(config);
    config.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $c1a1b13357d0a140$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $8957550d004fb8e7$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $64102e3a924041e9$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $a90e695ce52f20ae$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $c1a1b13357d0a140$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $9b9075f5b4b4a6ff$export$2e2bcd8739ae039)(reason)) {
            $a90e695ce52f20ae$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $c1a1b13357d0a140$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $ff39e254535c25ce$var$headersToObject = (thing)=>thing instanceof (0, $c44fec3be66b208e$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $ff39e254535c25ce$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(target) && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($ff39e254535c25ce$var$headersToObject(a), $ff39e254535c25ce$var$headersToObject(b), true)
    };
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $c16788b5149ee7e6$export$a4ad2735b021c132 = "1.6.8";



"use strict";
const $75ac3759707f3593$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $75ac3759707f3593$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $75ac3759707f3593$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $75ac3759707f3593$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $c16788b5149ee7e6$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$75ac3759707f3593$var$deprecatedWarnings[opt]) {
            $75ac3759707f3593$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $75ac3759707f3593$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("options must be an object", (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $75ac3759707f3593$export$2e2bcd8739ae039 = {
    assertOptions: $75ac3759707f3593$var$assertOptions,
    validators: $75ac3759707f3593$var$validators
};



"use strict";
const $0cdbc7e535a536fd$var$validators = (0, $75ac3759707f3593$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0cdbc7e535a536fd$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $cac6c0aeb085b4f1$export$2e2bcd8739ae039)(),
            response: new (0, $cac6c0aeb085b4f1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ff39e254535c25ce$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $75ac3759707f3593$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0cdbc7e535a536fd$var$validators.transitional($0cdbc7e535a536fd$var$validators.boolean),
            forcedJSONParsing: $0cdbc7e535a536fd$var$validators.transitional($0cdbc7e535a536fd$var$validators.boolean),
            clarifyTimeoutError: $0cdbc7e535a536fd$var$validators.transitional($0cdbc7e535a536fd$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $75ac3759707f3593$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0cdbc7e535a536fd$var$validators.function,
                serialize: $0cdbc7e535a536fd$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a90e695ce52f20ae$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $a90e695ce52f20ae$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ff39e254535c25ce$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $788e5dad59537aca$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $d1c352dffd6c37f8$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0cdbc7e535a536fd$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ff39e254535c25ce$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ff39e254535c25ce$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0cdbc7e535a536fd$var$Axios.prototype[method] = generateHTTPMethod();
    $0cdbc7e535a536fd$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $0cdbc7e535a536fd$export$2e2bcd8739ae039 = $0cdbc7e535a536fd$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $d14d3ef8f50745ec$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $d14d3ef8f50745ec$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $d14d3ef8f50745ec$export$2e2bcd8739ae039 = $d14d3ef8f50745ec$var$CancelToken;






"use strict";
function $96dec4d5bb99217c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $3b1a439533ee9426$export$2e2bcd8739ae039(payload) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $23aa36a2db2c13f0$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($23aa36a2db2c13f0$var$HttpStatusCode).forEach(([key, value])=>{
    $23aa36a2db2c13f0$var$HttpStatusCode[value] = key;
});
var $23aa36a2db2c13f0$export$2e2bcd8739ae039 = $23aa36a2db2c13f0$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $cd771979e180c558$var$createInstance(defaultConfig) {
    const context = new (0, $0cdbc7e535a536fd$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $ca8521541aab6ce6$export$2e2bcd8739ae039)((0, $0cdbc7e535a536fd$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).extend(instance, (0, $0cdbc7e535a536fd$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $cd771979e180c558$var$createInstance((0, $ff39e254535c25ce$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $cd771979e180c558$var$axios = $cd771979e180c558$var$createInstance((0, $64102e3a924041e9$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$cd771979e180c558$var$axios.Axios = (0, $0cdbc7e535a536fd$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$cd771979e180c558$var$axios.CanceledError = (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.CancelToken = (0, $d14d3ef8f50745ec$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.isCancel = (0, $9b9075f5b4b4a6ff$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.VERSION = (0, $c16788b5149ee7e6$export$a4ad2735b021c132);
$cd771979e180c558$var$axios.toFormData = (0, $29926b85f190cc00$export$2e2bcd8739ae039);
// Expose AxiosError class
$cd771979e180c558$var$axios.AxiosError = (0, $637759389b2d8179$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$cd771979e180c558$var$axios.Cancel = $cd771979e180c558$var$axios.CanceledError;
// Expose all/spread
$cd771979e180c558$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$cd771979e180c558$var$axios.spread = (0, $96dec4d5bb99217c$export$2e2bcd8739ae039);
// Expose isAxiosError
$cd771979e180c558$var$axios.isAxiosError = (0, $3b1a439533ee9426$export$2e2bcd8739ae039);
// Expose mergeConfig
$cd771979e180c558$var$axios.mergeConfig = (0, $ff39e254535c25ce$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.AxiosHeaders = (0, $c44fec3be66b208e$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.formToJSON = (thing)=>(0, $d73a975fa518ebeb$export$2e2bcd8739ae039)((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$cd771979e180c558$var$axios.getAdapter = (0, $8957550d004fb8e7$export$2e2bcd8739ae039).getAdapter;
$cd771979e180c558$var$axios.HttpStatusCode = (0, $23aa36a2db2c13f0$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.default = $cd771979e180c558$var$axios;
var // this module should only have a default export
$cd771979e180c558$export$2e2bcd8739ae039 = $cd771979e180c558$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b7070c4fc492ac8b$export$1c00760e9e5a4e95, AxiosError: $b7070c4fc492ac8b$export$c1fbed17c2f6a328, CanceledError: $b7070c4fc492ac8b$export$1ab0c6b20d94fa14, isCancel: $b7070c4fc492ac8b$export$3b22524397b493c6, CancelToken: $b7070c4fc492ac8b$export$fd08e3cb425f0d61, VERSION: $b7070c4fc492ac8b$export$a4ad2735b021c132, all: $b7070c4fc492ac8b$export$84bf76cd7afc7469, Cancel: $b7070c4fc492ac8b$export$848c9b7ead0df967, isAxiosError: $b7070c4fc492ac8b$export$fbafdbe06a5b5a9a, spread: $b7070c4fc492ac8b$export$3ae0fd4797ed47c8, toFormData: $b7070c4fc492ac8b$export$10ae0d317ea97f8b, AxiosHeaders: $b7070c4fc492ac8b$export$4e7d6ff0f3e6520, HttpStatusCode: $b7070c4fc492ac8b$export$a972f69c851492b3, formToJSON: $b7070c4fc492ac8b$export$86d7c59254d6a2c9, getAdapter: $b7070c4fc492ac8b$export$17ddc20a97d669e2, mergeConfig: $b7070c4fc492ac8b$export$7ec1ebcfa9d8bd6a } = (0, $cd771979e180c558$export$2e2bcd8739ae039);



var $hJwnw = parcelRequire("hJwnw");

const $bffe96b1c6039f7a$export$7f7cbe89f1eacd2 = ()=>{
    return /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "spinner"
    }, /*#__PURE__*/ $hJwnw.createElement("svg", {
        className: "circular",
        viewBox: "25 25 50 50",
        width: "48px",
        height: "48px"
    }, /*#__PURE__*/ $hJwnw.createElement("circle", {
        className: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        strokeWidth: "2",
        stroke: "black",
        strokeMiterlimit: "10"
    })));
};


var $b8db5df6424344a9$exports = {};

$b8db5df6424344a9$exports = (parcelRequire("ef61Y")).getBundleURL("eot5l") + "checkout.cc97b3de.svg";



var $hJwnw = parcelRequire("hJwnw");
const $171a0bbc376ef44a$export$909477bc2c8ad221 = ()=>{
    const branding = localStorage.getItem("branding");
    switch(branding){
        case "experian":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "68",
                height: "22",
                viewBox: "0 0 68 22",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M11.0658 5.1309H8.54768C7.79828 5.1309 7.19229 4.53521 7.19229 3.80086V1.32948C7.19234 0.595694 7.79833 0 8.54773 0H11.0658C11.8142 0 12.4206 0.595694 12.4206 1.32948V3.80086C12.4206 4.53521 11.8142 5.1309 11.0658 5.1309Z",
                fill: "#426DA9"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M4.55148 10.6704H1.71863C0.877007 10.6704 0.194214 10.0023 0.194214 9.1749V6.39406C0.194214 5.56855 0.877007 4.89819 1.71863 4.89819H4.55148C5.39354 4.89819 6.07609 5.56855 6.07609 6.39406V9.1749C6.07609 10.0023 5.39354 10.6704 4.55148 10.6704Z",
                fill: "#6D2077"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M4.28174 16.441H2.5516C2.03725 16.441 1.61926 16.0324 1.61926 15.5266V13.8293C1.61926 13.3229 2.03725 12.9136 2.5516 12.9136H4.28174C4.79634 12.9136 5.21365 13.3229 5.21365 13.8293V15.5266C5.21365 16.0324 4.79634 16.441 4.28174 16.441Z",
                fill: "#AF1685"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M8.92736 21.8064H6.88154C6.27343 21.8064 5.78043 21.3238 5.78043 20.726V18.7181C5.78043 18.1203 6.27338 17.6375 6.88154 17.6375H8.92736C9.53547 17.6375 10.0284 18.1202 10.0284 18.7181V20.726C10.0284 21.3238 9.53547 21.8064 8.92736 21.8064Z",
                fill: "#E63888"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M16.4248 6.14198H15.0073C14.5862 6.14198 14.2451 5.80626 14.2451 5.39426V4.00491C14.2451 3.59158 14.5862 3.25586 15.0073 3.25586H16.4248C16.8456 3.25586 17.186 3.59158 17.186 4.00491V5.39426C17.186 5.80621 16.8456 6.14198 16.4248 6.14198Z",
                fill: "#E63888"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M47.4432 7.0704C47.8938 7.0704 48.2585 6.71244 48.2585 6.2692C48.2585 5.82663 47.8937 5.46692 47.4432 5.46692C46.9925 5.46692 46.6246 5.82663 46.6246 6.2692C46.6246 6.71249 46.9924 7.0704 47.4432 7.0704Z",
                fill: "#1D4F91"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M17.6265 15.6215C17.5002 15.8075 17.2949 15.9003 17.0738 15.9003C16.9477 15.9003 16.8054 15.8694 16.6949 15.8075C16.5213 15.6988 16.3947 15.4666 16.3947 15.2342C16.3947 15.1255 16.4265 15.0169 16.4896 14.9242L18.3846 11.9956L16.4896 9.06698C16.4265 8.97397 16.3947 8.85 16.3947 8.7413C16.3947 8.52457 16.5055 8.29209 16.7108 8.18339C16.8212 8.12153 16.9319 8.09057 17.058 8.09057C17.2791 8.09057 17.5002 8.18339 17.6265 8.36965L19.174 10.7713L20.737 8.36965C20.8635 8.18339 21.0846 8.09057 21.3057 8.09057C21.432 8.09057 21.5426 8.12148 21.6529 8.18339C21.8582 8.29209 21.9686 8.52457 21.9686 8.7413C21.9686 8.85 21.9371 8.97397 21.874 9.06698L19.9792 11.9956L21.874 14.9242C21.9371 15.0169 21.9686 15.1255 21.9686 15.2342C21.9686 15.4666 21.8425 15.6988 21.6686 15.8075C21.5583 15.8694 21.416 15.9003 21.2897 15.9003C21.0689 15.9003 20.8635 15.8075 20.737 15.6215L19.174 13.2352L17.6265 15.6215ZM24.3819 9.00488C25.0925 8.36965 26.0557 7.9823 27.0979 7.9823C29.3719 7.9823 31.1877 9.7644 31.1877 11.9956C31.1877 14.1964 29.3719 15.9781 27.0979 15.9781C26.0557 15.9781 25.0925 15.5906 24.3819 14.9553V18.3799C24.3819 18.7209 24.0662 19.0152 23.7033 19.0152C23.3715 19.0152 23.04 18.7208 23.04 18.3799V8.67944C23.04 8.33874 23.3715 8.04416 23.7033 8.04416C24.0662 8.04416 24.3819 8.33869 24.3819 8.67944V9.00488ZM27.0979 9.31519C25.582 9.31519 24.3819 10.4925 24.3819 11.9956C24.3819 13.4833 25.5819 14.6608 27.0979 14.6608C28.6298 14.6608 29.8294 13.4833 29.8294 11.9956C29.8294 10.4925 28.6298 9.31519 27.0979 9.31519ZM42.748 11.2673V15.2806C42.748 15.6215 42.4162 15.9158 42.0848 15.9158C41.7214 15.9158 41.4057 15.6215 41.4057 15.2806V8.67944C41.4057 8.3385 41.7214 8.04416 42.0848 8.04416C42.4009 8.04416 42.7318 8.32305 42.748 8.64849C43.3005 8.23023 44.0111 7.99756 44.7847 7.9823C45.2112 7.9823 45.5266 8.30755 45.5266 8.63303C45.5266 8.98919 45.1954 9.31481 44.7847 9.31481C43.727 9.34572 42.748 9.7178 42.748 11.2673ZM47.4528 8.04416C47.0898 8.04416 46.7742 8.3385 46.7742 8.67944V15.2806C46.7742 15.6215 47.0898 15.9158 47.4528 15.9158C47.7846 15.9158 48.116 15.6215 48.116 15.2806V8.67944C48.116 8.33846 47.7846 8.04416 47.4528 8.04416ZM56.0274 8.67944C56.0274 8.3385 56.3425 8.04416 56.7059 8.04416C57.0376 8.04416 57.3692 8.3385 57.3692 8.67944V15.2806C57.3692 15.6215 57.0376 15.9158 56.7059 15.9158C56.3425 15.9158 56.0274 15.6215 56.0274 15.2806V14.9551C55.301 15.5904 54.3531 15.9777 53.3107 15.9777C51.0371 15.9777 49.2213 14.1962 49.2213 11.9647C49.2213 9.76445 51.0371 7.98235 53.3107 7.98235C54.3531 7.98235 55.301 8.3697 56.0274 9.00516V8.67944ZM53.3107 14.6453C54.8267 14.6453 56.0274 13.4676 56.0274 11.9647C56.0274 10.477 54.8267 9.2995 53.3107 9.2995C51.7793 9.2995 50.5797 10.477 50.5797 11.9647C50.5797 13.4677 51.7793 14.6453 53.3107 14.6453ZM64.2061 11.3447C64.2061 10.2448 63.2272 9.28381 62.1059 9.28381C61.0164 9.28381 60.0057 9.71776 60.0057 11.2673V15.2806C60.0057 15.6215 59.6743 15.9158 59.3424 15.9158C58.979 15.9158 58.6638 15.6215 58.6638 15.2806V8.67944C58.6638 8.3385 58.979 8.04416 59.3424 8.04416C59.6583 8.04416 59.99 8.32305 60.0057 8.64849C60.5745 8.2143 61.3008 7.9823 62.0897 7.9823C63.9215 7.9823 65.548 9.39256 65.548 11.1586V15.2805C65.548 15.6215 65.217 15.9158 64.8852 15.9158C64.5218 15.9158 64.2061 15.6215 64.2061 15.2805V11.3447ZM16.0214 11.7479C15.9899 9.7178 14.1428 7.9823 11.9637 7.9823C9.68965 7.9823 7.87405 9.7644 7.87405 11.9647C7.87405 14.1961 9.68965 15.9777 11.9637 15.9777C13.053 15.9777 14.064 15.5594 14.7901 14.8468C14.9322 14.7228 15.0269 14.5368 15.0269 14.3508C15.0269 13.9946 14.7111 13.6846 14.3479 13.6846C14.1428 13.6846 13.9532 13.8085 13.8111 13.9482C13.353 14.4283 12.6742 14.6453 11.9637 14.6453C10.606 14.6453 9.50141 13.7321 9.2637 12.4619H15.3586C15.3631 12.4619 15.3671 12.4604 15.3716 12.4604H15.3901C15.4013 12.4593 15.4126 12.4555 15.4241 12.4537C15.4475 12.4504 15.4707 12.4471 15.4932 12.4405C15.781 12.3645 16.0214 12.0944 16.0214 11.7479ZM11.9637 9.29955C13.1881 9.29955 14.2054 10.0707 14.5525 11.1452H9.35866C9.70583 10.0706 10.7244 9.29955 11.9637 9.29955ZM40.2696 11.7479C40.2377 9.7178 38.3903 7.9823 36.2115 7.9823C33.9375 7.9823 32.121 9.7644 32.121 11.9647C32.121 14.1961 33.9375 15.9777 36.2115 15.9777C37.3008 15.9777 38.3115 15.5594 39.0376 14.8468C39.1799 14.7228 39.2745 14.5368 39.2745 14.3508C39.2745 13.9946 38.9588 13.6846 38.5959 13.6846C38.3903 13.6846 38.2005 13.8085 38.0587 13.9482C37.6007 14.4283 36.9217 14.6453 36.2115 14.6453C34.8539 14.6453 33.7488 13.7321 33.5113 12.4619H39.5959C39.6 12.4619 39.6045 12.4604 39.6085 12.4604H39.6376C39.6558 12.4589 39.6736 12.4533 39.6916 12.4498C39.7009 12.4478 39.7103 12.4471 39.7193 12.4445C40.0165 12.3771 40.2696 12.1028 40.2696 11.7479ZM36.2115 9.29955C37.4356 9.29955 38.4533 10.0707 38.8007 11.1452H33.6061C33.9532 10.0706 34.9718 9.29955 36.2115 9.29955ZM67.2416 14.4926C66.8315 14.4926 66.485 14.8224 66.485 15.2125C66.485 15.6026 66.8316 15.9323 67.2416 15.9323C67.6598 15.9323 68 15.6094 68 15.2125C68 14.8156 67.6598 14.4926 67.2416 14.4926ZM67.8673 15.2125C67.8673 15.5332 67.5866 15.794 67.2416 15.794C66.9039 15.794 66.6293 15.5331 66.6293 15.2125C66.6293 14.8919 66.9039 14.6311 67.2416 14.6311C67.5866 14.6311 67.8673 14.8919 67.8673 15.2125ZM67.365 15.28C67.4472 15.2311 67.4958 15.1445 67.4958 15.0453C67.4958 14.895 67.3792 14.7816 67.2243 14.7816H67.1151C67.0555 14.7816 67.0122 14.8276 67.0122 14.8908V15.5669C67.0122 15.6061 67.0462 15.638 67.0882 15.638C67.1304 15.638 67.1621 15.6075 67.1621 15.5669V15.3162H67.2188L67.3536 15.5985C67.3648 15.6226 67.3899 15.6381 67.4179 15.6381C67.4298 15.6381 67.4427 15.6352 67.4518 15.6309C67.4784 15.6207 67.4958 15.5963 67.4958 15.5688C67.4958 15.5602 67.4958 15.5505 67.4898 15.5386L67.365 15.28ZM67.3457 15.0453C67.3457 15.0466 67.3444 15.1724 67.2263 15.1724H67.1622V14.9237H67.2263C67.3444 14.9237 67.3457 15.0403 67.3457 15.0453Z",
                fill: "#1D4F91"
            }));
        case "equifax":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
                version: "1.1",
                id: "Layer_1",
                x: "0px",
                y: "0px",
                width: "75px",
                height: "14px",
                viewBox: "0 0 150 28"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                fill: "#9E1C33",
                d: "M145.6008,3.9214c0-0.3906,0.0977-0.7568,0.293-1.0986s0.4638-0.6113,0.8056-0.8086    s0.7099-0.2959,1.1044-0.2959c0.3886,0,0.7529,0.0967,1.0947,0.29c0.3398,0.1934,0.6093,0.4624,0.8085,0.8071    c0.1973,0.3447,0.2969,0.7134,0.2969,1.106c0,0.3887-0.0967,0.7529-0.289,1.0928s-0.458,0.6094-0.7978,0.8086    s-0.7109,0.2988-1.1132,0.2988c-0.4043,0-0.7773-0.1011-1.1191-0.3032s-0.6084-0.4722-0.7978-0.8101    C145.6955,4.6704,145.6008,4.3081,145.6008,3.9214z M145.9612,3.9214c0,0.3281,0.0811,0.6333,0.2431,0.9155    s0.3857,0.5073,0.6709,0.6753s0.5947,0.252,0.9287,0.252c0.3379,0,0.6494-0.085,0.9365-0.2549    c0.2851-0.1699,0.5078-0.396,0.666-0.6782s0.2373-0.5854,0.2373-0.9097c0-0.3223-0.0801-0.6255-0.2402-0.9097    c-0.1601-0.2842-0.3818-0.5107-0.667-0.6797c-0.2832-0.1689-0.5947-0.2534-0.9326-0.2534c-0.3281,0-0.6357,0.0825-0.9209,0.2476    c-0.2871,0.165-0.5117,0.3906-0.6758,0.6768S145.9612,3.5952,145.9612,3.9214z M148.7735,3.4058    c0,0.1621-0.0449,0.3037-0.1328,0.4248c-0.0898,0.1211-0.2168,0.2168-0.3828,0.2871l0.6181,1.0928h-0.5859l-0.5039-0.9521h-0.2666    v0.9521h-0.5215V2.6382h0.7881C148.4444,2.6382,148.7735,2.894,148.7735,3.4058z M147.5197,3.8364h0.2109    c0.164,0,0.29-0.0352,0.3779-0.1055c0.0879-0.0703,0.1318-0.167,0.1318-0.29c0-0.1426-0.0449-0.2412-0.1328-0.2959    c-0.0898-0.0547-0.2148-0.082-0.3769-0.082h-0.2109V3.8364z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("polygon", {
                fill: "#9E1C33",
                points: "19.8029,12.1 20.7028,7.9 11.6033,7.9 12.4033,4.3 22.8027,4.3 23.7027,0 4.8037,0 0.0039,21.2     19.5029,21.2 20.4028,16.7 9.7034,16.7 10.7033,12.1   "
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                fill: "#9E1C33",
                d: "M45.1016,12.1c0.4-2,0.7-3.9,0.7-3.9c1.1999-6.6-5.3997-6.6-9.5995-6.7c-6.0997-0.2-11.2994-0.2-13.1993,7.3    c0,0-0.9999,3.9-1.1999,6.9c-0.3,6.1,6.1997,5.9,9.6995,6.1c3.4998,0.1,5.6997-0.6,5.6997-0.6l5.7997,6.8h8.7995L38.5019,12.1    H45.1016z M38.3019,8.5c0,0-0.5,3.6-1.7999,7.2c-0.6,1.7-2.5999,2.6-4.0998,2.6c-1.6999,0-3.5998-0.9-3.0998-3.4    c0,0,0.5-3.4,1.7999-7.2c0,0,1.0999-2.8,4.0998-2.6C35.2021,5.1,39.0019,4.5,38.3019,8.5z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                fill: "#9E1C33",
                d: "M63.3006,2.4l-3.0998,13.7c-0.6,2.5-3.6998,2.1-3.6998,2.1c-2.3999,0-2.3999-2.2-2.3999-2.2    c0.5-2.7,2.9998-13.5,2.9998-13.5h-7.6996c-0.6,2.2-2.4999,10.9-2.4999,10.9l7.0996,8.3C56.001,22,57.8009,22,58.8008,22    c5.8997-0.3,8.4996-2.6,8.9995-4.3c0.5-1.7,3.4998-15.2,3.4998-15.2h-7.9996C63.3006,2.5,63.3006,2.4,63.3006,2.4z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("polygon", {
                fill: "#9E1C33",
                points: "74.0001,2.4 69.9003,21.2 77.5999,21.2 81.8996,2.4   "
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("polygon", {
                fill: "#9E1C33",
                points: "98.7988,9.5 91.0992,9.5 91.9991,6 100.8987,6 101.7986,2.4 84.7995,2.4 80.6997,21.2 88.4993,21.2     90.3992,13.1 97.9988,13.1   "
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                fill: "#9E1C33",
                d: "M136.2968,2.4l-4.8997,4.8l-2.9998-4.8h-9.9995l6.1997,9.4l-6.2997,5.8l-1.8999-15.2h-9.3995L93.699,21.2    h5.4997l2.7999-4.2h8.1996l0.4,4.1h11.6994l5.3997-5.6l3.2998,5.6h9.5995l-6.5997-10l9.8995-8.7    C143.8964,2.4,136.2968,2.4,136.2968,2.4z M104.5985,13l4.2998-6.2l0.6,6.2H104.5985z"
            }))));
        case "mastercard":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
                width: "41.6px",
                height: "25.6px",
                viewBox: "0 0 52 32",
                version: "1.1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("g", {
                id: "Components---Sprint-3",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("rect", {
                width: "52",
                height: "32",
                fill: "#141413"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("g", {
                id: "assets-/-logo-/-mastercard-/-symbol"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("polygon", {
                id: "Fill-1",
                fill: "#FF5F00",
                points: "18.7752605 28.537934 32.6926792 28.537934 32.6926792 3.41596003 18.7752605 3.41596003"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M19.6590387,15.976947 C19.6590387,10.8803009 22.03472,6.34107274 25.7341024,3.41596003 C23.0283795,1.27638054 19.6148564,0 15.9044284,0 C7.12054904,0 0.000132546844,7.15323422 0.000132546844,15.976947 C0.000132546844,24.8006598 7.12054904,31.953894 15.9044284,31.953894 C19.6148564,31.953894 23.0283795,30.6775135 25.7341024,28.537934 C22.03472,25.6123775 19.6590387,21.0735931 19.6590387,15.976947",
                id: "Fill-2",
                fill: "#EB001B"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M50.9714634,25.8771954 L50.9714634,25.257201 L50.8101981,25.257201 L50.6250744,25.6836968 L50.4395088,25.257201 L50.2782434,25.257201 L50.2782434,25.8771954 L50.3917919,25.8771954 L50.3917919,25.4094258 L50.5658701,25.8128438 L50.6838368,25.8128438 L50.857915,25.4085382 L50.857915,25.8771954 L50.9714634,25.8771954 Z M49.9504109,25.8771954 L49.9504109,25.3628264 L50.157184,25.3628264 L50.157184,25.2580887 L49.6314148,25.2580887 L49.6314148,25.3628264 L49.8377461,25.3628264 L49.8377461,25.8771954 L49.9504109,25.8771954 Z M51.4680723,15.9768139 C51.4680723,24.8005266 44.347214,31.9537609 35.5637764,31.9537609 C31.8533484,31.9537609 28.4393835,30.6773803 25.7341024,28.5378008 C29.4334848,25.6126881 31.8091661,21.07346 31.8091661,15.9768139 C31.8091661,10.8806116 29.4334848,6.34138341 25.7341024,3.41582689 C28.4393835,1.2762474 31.8533484,-0.000133141225 35.5637764,-0.000133141225 C44.347214,-0.000133141225 51.4680723,7.15310107 51.4680723,15.9768139 L51.4680723,15.9768139 Z",
                id: "Fill-4",
                fill: "#F79E1B"
            }))));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "47",
                height: "25",
                viewBox: "0 0 47 25",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("g", {
                "clip-path": "url(#clip0_1343_7752)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M23.4972 0.938701V5.82431C21.2642 2.3271 17.3018 0 12.7779 0C5.80253 0 0.146484 5.54488 0.146484 12.3778C0.146484 19.2106 5.80253 24.7555 12.7823 24.7555C17.3018 24.7555 21.2686 22.4284 23.5016 18.9312V23.8168H46.8568V0.938701H23.4972Z",
                fill: "#2A0062"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M8.41834 14.9714C9.95158 14.9714 10.9723 14.0851 10.9723 12.8888C10.9723 11.7493 10.1923 11.1381 8.73034 10.8543C7.86121 10.6927 6.98762 10.4089 6.98762 9.71472C6.98762 9.26065 7.4155 8.87207 8.18657 8.87207C8.95765 8.87207 9.63959 9.22572 9.63959 9.77148C9.63959 9.90682 9.60393 9.99851 9.56827 10.112L10.6112 10.4657C10.7271 10.2605 10.8118 10.0116 10.8118 9.72345C10.8118 8.59701 9.75547 7.82422 8.29355 7.82422C6.84053 7.82422 5.89117 8.71053 5.89117 9.71035C5.89117 10.9852 6.85391 11.5878 8.35149 11.8279C9.46576 12.0244 9.81341 12.3955 9.81341 12.9194C9.81341 13.487 9.29193 13.9105 8.43171 13.9105C7.6339 13.9105 6.89848 13.5699 6.89848 12.8757C6.89848 12.7622 6.92076 12.6356 6.95642 12.5003L5.91346 12.0811C5.80649 12.2776 5.71289 12.557 5.71289 12.8452C5.7218 14.1288 6.74694 14.9714 8.41834 14.9714Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M11.8008 8.80616C11.8008 9.18164 12.0905 9.46543 12.4738 9.46543C12.8571 9.46543 13.1602 9.18164 13.1602 8.80616C13.1602 8.43068 12.8616 8.13379 12.4738 8.13379C12.0949 8.13379 11.8008 8.43068 11.8008 8.80616Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M13.0095 10.1689H11.9531V14.8668H13.0095V10.1689Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M16.2988 13.9716C15.5188 13.9716 14.9171 13.439 14.9171 12.5395C14.9171 11.5485 15.5232 10.959 16.2988 10.959C17.0877 10.959 17.6805 11.5965 17.6805 12.4697C17.676 13.3473 17.0743 13.9716 16.2988 13.9716ZM17.6314 10.16V10.7975C17.3328 10.3522 16.8737 10.0684 16.1116 10.0684C14.8457 10.0684 13.834 11.0464 13.834 12.5352C13.834 13.9672 14.7967 14.8666 16.0046 14.8666C16.8158 14.8666 17.3729 14.5261 17.6181 14.024V14.5261C17.6181 15.4124 17.2704 16.0368 16.3522 16.0368C15.6881 16.0368 15.1889 15.7093 15.0374 15.0719L14.0747 15.4692C14.4223 16.5039 15.238 16.9362 16.3522 16.9362C17.8721 16.9362 18.6744 15.9145 18.6744 14.4781V10.1557H17.6314V10.16Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M20.8359 12.2427C20.8359 11.4131 21.3484 10.9547 21.9724 10.9547C22.5652 10.9547 22.9575 11.3738 22.9575 12.151V14.871H24.0138V11.7973C24.0138 10.6927 23.3051 10.0684 22.329 10.0684C21.7362 10.0684 21.1791 10.2867 20.818 10.8499V10.1644H19.7617V14.8623H20.818V12.2339L20.8359 12.2427Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M28.0034 12.4832C28.0034 11.4485 28.7611 10.9595 29.4207 10.9595C30.1294 10.9595 30.642 11.3917 30.7356 12.0859L31.6983 11.7934C31.4978 10.7019 30.584 10.0645 29.4207 10.0645C28.1059 10.0645 26.9961 11.0424 26.9961 12.4876C26.9961 13.9764 28.0079 14.9675 29.5723 14.9675C30.7356 14.9675 31.6983 14.317 31.9524 13.0814L30.9896 12.7408C30.8827 13.435 30.4771 14.0812 29.5277 14.0812C28.77 14.0769 28.0034 13.47 28.0034 12.4832Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M34.9103 14.0375C34.1526 14.0375 33.4841 13.4568 33.4841 12.5356C33.4841 11.6143 34.1482 10.9987 34.9103 10.9987C35.619 10.9987 36.35 11.5794 36.35 12.5356C36.3366 13.4917 35.6101 14.0375 34.9103 14.0375ZM36.3054 10.1561V10.9201C36.0291 10.3875 35.4586 10.0557 34.6919 10.0557C33.3593 10.0557 32.4277 11.0904 32.4277 12.5356C32.4277 13.924 33.3816 14.9587 34.6919 14.9587C35.4229 14.9587 35.98 14.6662 36.3633 14.0724V14.867H37.3751V10.1561H36.3054Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M40.7183 14.9623C41.6231 14.9623 42.2382 14.4165 42.3318 13.4734L41.32 13.277C41.2844 13.8227 41.0615 14.0716 40.6559 14.0716C40.3573 14.0716 40.0498 13.8751 40.0498 13.421V11.0546H41.8727V10.1552H40.0498V8.65332H38.9979V10.1552H38.0352V11.0415H38.9979V13.3687C38.989 14.3117 39.5461 14.9623 40.7183 14.9623Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M24.9551 8.80616C24.9551 9.18164 25.2448 9.46543 25.6281 9.46543C26.0114 9.46543 26.3145 9.18164 26.3145 8.80616C26.3145 8.43068 26.0159 8.13379 25.6281 8.13379C25.2448 8.13379 24.9551 8.43068 24.9551 8.80616Z",
                fill: "white"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
                d: "M26.1618 10.1689H25.1055V14.8668H26.1618V10.1689Z",
                fill: "white"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("clipPath", {
                id: "clip0_1343_7752"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("rect", {
                width: "47",
                height: "25",
                fill: "white"
            }))));
    }
};



var $hJwnw = parcelRequire("hJwnw");

function $1fd7258a1b64df0b$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $04b2743fa679cb39$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $04b2743fa679cb39$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1fd7258a1b64df0b$export$2e2bcd8739ae039)(function(prop) {
    return $04b2743fa679cb39$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $hJwnw = parcelRequire("hJwnw");
var $98c7de0fc517b2f6$exports = {};
//
$98c7de0fc517b2f6$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $e641b86c6772ae4d$export$71ad59f2e432cfe8 = "-ms-";
var $e641b86c6772ae4d$export$2c0f367103c8d01c = "-moz-";
var $e641b86c6772ae4d$export$39dfd62a25e0fe93 = "-webkit-";
var $e641b86c6772ae4d$export$a29989082612d0d9 = "comm";
var $e641b86c6772ae4d$export$aa3a2e812ca8570d = "rule";
var $e641b86c6772ae4d$export$527d108ccf083c2b = "decl";
var $e641b86c6772ae4d$export$d3d35020fa5b54f0 = "@page";
var $e641b86c6772ae4d$export$500415a86c544f73 = "@media";
var $e641b86c6772ae4d$export$a763edbf796b780a = "@import";
var $e641b86c6772ae4d$export$2790aeb8b4e5c826 = "@charset";
var $e641b86c6772ae4d$export$1cc683e23b84b133 = "@viewport";
var $e641b86c6772ae4d$export$9447a5efea57e862 = "@supports";
var $e641b86c6772ae4d$export$ef011b4e114b1fba = "@document";
var $e641b86c6772ae4d$export$6aad947bda0f3f46 = "@namespace";
var $e641b86c6772ae4d$export$b44a8529a35fcb60 = "@keyframes";
var $e641b86c6772ae4d$export$2c16de31893252e6 = "@font-face";
var $e641b86c6772ae4d$export$3d846dd52e150c6f = "@counter-style";
var $e641b86c6772ae4d$export$22314bfbb57653fe = "@font-feature-values";
var $e641b86c6772ae4d$export$d773506282b3cfe6 = "@layer";
var $e641b86c6772ae4d$export$1c5a554c78c0cd12 = "@scope";
var $e641b86c6772ae4d$export$2335f513bbd82c6d = Math.abs;
var $e641b86c6772ae4d$export$6788812c4e6611e6 = String.fromCharCode;
var $e641b86c6772ae4d$export$e6e34fd1f2686227 = Object.assign;
function $e641b86c6772ae4d$export$d6af199866bfb566(e, r) {
    return $e641b86c6772ae4d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e641b86c6772ae4d$export$a9db5e087081082d(e, 0)) << 2 ^ $e641b86c6772ae4d$export$a9db5e087081082d(e, 1)) << 2 ^ $e641b86c6772ae4d$export$a9db5e087081082d(e, 2)) << 2 ^ $e641b86c6772ae4d$export$a9db5e087081082d(e, 3) : 0;
}
function $e641b86c6772ae4d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e641b86c6772ae4d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e641b86c6772ae4d$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $e641b86c6772ae4d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e641b86c6772ae4d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e641b86c6772ae4d$export$36776f635604f274(e) {
    return e.length;
}
function $e641b86c6772ae4d$export$f9084667e487ed46(e) {
    return e.length;
}
function $e641b86c6772ae4d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e641b86c6772ae4d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $e641b86c6772ae4d$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$e641b86c6772ae4d$export$4659b591c19bdf3d(e, r);
    });
}
var $e641b86c6772ae4d$export$53f1d5ea8de3d7c = 1;
var $e641b86c6772ae4d$export$4e0c71f277ca26b3 = 1;
var $e641b86c6772ae4d$export$f24224f1c91d8156 = 0;
var $e641b86c6772ae4d$export$5880b8b5730aff45 = 0;
var $e641b86c6772ae4d$export$c0306caf338ac095 = 0;
var $e641b86c6772ae4d$export$30a86d91af8ff6e6 = "";
function $e641b86c6772ae4d$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e641b86c6772ae4d$export$53f1d5ea8de3d7c,
        column: $e641b86c6772ae4d$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $e641b86c6772ae4d$export$784d13d8ee351f07(e, r) {
    return $e641b86c6772ae4d$export$e6e34fd1f2686227($e641b86c6772ae4d$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $e641b86c6772ae4d$export$590e8b2c435046d9(e) {
    while(e.root)e = $e641b86c6772ae4d$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $e641b86c6772ae4d$export$10d8903dec122b9d(e, e.siblings);
}
function $e641b86c6772ae4d$export$eba6f6f03b0a92e7() {
    return $e641b86c6772ae4d$export$c0306caf338ac095;
}
function $e641b86c6772ae4d$export$232faf9add678146() {
    $e641b86c6772ae4d$export$c0306caf338ac095 = $e641b86c6772ae4d$export$5880b8b5730aff45 > 0 ? $e641b86c6772ae4d$export$a9db5e087081082d($e641b86c6772ae4d$export$30a86d91af8ff6e6, --$e641b86c6772ae4d$export$5880b8b5730aff45) : 0;
    if ($e641b86c6772ae4d$export$4e0c71f277ca26b3--, $e641b86c6772ae4d$export$c0306caf338ac095 === 10) $e641b86c6772ae4d$export$4e0c71f277ca26b3 = 1, $e641b86c6772ae4d$export$53f1d5ea8de3d7c--;
    return $e641b86c6772ae4d$export$c0306caf338ac095;
}
function $e641b86c6772ae4d$export$48cfd1e771a65c4f() {
    $e641b86c6772ae4d$export$c0306caf338ac095 = $e641b86c6772ae4d$export$5880b8b5730aff45 < $e641b86c6772ae4d$export$f24224f1c91d8156 ? $e641b86c6772ae4d$export$a9db5e087081082d($e641b86c6772ae4d$export$30a86d91af8ff6e6, $e641b86c6772ae4d$export$5880b8b5730aff45++) : 0;
    if ($e641b86c6772ae4d$export$4e0c71f277ca26b3++, $e641b86c6772ae4d$export$c0306caf338ac095 === 10) $e641b86c6772ae4d$export$4e0c71f277ca26b3 = 1, $e641b86c6772ae4d$export$53f1d5ea8de3d7c++;
    return $e641b86c6772ae4d$export$c0306caf338ac095;
}
function $e641b86c6772ae4d$export$4d3fb11e950abb9e() {
    return $e641b86c6772ae4d$export$a9db5e087081082d($e641b86c6772ae4d$export$30a86d91af8ff6e6, $e641b86c6772ae4d$export$5880b8b5730aff45);
}
function $e641b86c6772ae4d$export$e88cb2efb12ae807() {
    return $e641b86c6772ae4d$export$5880b8b5730aff45;
}
function $e641b86c6772ae4d$export$58adb3bec8346d0f(e, r) {
    return $e641b86c6772ae4d$export$2f35ab04d2335697($e641b86c6772ae4d$export$30a86d91af8ff6e6, e, r);
}
function $e641b86c6772ae4d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e641b86c6772ae4d$export$2de70f21292aac9e(e) {
    return $e641b86c6772ae4d$export$53f1d5ea8de3d7c = $e641b86c6772ae4d$export$4e0c71f277ca26b3 = 1, $e641b86c6772ae4d$export$f24224f1c91d8156 = $e641b86c6772ae4d$export$36776f635604f274($e641b86c6772ae4d$export$30a86d91af8ff6e6 = e), $e641b86c6772ae4d$export$5880b8b5730aff45 = 0, [];
}
function $e641b86c6772ae4d$export$45918ac1574455b1(e) {
    return $e641b86c6772ae4d$export$30a86d91af8ff6e6 = "", e;
}
function $e641b86c6772ae4d$export$410ac95b9ec204b8(e) {
    return $e641b86c6772ae4d$export$87c2784dc9fc4ab($e641b86c6772ae4d$export$58adb3bec8346d0f($e641b86c6772ae4d$export$5880b8b5730aff45 - 1, $e641b86c6772ae4d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e641b86c6772ae4d$export$660b2ee2d4fb4eff(e) {
    return $e641b86c6772ae4d$export$45918ac1574455b1($e641b86c6772ae4d$export$5f8c09e3ae6f64e1($e641b86c6772ae4d$export$2de70f21292aac9e(e)));
}
function $e641b86c6772ae4d$export$7af1228ff777d175(e) {
    while($e641b86c6772ae4d$export$c0306caf338ac095 = $e641b86c6772ae4d$export$4d3fb11e950abb9e())if ($e641b86c6772ae4d$export$c0306caf338ac095 < 33) $e641b86c6772ae4d$export$48cfd1e771a65c4f();
    else break;
    return $e641b86c6772ae4d$export$9e1725a4cfeada27(e) > 2 || $e641b86c6772ae4d$export$9e1725a4cfeada27($e641b86c6772ae4d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e641b86c6772ae4d$export$5f8c09e3ae6f64e1(e) {
    while($e641b86c6772ae4d$export$48cfd1e771a65c4f())switch($e641b86c6772ae4d$export$9e1725a4cfeada27($e641b86c6772ae4d$export$c0306caf338ac095)){
        case 0:
            $e641b86c6772ae4d$export$10d8903dec122b9d($e641b86c6772ae4d$export$c2ab62c7bf24634($e641b86c6772ae4d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e641b86c6772ae4d$export$10d8903dec122b9d($e641b86c6772ae4d$export$410ac95b9ec204b8($e641b86c6772ae4d$export$c0306caf338ac095), e);
            break;
        default:
            $e641b86c6772ae4d$export$10d8903dec122b9d($e641b86c6772ae4d$export$6788812c4e6611e6($e641b86c6772ae4d$export$c0306caf338ac095), e);
    }
    return e;
}
function $e641b86c6772ae4d$export$955ba06d119e085e(e, r) {
    while(--r && $e641b86c6772ae4d$export$48cfd1e771a65c4f())if ($e641b86c6772ae4d$export$c0306caf338ac095 < 48 || $e641b86c6772ae4d$export$c0306caf338ac095 > 102 || $e641b86c6772ae4d$export$c0306caf338ac095 > 57 && $e641b86c6772ae4d$export$c0306caf338ac095 < 65 || $e641b86c6772ae4d$export$c0306caf338ac095 > 70 && $e641b86c6772ae4d$export$c0306caf338ac095 < 97) break;
    return $e641b86c6772ae4d$export$58adb3bec8346d0f(e, $e641b86c6772ae4d$export$e88cb2efb12ae807() + (r < 6 && $e641b86c6772ae4d$export$4d3fb11e950abb9e() == 32 && $e641b86c6772ae4d$export$48cfd1e771a65c4f() == 32));
}
function $e641b86c6772ae4d$export$c889f2fcc19dbf12(e) {
    while($e641b86c6772ae4d$export$48cfd1e771a65c4f())switch($e641b86c6772ae4d$export$c0306caf338ac095){
        case e:
            return $e641b86c6772ae4d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e641b86c6772ae4d$export$c889f2fcc19dbf12($e641b86c6772ae4d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e641b86c6772ae4d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e641b86c6772ae4d$export$48cfd1e771a65c4f();
            break;
    }
    return $e641b86c6772ae4d$export$5880b8b5730aff45;
}
function $e641b86c6772ae4d$export$4254d4e2b3745c4c(e, r) {
    while($e641b86c6772ae4d$export$48cfd1e771a65c4f())if (e + $e641b86c6772ae4d$export$c0306caf338ac095 === 57) break;
    else if (e + $e641b86c6772ae4d$export$c0306caf338ac095 === 84 && $e641b86c6772ae4d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e641b86c6772ae4d$export$58adb3bec8346d0f(r, $e641b86c6772ae4d$export$5880b8b5730aff45 - 1) + "*" + $e641b86c6772ae4d$export$6788812c4e6611e6(e === 47 ? e : $e641b86c6772ae4d$export$48cfd1e771a65c4f());
}
function $e641b86c6772ae4d$export$c2ab62c7bf24634(e) {
    while(!$e641b86c6772ae4d$export$9e1725a4cfeada27($e641b86c6772ae4d$export$4d3fb11e950abb9e()))$e641b86c6772ae4d$export$48cfd1e771a65c4f();
    return $e641b86c6772ae4d$export$58adb3bec8346d0f(e, $e641b86c6772ae4d$export$5880b8b5730aff45);
}
function $e641b86c6772ae4d$export$ef7acd7185315e22(e) {
    return $e641b86c6772ae4d$export$45918ac1574455b1($e641b86c6772ae4d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e641b86c6772ae4d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e641b86c6772ae4d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $e641b86c6772ae4d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e641b86c6772ae4d$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($e641b86c6772ae4d$export$f8e21b1e77979a08(z += $e641b86c6772ae4d$export$77ad94ebf1c2b9ed($e641b86c6772ae4d$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $e641b86c6772ae4d$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $e641b86c6772ae4d$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $e641b86c6772ae4d$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $e641b86c6772ae4d$export$955ba06d119e085e($e641b86c6772ae4d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e641b86c6772ae4d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e641b86c6772ae4d$export$10d8903dec122b9d($e641b86c6772ae4d$export$4a34f930e789283c($e641b86c6772ae4d$export$4254d4e2b3745c4c($e641b86c6772ae4d$export$48cfd1e771a65c4f(), $e641b86c6772ae4d$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e641b86c6772ae4d$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $e641b86c6772ae4d$export$36776f635604f274(z) - l) $e641b86c6772ae4d$export$10d8903dec122b9d(p > 32 ? $e641b86c6772ae4d$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $e641b86c6772ae4d$export$f8483753829ec8f3($e641b86c6772ae4d$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $e641b86c6772ae4d$export$10d8903dec122b9d(j = $e641b86c6772ae4d$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $e641b86c6772ae4d$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $e641b86c6772ae4d$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e641b86c6772ae4d$export$98e6a39c04603d36(e, j, j, n && $e641b86c6772ae4d$export$10d8903dec122b9d($e641b86c6772ae4d$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $e641b86c6772ae4d$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $e641b86c6772ae4d$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $e641b86c6772ae4d$export$232faf9add678146() == 125) continue;
            }
            switch(z += $e641b86c6772ae4d$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e641b86c6772ae4d$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e641b86c6772ae4d$export$4d3fb11e950abb9e() === 45) z += $e641b86c6772ae4d$export$410ac95b9ec204b8($e641b86c6772ae4d$export$48cfd1e771a65c4f());
                    v = $e641b86c6772ae4d$export$4d3fb11e950abb9e(), o = l = $e641b86c6772ae4d$export$36776f635604f274(k = z += $e641b86c6772ae4d$export$c2ab62c7bf24634($e641b86c6772ae4d$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $e641b86c6772ae4d$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $e641b86c6772ae4d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $e641b86c6772ae4d$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $e641b86c6772ae4d$export$2f35ab04d2335697(e, p + 1, p = $e641b86c6772ae4d$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $e641b86c6772ae4d$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $e641b86c6772ae4d$export$35059013cd4a06db(e, r, a, s === 0 ? $e641b86c6772ae4d$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $e641b86c6772ae4d$export$4a34f930e789283c(e, r, a, c) {
    return $e641b86c6772ae4d$export$35059013cd4a06db(e, r, a, $e641b86c6772ae4d$export$a29989082612d0d9, $e641b86c6772ae4d$export$6788812c4e6611e6($e641b86c6772ae4d$export$eba6f6f03b0a92e7()), $e641b86c6772ae4d$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $e641b86c6772ae4d$export$f8483753829ec8f3(e, r, a, n, c) {
    return $e641b86c6772ae4d$export$35059013cd4a06db(e, r, a, $e641b86c6772ae4d$export$527d108ccf083c2b, $e641b86c6772ae4d$export$2f35ab04d2335697(e, 0, n), $e641b86c6772ae4d$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $e641b86c6772ae4d$export$82e9f45cca5ba907(n, c, s) {
    switch($e641b86c6772ae4d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e641b86c6772ae4d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$2c0f367103c8d01c + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e641b86c6772ae4d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "box-$1$2" + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "flex-item-" + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e641b86c6772ae4d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "grid-row-" + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "flex-line-pack" + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "box-" + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e641b86c6772ae4d$export$39dfd62a25e0fe93 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed($e641b86c6772ae4d$export$77ad94ebf1c2b9ed($e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed($e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "box-pack:$3" + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e641b86c6772ae4d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "grid-column-align" + $e641b86c6772ae4d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e641b86c6772ae4d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e641b86c6772ae4d$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e641b86c6772ae4d$export$f8e21b1e77979a08(s, "span", 0) ? $e641b86c6772ae4d$export$4659b591c19bdf3d(s, /\d+/) : +$e641b86c6772ae4d$export$4659b591c19bdf3d(s, /\d+/) - +$e641b86c6772ae4d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e641b86c6772ae4d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e641b86c6772ae4d$export$71ad59f2e432cfe8 + $e641b86c6772ae4d$export$77ad94ebf1c2b9ed($e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e641b86c6772ae4d$export$36776f635604f274(n) - 1 - c > 6) switch($e641b86c6772ae4d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e641b86c6772ae4d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e641b86c6772ae4d$export$2c0f367103c8d01c + ($e641b86c6772ae4d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e641b86c6772ae4d$export$f8e21b1e77979a08(n, "stretch", 0) ? $e641b86c6772ae4d$export$82e9f45cca5ba907($e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e641b86c6772ae4d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e641b86c6772ae4d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e641b86c6772ae4d$export$a9db5e087081082d(n, c + 6) === 121) return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, ":", ":" + $e641b86c6772ae4d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e641b86c6772ae4d$export$a9db5e087081082d(n, $e641b86c6772ae4d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + ($e641b86c6772ae4d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, ":", ":" + $e641b86c6772ae4d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e641b86c6772ae4d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $e641b86c6772ae4d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e641b86c6772ae4d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e641b86c6772ae4d$export$a763edbf796b780a:
        case $e641b86c6772ae4d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e641b86c6772ae4d$export$a29989082612d0d9:
            return "";
        case $e641b86c6772ae4d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e641b86c6772ae4d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e641b86c6772ae4d$export$aa3a2e812ca8570d:
            if (!$e641b86c6772ae4d$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $e641b86c6772ae4d$export$36776f635604f274(a = $e641b86c6772ae4d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e641b86c6772ae4d$export$5a7767152ae0305f(e) {
    var r = $e641b86c6772ae4d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e641b86c6772ae4d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e641b86c6772ae4d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e641b86c6772ae4d$export$527d108ccf083c2b:
                n.return = $e641b86c6772ae4d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e641b86c6772ae4d$export$b44a8529a35fcb60:
                return $e641b86c6772ae4d$export$dfdc1655ccc5b9cb([
                    $e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                        value: $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e641b86c6772ae4d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e641b86c6772ae4d$export$aa3a2e812ca8570d:
                if (n.length) return $e641b86c6772ae4d$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($e641b86c6772ae4d$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $e641b86c6772ae4d$export$590e8b2c435046d9($e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                                props: [
                                    $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e641b86c6772ae4d$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $e641b86c6772ae4d$export$590e8b2c435046d9($e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $e641b86c6772ae4d$export$e6e34fd1f2686227(n, {
                                props: $e641b86c6772ae4d$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $e641b86c6772ae4d$export$590e8b2c435046d9($e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                                props: [
                                    $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e641b86c6772ae4d$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $e641b86c6772ae4d$export$590e8b2c435046d9($e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                                props: [
                                    $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e641b86c6772ae4d$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $e641b86c6772ae4d$export$590e8b2c435046d9($e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                                props: [
                                    $e641b86c6772ae4d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e641b86c6772ae4d$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $e641b86c6772ae4d$export$590e8b2c435046d9($e641b86c6772ae4d$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $e641b86c6772ae4d$export$e6e34fd1f2686227(n, {
                                props: $e641b86c6772ae4d$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $e641b86c6772ae4d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e641b86c6772ae4d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e641b86c6772ae4d$export$1be1fc439b849fdf($e641b86c6772ae4d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e641b86c6772ae4d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e641b86c6772ae4d$export$2f35ab04d2335697(r, 1, $e641b86c6772ae4d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e641b86c6772ae4d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e641b86c6772ae4d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e641b86c6772ae4d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $0f17ddb1350be779$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $fab343f1a5ab9ec7$exports = {};
// shim for using process in browser
var $fab343f1a5ab9ec7$var$process = $fab343f1a5ab9ec7$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fab343f1a5ab9ec7$var$cachedSetTimeout;
var $fab343f1a5ab9ec7$var$cachedClearTimeout;
function $fab343f1a5ab9ec7$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $fab343f1a5ab9ec7$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $fab343f1a5ab9ec7$var$cachedSetTimeout = setTimeout;
        else $fab343f1a5ab9ec7$var$cachedSetTimeout = $fab343f1a5ab9ec7$var$defaultSetTimout;
    } catch (e) {
        $fab343f1a5ab9ec7$var$cachedSetTimeout = $fab343f1a5ab9ec7$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $fab343f1a5ab9ec7$var$cachedClearTimeout = clearTimeout;
        else $fab343f1a5ab9ec7$var$cachedClearTimeout = $fab343f1a5ab9ec7$var$defaultClearTimeout;
    } catch (e) {
        $fab343f1a5ab9ec7$var$cachedClearTimeout = $fab343f1a5ab9ec7$var$defaultClearTimeout;
    }
})();
function $fab343f1a5ab9ec7$var$runTimeout(fun) {
    if ($fab343f1a5ab9ec7$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fab343f1a5ab9ec7$var$cachedSetTimeout === $fab343f1a5ab9ec7$var$defaultSetTimout || !$fab343f1a5ab9ec7$var$cachedSetTimeout) && setTimeout) {
        $fab343f1a5ab9ec7$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fab343f1a5ab9ec7$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fab343f1a5ab9ec7$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fab343f1a5ab9ec7$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fab343f1a5ab9ec7$var$runClearTimeout(marker) {
    if ($fab343f1a5ab9ec7$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fab343f1a5ab9ec7$var$cachedClearTimeout === $fab343f1a5ab9ec7$var$defaultClearTimeout || !$fab343f1a5ab9ec7$var$cachedClearTimeout) && clearTimeout) {
        $fab343f1a5ab9ec7$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fab343f1a5ab9ec7$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fab343f1a5ab9ec7$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fab343f1a5ab9ec7$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fab343f1a5ab9ec7$var$queue = [];
var $fab343f1a5ab9ec7$var$draining = false;
var $fab343f1a5ab9ec7$var$currentQueue;
var $fab343f1a5ab9ec7$var$queueIndex = -1;
function $fab343f1a5ab9ec7$var$cleanUpNextTick() {
    if (!$fab343f1a5ab9ec7$var$draining || !$fab343f1a5ab9ec7$var$currentQueue) return;
    $fab343f1a5ab9ec7$var$draining = false;
    if ($fab343f1a5ab9ec7$var$currentQueue.length) $fab343f1a5ab9ec7$var$queue = $fab343f1a5ab9ec7$var$currentQueue.concat($fab343f1a5ab9ec7$var$queue);
    else $fab343f1a5ab9ec7$var$queueIndex = -1;
    if ($fab343f1a5ab9ec7$var$queue.length) $fab343f1a5ab9ec7$var$drainQueue();
}
function $fab343f1a5ab9ec7$var$drainQueue() {
    if ($fab343f1a5ab9ec7$var$draining) return;
    var timeout = $fab343f1a5ab9ec7$var$runTimeout($fab343f1a5ab9ec7$var$cleanUpNextTick);
    $fab343f1a5ab9ec7$var$draining = true;
    var len = $fab343f1a5ab9ec7$var$queue.length;
    while(len){
        $fab343f1a5ab9ec7$var$currentQueue = $fab343f1a5ab9ec7$var$queue;
        $fab343f1a5ab9ec7$var$queue = [];
        while(++$fab343f1a5ab9ec7$var$queueIndex < len)if ($fab343f1a5ab9ec7$var$currentQueue) $fab343f1a5ab9ec7$var$currentQueue[$fab343f1a5ab9ec7$var$queueIndex].run();
        $fab343f1a5ab9ec7$var$queueIndex = -1;
        len = $fab343f1a5ab9ec7$var$queue.length;
    }
    $fab343f1a5ab9ec7$var$currentQueue = null;
    $fab343f1a5ab9ec7$var$draining = false;
    $fab343f1a5ab9ec7$var$runClearTimeout(timeout);
}
$fab343f1a5ab9ec7$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fab343f1a5ab9ec7$var$queue.push(new $fab343f1a5ab9ec7$var$Item(fun, args));
    if ($fab343f1a5ab9ec7$var$queue.length === 1 && !$fab343f1a5ab9ec7$var$draining) $fab343f1a5ab9ec7$var$runTimeout($fab343f1a5ab9ec7$var$drainQueue);
};
// v8 likes predictible objects
function $fab343f1a5ab9ec7$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fab343f1a5ab9ec7$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fab343f1a5ab9ec7$var$process.title = "browser";
$fab343f1a5ab9ec7$var$process.browser = true;
$fab343f1a5ab9ec7$var$process.env = {};
$fab343f1a5ab9ec7$var$process.argv = [];
$fab343f1a5ab9ec7$var$process.version = ""; // empty string to avoid regexp issues
$fab343f1a5ab9ec7$var$process.versions = {};
function $fab343f1a5ab9ec7$var$noop() {}
$fab343f1a5ab9ec7$var$process.on = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.addListener = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.once = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.off = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.removeListener = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.removeAllListeners = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.emit = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.prependListener = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.prependOnceListener = $fab343f1a5ab9ec7$var$noop;
$fab343f1a5ab9ec7$var$process.listeners = function(name) {
    return [];
};
$fab343f1a5ab9ec7$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$fab343f1a5ab9ec7$var$process.cwd = function() {
    return "/";
};
$fab343f1a5ab9ec7$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$fab343f1a5ab9ec7$var$process.umask = function() {
    return 0;
};


var $aeb02c6ea4661e47$var$f = ("undefined" != typeof $fab343f1a5ab9ec7$exports && void 0 !== $fab343f1a5ab9ec7$exports.env && undefined, "data-styled"), $aeb02c6ea4661e47$var$m = "active", $aeb02c6ea4661e47$var$y = "data-styled-version", $aeb02c6ea4661e47$export$83d89fbfd8236492 = "6.1.12", $aeb02c6ea4661e47$var$g = "/*!sc*/\n", $aeb02c6ea4661e47$var$S = "undefined" != typeof window && "HTMLElement" in window, $aeb02c6ea4661e47$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $fab343f1a5ab9ec7$exports && $fab343f1a5ab9ec7$exports.env, "undefined" != typeof $fab343f1a5ab9ec7$exports && $fab343f1a5ab9ec7$exports.env, false)), $aeb02c6ea4661e47$var$b = {}, $aeb02c6ea4661e47$var$E = /invalid hook call/i, $aeb02c6ea4661e47$var$N = new Set, $aeb02c6ea4661e47$var$P = function(t, n) {
    var o, s, i, a, e;
}, $aeb02c6ea4661e47$var$_ = Object.freeze([]), $aeb02c6ea4661e47$var$C = Object.freeze({});
function $aeb02c6ea4661e47$var$I(e, t, n) {
    return void 0 === n && (n = $aeb02c6ea4661e47$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $aeb02c6ea4661e47$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $aeb02c6ea4661e47$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $aeb02c6ea4661e47$var$D = /(^-|-$)/g;
function $aeb02c6ea4661e47$var$R(e) {
    return e.replace($aeb02c6ea4661e47$var$O, "-").replace($aeb02c6ea4661e47$var$D, "");
}
var $aeb02c6ea4661e47$var$T = /(a)(d)/gi, $aeb02c6ea4661e47$var$k = 52, $aeb02c6ea4661e47$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $aeb02c6ea4661e47$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $aeb02c6ea4661e47$var$k; t = t / $aeb02c6ea4661e47$var$k | 0)n = $aeb02c6ea4661e47$var$j(t % $aeb02c6ea4661e47$var$k) + n;
    return ($aeb02c6ea4661e47$var$j(t % $aeb02c6ea4661e47$var$k) + n).replace($aeb02c6ea4661e47$var$T, "$1-$2");
}
var $aeb02c6ea4661e47$var$V, $aeb02c6ea4661e47$var$F = 5381, $aeb02c6ea4661e47$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $aeb02c6ea4661e47$var$z = function(e) {
    return $aeb02c6ea4661e47$var$M($aeb02c6ea4661e47$var$F, e);
};
function $aeb02c6ea4661e47$var$$(e) {
    return $aeb02c6ea4661e47$var$x($aeb02c6ea4661e47$var$z(e) >>> 0);
}
function $aeb02c6ea4661e47$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $aeb02c6ea4661e47$var$L(e) {
    return "string" == typeof e && true;
}
var $aeb02c6ea4661e47$var$G = "function" == typeof Symbol && Symbol.for, $aeb02c6ea4661e47$var$Y = $aeb02c6ea4661e47$var$G ? Symbol.for("react.memo") : 60115, $aeb02c6ea4661e47$var$W = $aeb02c6ea4661e47$var$G ? Symbol.for("react.forward_ref") : 60112, $aeb02c6ea4661e47$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $aeb02c6ea4661e47$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $aeb02c6ea4661e47$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $aeb02c6ea4661e47$var$J = (($aeb02c6ea4661e47$var$V = {})[$aeb02c6ea4661e47$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $aeb02c6ea4661e47$var$V[$aeb02c6ea4661e47$var$Y] = $aeb02c6ea4661e47$var$U, $aeb02c6ea4661e47$var$V);
function $aeb02c6ea4661e47$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $aeb02c6ea4661e47$var$Y ? $aeb02c6ea4661e47$var$U : "$$typeof" in e ? $aeb02c6ea4661e47$var$J[e.$$typeof] : $aeb02c6ea4661e47$var$q;
}
var $aeb02c6ea4661e47$var$Z = Object.defineProperty, $aeb02c6ea4661e47$var$K = Object.getOwnPropertyNames, $aeb02c6ea4661e47$var$Q = Object.getOwnPropertySymbols, $aeb02c6ea4661e47$var$ee = Object.getOwnPropertyDescriptor, $aeb02c6ea4661e47$var$te = Object.getPrototypeOf, $aeb02c6ea4661e47$var$ne = Object.prototype;
function $aeb02c6ea4661e47$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($aeb02c6ea4661e47$var$ne) {
            var o = $aeb02c6ea4661e47$var$te(t);
            o && o !== $aeb02c6ea4661e47$var$ne && $aeb02c6ea4661e47$var$oe(e, o, n);
        }
        var r = $aeb02c6ea4661e47$var$K(t);
        $aeb02c6ea4661e47$var$Q && (r = r.concat($aeb02c6ea4661e47$var$Q(t)));
        for(var s = $aeb02c6ea4661e47$var$X(e), i = $aeb02c6ea4661e47$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $aeb02c6ea4661e47$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $aeb02c6ea4661e47$var$ee(t, c);
                try {
                    $aeb02c6ea4661e47$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $aeb02c6ea4661e47$var$re(e) {
    return "function" == typeof e;
}
function $aeb02c6ea4661e47$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $aeb02c6ea4661e47$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $aeb02c6ea4661e47$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $aeb02c6ea4661e47$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $aeb02c6ea4661e47$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$aeb02c6ea4661e47$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $aeb02c6ea4661e47$var$le(e[o], t[o]);
    else if ($aeb02c6ea4661e47$var$ce(t)) for(var o in t)e[o] = $aeb02c6ea4661e47$var$le(e[o], t[o]);
    return e;
}
function $aeb02c6ea4661e47$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $aeb02c6ea4661e47$var$pe = {};
function $aeb02c6ea4661e47$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $aeb02c6ea4661e47$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $aeb02c6ea4661e47$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $aeb02c6ea4661e47$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($aeb02c6ea4661e47$var$g);
        return t;
    }, e;
}(), $aeb02c6ea4661e47$var$me = 1073741824, $aeb02c6ea4661e47$var$ye = new Map, $aeb02c6ea4661e47$var$ve = new Map, $aeb02c6ea4661e47$var$ge = 1, $aeb02c6ea4661e47$var$Se = function(e) {
    if ($aeb02c6ea4661e47$var$ye.has(e)) return $aeb02c6ea4661e47$var$ye.get(e);
    for(; $aeb02c6ea4661e47$var$ve.has($aeb02c6ea4661e47$var$ge);)$aeb02c6ea4661e47$var$ge++;
    var t = $aeb02c6ea4661e47$var$ge++;
    return $aeb02c6ea4661e47$var$ye.set(e, t), $aeb02c6ea4661e47$var$ve.set(t, e), t;
}, $aeb02c6ea4661e47$var$we = function(e, t) {
    $aeb02c6ea4661e47$var$ge = t + 1, $aeb02c6ea4661e47$var$ye.set(e, t), $aeb02c6ea4661e47$var$ve.set(t, e);
}, $aeb02c6ea4661e47$var$be = "style[".concat($aeb02c6ea4661e47$var$f, "][").concat($aeb02c6ea4661e47$var$y, '="').concat($aeb02c6ea4661e47$export$83d89fbfd8236492, '"]'), $aeb02c6ea4661e47$var$Ee = new RegExp("^".concat($aeb02c6ea4661e47$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $aeb02c6ea4661e47$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $aeb02c6ea4661e47$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($aeb02c6ea4661e47$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($aeb02c6ea4661e47$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($aeb02c6ea4661e47$var$we(u, l), $aeb02c6ea4661e47$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $aeb02c6ea4661e47$var$_e = function(e) {
    for(var t = document.querySelectorAll($aeb02c6ea4661e47$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($aeb02c6ea4661e47$var$f) !== $aeb02c6ea4661e47$var$m && ($aeb02c6ea4661e47$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $aeb02c6ea4661e47$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $aeb02c6ea4661e47$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($aeb02c6ea4661e47$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($aeb02c6ea4661e47$var$f, $aeb02c6ea4661e47$var$m), o.setAttribute($aeb02c6ea4661e47$var$y, $aeb02c6ea4661e47$export$83d89fbfd8236492);
    var i = $aeb02c6ea4661e47$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $aeb02c6ea4661e47$var$Ae = function() {
    function e(e) {
        this.element = $aeb02c6ea4661e47$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $aeb02c6ea4661e47$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $aeb02c6ea4661e47$var$Oe = function() {
    function e(e) {
        this.element = $aeb02c6ea4661e47$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $aeb02c6ea4661e47$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $aeb02c6ea4661e47$var$Re = $aeb02c6ea4661e47$var$S, $aeb02c6ea4661e47$var$Te = {
    isServer: !$aeb02c6ea4661e47$var$S,
    useCSSOMInjection: !$aeb02c6ea4661e47$var$w
}, $aeb02c6ea4661e47$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $aeb02c6ea4661e47$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, $aeb02c6ea4661e47$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $aeb02c6ea4661e47$var$S && $aeb02c6ea4661e47$var$Re && ($aeb02c6ea4661e47$var$Re = !1, $aeb02c6ea4661e47$var$_e(this)), $aeb02c6ea4661e47$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $aeb02c6ea4661e47$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($aeb02c6ea4661e47$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($aeb02c6ea4661e47$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $aeb02c6ea4661e47$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $aeb02c6ea4661e47$var$S && $aeb02c6ea4661e47$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $aeb02c6ea4661e47$var$De(n) : t ? new $aeb02c6ea4661e47$var$Ae(n) : new $aeb02c6ea4661e47$var$Oe(n);
        }(this.options), new $aeb02c6ea4661e47$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($aeb02c6ea4661e47$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($aeb02c6ea4661e47$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($aeb02c6ea4661e47$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $aeb02c6ea4661e47$var$je = /&/g, $aeb02c6ea4661e47$var$xe = /^\s*\/\/.*$/gm;
function $aeb02c6ea4661e47$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $aeb02c6ea4661e47$var$Ve(e.children, t)), e;
    });
}
function $aeb02c6ea4661e47$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $aeb02c6ea4661e47$var$C : e, s = r.options, i = void 0 === s ? $aeb02c6ea4661e47$var$C : s, a = r.plugins, c = void 0 === a ? $aeb02c6ea4661e47$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $e641b86c6772ae4d$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($aeb02c6ea4661e47$var$je, n).replace(o, l));
    }), i.prefix && u.push($e641b86c6772ae4d$export$e08c7d021b829b7a), u.push($e641b86c6772ae4d$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($aeb02c6ea4661e47$var$xe, ""), l = $e641b86c6772ae4d$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $aeb02c6ea4661e47$var$Ve(l, i.namespace));
        var p = [];
        return $e641b86c6772ae4d$export$dfdc1655ccc5b9cb(l, $e641b86c6772ae4d$export$5a7767152ae0305f(u.concat($e641b86c6772ae4d$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $aeb02c6ea4661e47$var$he(15), $aeb02c6ea4661e47$var$M(e, t.name);
    }, $aeb02c6ea4661e47$var$F).toString() : "", p;
}
var $aeb02c6ea4661e47$var$Me = new $aeb02c6ea4661e47$var$ke, $aeb02c6ea4661e47$var$ze = $aeb02c6ea4661e47$var$Fe(), $aeb02c6ea4661e47$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $aeb02c6ea4661e47$var$Me,
    stylis: $aeb02c6ea4661e47$var$ze
}), $aeb02c6ea4661e47$export$91317688fc694efa = $aeb02c6ea4661e47$export$8c190ef828af4c86.Consumer, $aeb02c6ea4661e47$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createContext(void 0);
function $aeb02c6ea4661e47$var$Ge() {
    return (0, $hJwnw.useContext)($aeb02c6ea4661e47$export$8c190ef828af4c86);
}
function $aeb02c6ea4661e47$export$a473771da2f0ff7c(e) {
    var t = (0, $hJwnw.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $aeb02c6ea4661e47$var$Ge().styleSheet, l = (0, $hJwnw.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $hJwnw.useMemo)(function() {
        return $aeb02c6ea4661e47$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $hJwnw.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($98c7de0fc517b2f6$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $hJwnw.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($aeb02c6ea4661e47$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($aeb02c6ea4661e47$var$Le.Provider, {
        value: u
    }, e.children));
}
var $aeb02c6ea4661e47$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $aeb02c6ea4661e47$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $aeb02c6ea4661e47$var$ue(this, function() {
            throw $aeb02c6ea4661e47$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $aeb02c6ea4661e47$var$ze), this.name + e.hash;
    }, e;
}(), $aeb02c6ea4661e47$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $aeb02c6ea4661e47$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $aeb02c6ea4661e47$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $aeb02c6ea4661e47$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $aeb02c6ea4661e47$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$aeb02c6ea4661e47$var$Ue(i) && (Array.isArray(i) && i.isCss || $aeb02c6ea4661e47$var$re(i) ? r.push("".concat($aeb02c6ea4661e47$var$He(s), ":"), i, ";") : $aeb02c6ea4661e47$var$ce(i) ? r.push.apply(r, (0, $4210dc1af4009341$export$1216008129fb82ed)((0, $4210dc1af4009341$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $aeb02c6ea4661e47$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($aeb02c6ea4661e47$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $0f17ddb1350be779$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $aeb02c6ea4661e47$var$Xe(e, t, n, o) {
    if ($aeb02c6ea4661e47$var$Ue(e)) return [];
    if ($aeb02c6ea4661e47$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($aeb02c6ea4661e47$var$re(e)) {
        if (!$aeb02c6ea4661e47$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $aeb02c6ea4661e47$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $aeb02c6ea4661e47$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $aeb02c6ea4661e47$var$ce(e) ? $aeb02c6ea4661e47$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($aeb02c6ea4661e47$var$_, e.map(function(e) {
        return $aeb02c6ea4661e47$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $aeb02c6ea4661e47$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($aeb02c6ea4661e47$var$re(n) && !$aeb02c6ea4661e47$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $aeb02c6ea4661e47$var$Ke = $aeb02c6ea4661e47$var$z($aeb02c6ea4661e47$export$83d89fbfd8236492), $aeb02c6ea4661e47$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $aeb02c6ea4661e47$var$Ze(e), this.componentId = t, this.baseHash = $aeb02c6ea4661e47$var$M($aeb02c6ea4661e47$var$Ke, t), this.baseStyle = n, $aeb02c6ea4661e47$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $aeb02c6ea4661e47$var$ie(o, this.staticRulesId);
            else {
                var r = $aeb02c6ea4661e47$var$ae($aeb02c6ea4661e47$var$Xe(this.rules, e, t, n)), s = $aeb02c6ea4661e47$var$x($aeb02c6ea4661e47$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $aeb02c6ea4661e47$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $aeb02c6ea4661e47$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $aeb02c6ea4661e47$var$ae($aeb02c6ea4661e47$var$Xe(u, e, t, n));
                    a = $aeb02c6ea4661e47$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $aeb02c6ea4661e47$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $aeb02c6ea4661e47$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $aeb02c6ea4661e47$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createContext(void 0), $aeb02c6ea4661e47$export$b631efc24e9d5e2f = $aeb02c6ea4661e47$export$2c657da244d00bd6.Consumer;
function $aeb02c6ea4661e47$export$93d4e7f90805808f() {
    var e = (0, $hJwnw.useContext)($aeb02c6ea4661e47$export$2c657da244d00bd6);
    if (!e) throw $aeb02c6ea4661e47$var$he(18);
    return e;
}
function $aeb02c6ea4661e47$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($aeb02c6ea4661e47$export$2c657da244d00bd6), r = (0, $hJwnw.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $aeb02c6ea4661e47$var$he(14);
            if ($aeb02c6ea4661e47$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $aeb02c6ea4661e47$var$he(8);
            return n ? (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($aeb02c6ea4661e47$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $aeb02c6ea4661e47$var$rt = {}, $aeb02c6ea4661e47$var$st = new Set;
function $aeb02c6ea4661e47$var$it(e, r, s) {
    var i = $aeb02c6ea4661e47$export$7ba318d8d2f06c76(e), a = e, c = !$aeb02c6ea4661e47$var$L(e), p = r.attrs, d = void 0 === p ? $aeb02c6ea4661e47$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $aeb02c6ea4661e47$var$R(e);
        $aeb02c6ea4661e47$var$rt[n] = ($aeb02c6ea4661e47$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($aeb02c6ea4661e47$var$$($aeb02c6ea4661e47$export$83d89fbfd8236492 + n + $aeb02c6ea4661e47$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $aeb02c6ea4661e47$var$L(e) ? "styled.".concat(e) : "Styled(".concat($aeb02c6ea4661e47$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($aeb02c6ea4661e47$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $aeb02c6ea4661e47$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($aeb02c6ea4661e47$export$2c657da244d00bd6), m = $aeb02c6ea4661e47$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $aeb02c6ea4661e47$var$I(r, f, c) || $aeb02c6ea4661e47$var$C, g = function(e, n, o) {
                for(var r, s = (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $aeb02c6ea4661e47$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $aeb02c6ea4661e47$var$ie(s[c], a[c]) : "style" === c ? (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $aeb02c6ea4661e47$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $aeb02c6ea4661e47$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $aeb02c6ea4661e47$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$aeb02c6ea4661e47$var$L(S) && !$aeb02c6ea4661e47$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $hJwnw.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $aeb02c6ea4661e47$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$aeb02c6ea4661e47$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $aeb02c6ea4661e47$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $aeb02c6ea4661e47$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $aeb02c6ea4661e47$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $aeb02c6ea4661e47$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $aeb02c6ea4661e47$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($aeb02c6ea4661e47$var$re(t) || $aeb02c6ea4661e47$var$ce(t)) return $aeb02c6ea4661e47$var$ct($aeb02c6ea4661e47$var$Xe($aeb02c6ea4661e47$var$at($aeb02c6ea4661e47$var$_, (0, $4210dc1af4009341$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $aeb02c6ea4661e47$var$Xe(r) : $aeb02c6ea4661e47$var$ct($aeb02c6ea4661e47$var$Xe($aeb02c6ea4661e47$var$at(r, n)));
}
function $aeb02c6ea4661e47$var$ut(n, o, r) {
    if (void 0 === r && (r = $aeb02c6ea4661e47$var$C), !o) throw $aeb02c6ea4661e47$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $aeb02c6ea4661e47$export$dbf350e5966cf602.apply(void 0, (0, $4210dc1af4009341$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $aeb02c6ea4661e47$var$ut(n, o, (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $aeb02c6ea4661e47$var$ut(n, o, (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $aeb02c6ea4661e47$var$pt = function(e) {
    return $aeb02c6ea4661e47$var$ut($aeb02c6ea4661e47$var$it, e);
}, $aeb02c6ea4661e47$export$2e2bcd8739ae039 = $aeb02c6ea4661e47$var$pt;
$aeb02c6ea4661e47$var$A.forEach(function(e) {
    $aeb02c6ea4661e47$export$2e2bcd8739ae039[e] = $aeb02c6ea4661e47$var$pt(e);
});
var $aeb02c6ea4661e47$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $aeb02c6ea4661e47$var$Ze(e), $aeb02c6ea4661e47$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($aeb02c6ea4661e47$var$ae($aeb02c6ea4661e47$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $aeb02c6ea4661e47$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $aeb02c6ea4661e47$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $aeb02c6ea4661e47$export$dbf350e5966cf602.apply(void 0, (0, $4210dc1af4009341$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($aeb02c6ea4661e47$var$$(JSON.stringify(i))), c = new $aeb02c6ea4661e47$var$ht(i, a);
    var l = function(e) {
        var t = $aeb02c6ea4661e47$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($aeb02c6ea4661e47$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $aeb02c6ea4661e47$var$b, o, s);
        else {
            var i = (0, $4210dc1af4009341$export$18ce0697a983be9b)((0, $4210dc1af4009341$export$18ce0697a983be9b)({}, n), {
                theme: $aeb02c6ea4661e47$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).memo(l);
}
function $aeb02c6ea4661e47$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $aeb02c6ea4661e47$var$ae($aeb02c6ea4661e47$export$dbf350e5966cf602.apply(void 0, (0, $4210dc1af4009341$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $aeb02c6ea4661e47$var$$(r);
    return new $aeb02c6ea4661e47$var$We(s, r);
}
function $aeb02c6ea4661e47$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).forwardRef(function(n, r) {
        var s = $aeb02c6ea4661e47$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($aeb02c6ea4661e47$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement(e, (0, $4210dc1af4009341$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($aeb02c6ea4661e47$var$B(e), ")"), $aeb02c6ea4661e47$var$oe(n, e);
}
var $aeb02c6ea4661e47$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $aeb02c6ea4661e47$var$Ce(), o = $aeb02c6ea4661e47$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($aeb02c6ea4661e47$var$f, '="true"'),
                "".concat($aeb02c6ea4661e47$var$y, '="').concat($aeb02c6ea4661e47$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $aeb02c6ea4661e47$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $aeb02c6ea4661e47$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$aeb02c6ea4661e47$var$f] = "", n[$aeb02c6ea4661e47$var$y] = $aeb02c6ea4661e47$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $aeb02c6ea4661e47$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("style", (0, $4210dc1af4009341$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $aeb02c6ea4661e47$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $aeb02c6ea4661e47$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($aeb02c6ea4661e47$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $aeb02c6ea4661e47$var$he(3);
    }, e;
}(), $aeb02c6ea4661e47$export$5c87cfe6c475f500 = {
    StyleSheet: $aeb02c6ea4661e47$var$ke,
    mainSheet: $aeb02c6ea4661e47$var$Me
};
var $aeb02c6ea4661e47$var$St = "__sc-".concat($aeb02c6ea4661e47$var$f, "__");


const $41d3c07e3db0036f$var$rotate = (0, $aeb02c6ea4661e47$export$d25ddfdf17c3ad3e)`
  100% {
    transform: rotate(1turn);
  }

`;
const $41d3c07e3db0036f$export$42a852a2b6b56249 = (0, $aeb02c6ea4661e47$export$2e2bcd8739ae039).div`
  position: relative;
  z-index: 0;
  width: ${(props)=>props.width ? props.width : "50px"};
  height: ${(props)=>props.width ? props.width : "50px"};
  display: block;
  box-sizing: border-box;
  border-radius: 50px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background-color: ${(props)=>props.bgColor ? props.bgColor : "#399953"};
    background-repeat: no-repeat;
    background-size: 50% 50%, 50% 50%;
    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
    background-image: linear-gradient(
        ${(props)=>props.primary ? props.primary : "#399953"},
        ${(props)=>props.primary ? props.primary : "#399953"}
      ),
      linear-gradient(
        ${(props)=>props.bgColor ? props.bgColor : "#ffffff"},
        ${(props)=>props.bgColor ? props.bgColor : "#ffffff"}
      ),
      linear-gradient(
        ${(props)=>props.bgColor ? props.bgColor : "#ffffff"},
        ${(props)=>props.bgColor ? props.bgColor : "#ffffff"}
      );
    animation: ${$41d3c07e3db0036f$var$rotate} 0.6s cubic-bezier(0.67, 0.34, 0.3, 0.71) infinite;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    left: ${(props)=>props.thickness ? props.thickness + "px" : "6px"};
    top: ${(props)=>props.thickness ? props.thickness + "px" : "6px"};
    width: calc(
      100% -
        ${(props)=>props.thickness ? props.thickness * 2 + "px" : "12px"}
    );
    height: calc(
      100% -
        ${(props)=>props.thickness ? props.thickness * 2 + "px" : "12px"}
    );
    background: ${(props)=>props.bgIframe ? props.bgIframe : props.primary ? props.bgColor : "#ffffff"};
    border-radius: 50px;
  }
`;
const $41d3c07e3db0036f$export$f6b1e3902165e5e1 = (0, $aeb02c6ea4661e47$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props)=>props.padding ? props.padding : "0"};
  height: ${(props)=>props.height ? props.height : "auto"};
`;


const $080f38168f2caab9$export$df24742afae8dff9 = ({ width: width, height: height, bgColor: bgColor, primary: primary, padding: padding, thickness: thickness, bgIframe: bgIframe })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $41d3c07e3db0036f$export$f6b1e3902165e5e1), {
        padding: padding,
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $41d3c07e3db0036f$export$42a852a2b6b56249), {
        id: "loading",
        width: width || "80px",
        bgColor: bgColor,
        primary: primary,
        thickness: thickness,
        bgIframe: bgIframe
    }));
};


const $ea6a4695036d0bc2$export$e7db60a978123476 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $264e5bf5cf964d1b$export$9fc83ad70ead8663)();
    const store = $hJwnw.useContext((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { payment: payment, themeId: themeId } = store.AppState;
    const [loading, setLoading] = (0, $hJwnw.useState)(true);
    const getPaymentDetails = async ()=>{
        try {
            const response = await (0, $cd771979e180c558$export$2e2bcd8739ae039).get(`${"https://web-api.prod-eu.identity.signicat.global"}/visa-payment-authorization/payment-details`, {
                withCredentials: true
            });
            store.AppState.setPayment(response.data);
            setLoading(false);
        } catch (e) {
            store.AppState.setActivePage("error");
        }
    };
    const handleConsent = ()=>{
        if (themeId === "sample-shop-demo-theme") {
            store.AppState.setActivePage("select-method");
            return;
        }
        window.location.href = `${"https://web-api.prod-eu.identity.signicat.global"}/visa-payment-authorization/redirect-to-auth`;
    };
    const handleDoNotConsent = ()=>{
        if (themeId === "sample-shop-demo-theme") return;
        store.AppState.setModalVisible(true);
    };
    $hJwnw.useEffect(()=>{
        getPaymentDetails();
    }, []);
    const url = new URL(window.location.href);
    //   check query param branding
    const branding = url.searchParams.get("branding");
    const [containerKey, setContainerKey] = (0, $hJwnw.useState)(0);
    $hJwnw.useEffect(()=>{
        if (themeId === "sample-shop-demo-theme") setContainerKey(containerKey + 1);
    }, [
        themeId
    ]);
    return /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__container",
        key: containerKey
    }, themeId === "checkout" ? /*#__PURE__*/ $hJwnw.createElement("div", {
        className: `consent__top consent__top--${themeId}`
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: `provider-logo provider-logo-container`
    }, /*#__PURE__*/ $hJwnw.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b8db5df6424344a9$exports)))
    }))) : "", /*#__PURE__*/ $hJwnw.createElement("div", {
        className: `consent consent--${themeId}`
    }, themeId === "sample-shop-demo-theme" && /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "powered-by"
    }, "Powered by:", /*#__PURE__*/ $hJwnw.createElement((0, $171a0bbc376ef44a$export$909477bc2c8ad221), null)), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: `consent__banner consent__banner--${themeId}`
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: `provider-logo provider-logo--${themeId}`
    })), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data"
    }, loading ? /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "block-centered"
    }, themeId === "sample-shop-demo-theme" ? /*#__PURE__*/ $hJwnw.createElement((0, $080f38168f2caab9$export$df24742afae8dff9), {
        bgIframe: "#fff",
        bgColor: "#f7f9fc",
        primary: "#5F36BC",
        width: "48px",
        height: "348px"
    }) : /*#__PURE__*/ $hJwnw.createElement((0, $bffe96b1c6039f7a$export$7f7cbe89f1eacd2), null)) : /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data--content"
    }, /*#__PURE__*/ $hJwnw.createElement("p", {
        className: "consent__data--description"
    }, t("consent.shareInfo")), themeId !== "sample-shop-demo-theme" && /*#__PURE__*/ $hJwnw.createElement($hJwnw.Fragment, null, /*#__PURE__*/ $hJwnw.createElement("p", {
        className: "consent__data--amount"
    }, payment.amount, " ", payment.currency), /*#__PURE__*/ $hJwnw.createElement("ul", null, /*#__PURE__*/ $hJwnw.createElement("li", null, /*#__PURE__*/ $hJwnw.createElement("b", null, "Merchant:"), " ", themeId === "checkout" ? "checkout.com" : "Sample Shop"), /*#__PURE__*/ $hJwnw.createElement("li", null, "transactionID: ", payment.id))), themeId === "sample-shop-demo-theme" && /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data__new_demo"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data__new_demo__amount-wrapper"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data__new_demo__amount-wrapper--row"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "norm-text"
    }, "Amount: "), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "value-text"
    }, payment.amount, payment.currency)), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data__new_demo__amount-wrapper--separator"
    }), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data__new_demo__amount-wrapper--row"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "norm-text"
    }, "Merchant: "), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "value-text"
    }, "Sample Shop"))), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__data__new_demo__transaction-id"
    }, "TransactionID: ", payment.id)))), !loading && /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__action"
    }, /*#__PURE__*/ $hJwnw.createElement("button", {
        className: `btn btn--secondary btn--secondary--${themeId}`,
        onClick: ()=>handleDoNotConsent()
    }, /*#__PURE__*/ $hJwnw.createElement("span", null, t("consent.consentDeny"))), /*#__PURE__*/ $hJwnw.createElement("button", {
        className: `btn btn--primary btn--primary--${themeId}`,
        onClick: ()=>handleConsent()
    }, /*#__PURE__*/ $hJwnw.createElement("span", null, t("consent.consentConfirm")), themeId === "visa" ? /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "btn--primary-arrow"
    }) : "")), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "consent__bottom"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "powered-by"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "foo-logo-sgn"
    }), themeId === "visa" ? /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "foo-logo-visa"
    }) : ""))));
});



var $hJwnw = parcelRequire("hJwnw");



const $ced530a4f4fdd691$export$edf27be85e5f6da0 = ()=>{
    const { t: t } = (0, $264e5bf5cf964d1b$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "error"
    }, /*#__PURE__*/ $hJwnw.createElement("h1", null, t("error.title")), /*#__PURE__*/ $hJwnw.createElement("span", null, t("error.description")));
};




var $hJwnw = parcelRequire("hJwnw");




const $8ef125b0f2d984c5$export$ffa3d9fee6fd705a = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    return /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "success-page"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "topbar"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "image-container"
    }, /*#__PURE__*/ $hJwnw.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b8db5df6424344a9$exports)))
    }))), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "payment-success"
    }, /*#__PURE__*/ $hJwnw.createElement("h1", null, "Your payment authorization has been completed successfully"), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "center-liner"
    }, /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "success-icon"
    }, /*#__PURE__*/ $hJwnw.createElement("svg", {
        width: "124",
        height: "125",
        viewBox: "0 0 124 125",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $hJwnw.createElement("circle", {
        cx: "62",
        cy: "62.5",
        r: "62",
        fill: "url(#paint0_linear_675_15128)"
    }), /*#__PURE__*/ $hJwnw.createElement("path", {
        d: "M42 66L53.5 77.5L82.5 48.5",
        stroke: "white",
        "stroke-width": "6",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }), /*#__PURE__*/ $hJwnw.createElement("defs", null, /*#__PURE__*/ $hJwnw.createElement("linearGradient", {
        id: "paint0_linear_675_15128",
        x1: "34.9834",
        y1: "10.1433",
        x2: "92.9834",
        y2: "124.143",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $hJwnw.createElement("stop", {
        "stop-color": "#186AFF"
    }), /*#__PURE__*/ $hJwnw.createElement("stop", {
        offset: "1",
        "stop-color": "#711BC7"
    })))))), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "center-liner"
    }, /*#__PURE__*/ $hJwnw.createElement("span", {
        className: "price"
    }, "1.500 EUR")), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "center-liner"
    }, /*#__PURE__*/ $hJwnw.createElement("span", {
        className: "company-name"
    }, "Sample", /*#__PURE__*/ $hJwnw.createElement("span", {
        className: "txt-green"
    }, "Company"))), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "center-liner"
    }, /*#__PURE__*/ $hJwnw.createElement("span", {
        className: "date"
    }, "10:23 11.09.2024")), /*#__PURE__*/ $hJwnw.createElement("div", {
        className: "center-liner"
    }, /*#__PURE__*/ $hJwnw.createElement("span", {
        className: "transaction-id"
    }, "TransactionID: ", /*#__PURE__*/ $hJwnw.createElement("span", {
        className: "transaction-id-txt"
    }, "123456789123456789")), "d")));
});



var $hJwnw = parcelRequire("hJwnw");





const $af84bac34fc70d89$export$1a564522130d3eef = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const [loading, setLoading] = (0, $hJwnw.useState)(false);
    const proceedNbid = async ()=>{
        setLoading(true);
        window.location.href = `${"https://web-api.prod-eu.identity.signicat.global"}/payment-authorization/redirect-to-auth?method=nbid`;
    };
    const proceedPhone = async ()=>{
        window.location.href = `${"https://web-api.prod-eu.identity.signicat.global"}/payment-authorization/redirect-to-auth?method=mobile-id`;
    };
    const url = new URL(window.location.href);
    //   check query param branding
    const branding = url.searchParams.get("branding");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "page-wrap"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "block-centered"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $080f38168f2caab9$export$df24742afae8dff9), {
        bgIframe: "#fff",
        bgColor: "#f7f9fc",
        primary: "#5F36BC",
        width: "48px",
        height: "326px"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "choose-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h1", null, "Select payment confirmation method"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "choose-page__secondary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("nav", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("button", {
        className: "choose-page-item",
        onClick: proceedNbid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", {
        className: "choose-page-item__graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.76562 13.0859C8.79481 13.0859 8.00781 13.8729 8.00781 14.8438C8.00781 15.8146 8.79481 16.6016 9.76562 16.6016H14.8438C15.8146 16.6016 16.6016 15.8146 16.6016 14.8438C16.6016 13.8729 15.8146 13.0859 14.8438 13.0859H9.76562ZM35.1562 13.0859C34.1854 13.0859 33.3984 13.8729 33.3984 14.8438C33.3984 15.8146 34.1854 16.6016 35.1562 16.6016H40.2344C41.2052 16.6016 41.9922 15.8146 41.9922 14.8438C41.9922 13.8729 41.2052 13.0859 40.2344 13.0859H35.1562ZM8.00781 28.3854C8.00781 27.4145 8.79481 26.6275 9.76562 26.6275H14.8438C15.8146 26.6275 16.6016 27.4145 16.6016 28.3854C16.6016 29.3562 15.8146 30.1432 14.8438 30.1432H9.76562C8.79481 30.1432 8.00781 29.3562 8.00781 28.3854ZM9.76562 33.3984C8.79481 33.3984 8.00781 34.1854 8.00781 35.1562C8.00781 36.1271 8.79481 36.9141 9.76562 36.9141H14.8438C15.8146 36.9141 16.6016 36.1271 16.6016 35.1562C16.6016 34.1854 15.8146 33.3984 14.8438 33.3984H9.76562ZM33.3984 35.1562C33.3984 34.1854 34.1854 33.3984 35.1562 33.3984H40.2344C41.2052 33.3984 41.9922 34.1854 41.9922 35.1562C41.9922 36.1271 41.2052 36.9141 40.2344 36.9141H35.1562C34.1854 36.9141 33.3984 36.1271 33.3984 35.1562ZM35.1562 19.8568C34.1854 19.8568 33.3984 20.6438 33.3984 21.6146C33.3984 22.5855 34.1854 23.3725 35.1562 23.3725H40.2344C41.2052 23.3725 41.9922 22.5855 41.9922 21.6146C41.9922 20.6438 41.2052 19.8568 40.2344 19.8568H35.1562ZM20.7031 21.6146C20.7031 20.6438 21.4901 19.8568 22.4609 19.8568H27.5391C28.5099 19.8568 29.2969 20.6438 29.2969 21.6146C29.2969 22.5855 28.5099 23.3725 27.5391 23.3725H22.4609C21.4901 23.3725 20.7031 22.5855 20.7031 21.6146ZM22.4609 26.6275C21.4901 26.6275 20.7031 27.4145 20.7031 28.3854C20.7031 29.3562 21.4901 30.1432 22.4609 30.1432H27.5391C28.5099 30.1432 29.2969 29.3562 29.2969 28.3854C29.2969 27.4145 28.5099 26.6275 27.5391 26.6275H22.4609Z",
        fill: "#39134C"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", {
        className: "choose-page-item__title"
    }, "BankID"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", {
        className: "choose-page-item__subtitle"
    }, "Norway"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "choose-page-item__arrow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.1303 7.63044C11.4265 7.3343 11.9066 7.3343 12.2028 7.63044L18.0361 13.4638C18.3322 13.7599 18.3322 14.2401 18.0361 14.5362L12.2028 20.3696C11.9066 20.6657 11.4265 20.6657 11.1303 20.3696C10.8342 20.0734 10.8342 19.5933 11.1303 19.2971L16.4274 14L11.1303 8.70289C10.8342 8.40674 10.8342 7.92659 11.1303 7.63044Z",
        fill: "#5F36BC"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("button", {
        className: "choose-page-item",
        onClick: proceedPhone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", {
        className: "choose-page-item__graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.85156 8.125C7.85156 5.70876 9.81032 3.75 12.2266 3.75H29.1016C31.5178 3.75 33.4766 5.70875 33.4766 8.125V43.125C33.4766 45.5412 31.5178 47.5 29.1016 47.5H12.2266C9.81032 47.5 7.85156 45.5412 7.85156 43.125V8.125ZM12.2266 5C10.5007 5 9.10156 6.39911 9.10156 8.125V43.125C9.10156 44.8509 10.5007 46.25 12.2266 46.25H29.1016C30.8275 46.25 32.2266 44.8509 32.2266 43.125V8.125C32.2266 6.39911 30.8275 5 29.1016 5H12.2266Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.1016 43.75C14.1016 43.4048 14.3814 43.125 14.7266 43.125H26.6016C26.9467 43.125 27.2266 43.4048 27.2266 43.75C27.2266 44.0952 26.9467 44.375 26.6016 44.375H14.7266C14.3814 44.375 14.1016 44.0952 14.1016 43.75Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        d: "M45.3989 25.625C45.3989 34.2544 38.4034 41.25 29.7739 41.25C21.1445 41.25 14.1489 34.2544 14.1489 25.625C14.1489 16.9956 21.1445 10 29.7739 10C38.4034 10 45.3989 16.9956 45.3989 25.625Z",
        fill: "#41FFD1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M27.6541 29.85C27.9098 30.0819 27.929 30.4772 27.6971 30.7329C26.5627 31.9836 24.8748 32.8843 23.5248 33.4648C22.8409 33.7589 22.2249 33.9787 21.7794 34.1251C21.5563 34.1984 21.3753 34.2536 21.2489 34.2907C21.1857 34.3093 21.1361 34.3234 21.1018 34.333L21.0618 34.344L21.0508 34.347L21.0475 34.3479L21.0465 34.3481C21.0464 34.3482 21.0459 34.3483 20.8854 33.7442L21.0459 34.3483C20.7122 34.4369 20.37 34.2383 20.2814 33.9047C20.1928 33.5711 20.3913 33.2289 20.7248 33.1402L20.7262 33.1399L20.7336 33.1379L20.7658 33.129C20.7949 33.1208 20.839 33.1083 20.8965 33.0914C21.0114 33.0577 21.1798 33.0064 21.389 32.9376C21.8081 32.7999 22.3884 32.5928 23.031 32.3165C24.3342 31.7561 25.8207 30.9411 26.7712 29.8931C27.0031 29.6374 27.3984 29.6181 27.6541 29.85Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M29.2093 27.9561C28.6647 27.5788 27.6318 27.5573 26.7111 28.4574C25.5566 29.588 23.9407 30.5709 22.6463 31.2614C21.9931 31.6099 21.4097 31.8902 20.9892 32.0836C20.7787 32.1803 20.6086 32.2555 20.4905 32.3068C20.4314 32.3325 20.3852 32.3522 20.3534 32.3656L20.3168 32.3811L20.3068 32.3852L20.3032 32.3867C20.3031 32.3867 20.3027 32.3869 20.0641 31.8092L20.3032 32.3867C19.9842 32.5185 19.6182 32.3669 19.4865 32.0478C19.3547 31.7288 19.5065 31.3634 19.8254 31.2316L19.8273 31.2308L19.8348 31.2277L19.8664 31.2144C19.8948 31.2024 19.9374 31.1842 19.9927 31.1602C20.1035 31.1121 20.2654 31.0406 20.467 30.9479C20.8704 30.7624 21.431 30.4931 22.0579 30.1586C23.3239 29.4832 24.8126 28.5671 25.8369 27.5639C27.0987 26.3303 28.7905 26.1453 29.9212 26.9286C30.4897 27.3224 30.8757 27.943 30.9509 28.7076C31.0252 29.463 30.7932 30.307 30.2363 31.1813C29.1469 32.8914 27.4025 34.1131 25.9802 34.8976C25.2621 35.2937 24.6098 35.5872 24.1361 35.782C23.899 35.8796 23.7058 35.9527 23.5705 36.0019C23.5028 36.0265 23.4496 36.0452 23.4125 36.0579C23.394 36.0643 23.3795 36.0692 23.3692 36.0726L23.357 36.0767L23.3534 36.0779L23.3522 36.0783C23.352 36.0783 23.3514 36.0785 23.1672 35.5128L23.3514 36.0785C23.0232 36.1854 22.6705 36.006 22.5636 35.6778C22.4568 35.3496 22.6361 34.997 22.9641 34.8901C22.9642 34.89 22.964 34.8901 22.9641 34.8901L22.9653 34.8897L22.9727 34.8872L23.0062 34.8758C23.0365 34.8654 23.0828 34.8492 23.1431 34.8273C23.2638 34.7833 23.4409 34.7164 23.6606 34.626C24.1006 34.445 24.7086 34.1715 25.3765 33.8031C26.7264 33.0585 28.2577 31.9608 29.182 30.5097C29.632 29.8033 29.7469 29.236 29.7069 28.83C29.6679 28.4333 29.4785 28.1426 29.2093 27.9561Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M29.4954 25.5102C28.46 25.1258 26.702 25.3353 24.1415 27.5598C22.7859 28.7374 21.7283 29.3414 20.9827 29.6505C20.6097 29.8051 20.3156 29.8857 20.1025 29.9273C19.996 29.9481 19.9102 29.9591 19.8453 29.9648C19.8129 29.9676 19.7858 29.9691 19.7639 29.9699C19.753 29.9702 19.7435 29.9704 19.7353 29.9705L19.7239 29.9705L19.719 29.9705L19.7168 29.9704L19.7157 29.9704C19.7152 29.9704 19.7146 29.9704 19.7266 29.3455L19.7146 29.9704C19.3695 29.9638 19.0951 29.6787 19.1017 29.3336C19.1082 28.9935 19.3851 28.7221 19.7233 28.7205M19.7365 28.7206L19.7346 28.7206L19.7312 28.7205L19.7259 28.7205L19.7214 28.7206C19.7214 28.7206 19.7221 28.7206 19.7233 28.7205C19.7257 28.7204 19.73 28.7201 19.7363 28.7195C19.757 28.7177 19.7992 28.7129 19.8629 28.7005C19.99 28.6757 20.2042 28.6201 20.5039 28.4958C21.1036 28.2472 22.0485 27.7223 23.3217 26.6162C26.0187 24.2731 28.2583 23.7176 29.9304 24.3383C30.7146 24.6294 31.6535 25.2492 32.293 26.2646C32.9436 27.2976 33.2537 28.6928 32.8374 30.4566C32.3744 32.4176 30.7421 34.1694 29.3362 35.3836C28.6186 36.0032 27.9294 36.5085 27.42 36.8588C27.1648 37.0342 26.9538 37.1714 26.8054 37.2654C26.7313 37.3124 26.6727 37.3487 26.6321 37.3735C26.6118 37.3859 26.596 37.3955 26.5849 37.4022L26.572 37.4099L26.5683 37.4122L26.5671 37.4128C26.5669 37.4129 26.5664 37.4133 26.2478 36.8755L26.5664 37.4133C26.2694 37.5892 25.8861 37.4911 25.7101 37.1941C25.5342 36.8972 25.6323 36.5139 25.9291 36.3379L25.9312 36.3367L25.9404 36.3312C25.9489 36.3261 25.9621 36.3181 25.9797 36.3073C26.015 36.2857 26.068 36.2529 26.1363 36.2096C26.273 36.123 26.4709 35.9943 26.7118 35.8287C27.1943 35.497 27.845 35.0197 28.5192 34.4375C29.8968 33.2479 31.2551 31.7184 31.6208 30.1694C31.9658 28.7082 31.6947 27.6602 31.2353 26.9307C30.7648 26.1837 30.0649 25.7216 29.4954 25.5102M19.7365 28.7206C19.7365 28.7206 19.7364 28.7206 19.7365 28.7206Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M33.0036 24.4872C30.7746 21.8444 27.3547 21.8191 25.3864 23.3746C24.2605 24.2643 22.9779 25.2227 21.979 25.957C21.4791 26.3245 21.0492 26.6367 20.7443 26.8571C20.5918 26.9673 20.4704 27.0545 20.3871 27.1143L20.2916 27.1828L20.2588 27.2063L20.2582 27.2067C20.2582 27.2067 20.2581 27.2067 19.8951 26.698L19.532 26.1893L19.5641 26.1663L19.6583 26.0988C19.7406 26.0397 19.8608 25.9532 20.0122 25.8439C20.315 25.6251 20.742 25.315 21.2386 24.9499C22.2329 24.2189 23.5022 23.2704 24.6113 22.3939C27.113 20.4168 31.2982 20.5265 33.9591 23.6813C36.6656 26.89 36.2399 32.4644 32.0533 36.3369C31.7999 36.5712 31.4044 36.5558 31.17 36.3024C30.9357 36.049 30.9511 35.6536 31.2045 35.4192C35.0128 31.8967 35.1872 27.076 33.0036 24.4872ZM19.3863 27.0611C19.1858 26.7801 19.251 26.3898 19.532 26.1893L19.8951 26.698L20.2582 27.2067C19.9772 27.4072 19.5869 27.342 19.3863 27.0611Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M21.6128 22.003L21.207 21.5276C20.9445 21.7517 20.9133 22.1462 21.1374 22.4087C21.3615 22.6712 21.7557 22.7024 22.0183 22.4786L22.0186 22.4783L22.0203 22.4769L22.0318 22.4673C22.0427 22.4582 22.06 22.444 22.0835 22.4251C22.1306 22.3872 22.2023 22.3307 22.2968 22.2596C22.486 22.1173 22.7659 21.9171 23.1219 21.6913C23.8359 21.2384 24.8456 20.6889 26.0352 20.2936C28.4046 19.5061 31.4414 19.3373 34.3414 21.7173L34.3414 21.7174C37.333 24.1718 37.6092 27.2892 37.1142 29.8729C36.8657 31.17 36.4234 32.3163 36.0404 33.1411C35.8495 33.5524 35.6748 33.8807 35.5489 34.1044C35.486 34.2161 35.4354 34.3016 35.4013 34.358C35.3842 34.3861 35.3713 34.4071 35.363 34.4203L35.3541 34.4345L35.3525 34.437L35.3523 34.4372L35.3523 34.4373C35.1656 34.7274 35.2493 35.114 35.5393 35.3009C35.8295 35.4879 36.2163 35.4042 36.4032 35.1141L35.8779 34.7755C36.4032 35.1141 36.4034 35.1138 36.4036 35.1135L36.404 35.1128L36.4053 35.1108L36.4093 35.1045L36.4228 35.0831C36.4343 35.0648 36.4504 35.0388 36.4706 35.0053C36.5112 34.9383 36.5685 34.8414 36.6383 34.7173C36.7778 34.4694 36.9678 34.1121 37.1742 33.6675C37.5859 32.7807 38.0686 31.5344 38.3419 30.1081C38.8904 27.2449 38.5965 23.5916 35.1343 20.751C31.8018 18.0161 28.2761 18.2316 25.641 19.1073C24.3285 19.5435 23.2256 20.1453 22.4524 20.6358C22.0648 20.8816 21.7576 21.1011 21.5455 21.2606C21.4394 21.3404 21.3569 21.4053 21.2999 21.4512C21.2714 21.4741 21.2493 21.4923 21.2337 21.5052L21.2153 21.5206L21.2099 21.5251L21.2082 21.5266L21.2075 21.5272C21.2072 21.5274 21.207 21.5276 21.6128 22.003Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M24.9053 18.2321L24.9079 18.231L24.9237 18.2245C24.9385 18.2185 24.9618 18.2091 24.9933 18.1969C25.0562 18.1724 25.1516 18.1365 25.2758 18.0929C25.5245 18.0057 25.8883 17.8884 26.34 17.7711C27.2458 17.5358 28.4924 17.3042 29.8672 17.3104C32.5982 17.3228 35.808 18.2647 37.9328 22.0077C38.1032 22.3079 38.4847 22.4131 38.7849 22.2427C39.0851 22.0723 39.1903 21.6908 39.0199 21.3907C36.6147 17.1537 32.9169 16.0743 29.8729 16.0604C28.3602 16.0536 27.0024 16.3075 26.0258 16.5612C25.5362 16.6883 25.1392 16.8163 24.8624 16.9133C24.7239 16.9618 24.6153 17.0027 24.54 17.0319C24.5024 17.0466 24.4731 17.0584 24.4525 17.0667L24.4282 17.0767L24.421 17.0797L24.4187 17.0807L24.4179 17.081C24.4176 17.0812 24.4173 17.0813 24.6613 17.6567L24.4173 17.0813C24.0995 17.216 23.9511 17.5829 24.0859 17.9007C24.2206 18.2183 24.5872 18.3667 24.9049 18.2322L24.9049 18.2322L24.9053 18.2321Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M28.0363 14.7916L27.8308 14.2014C27.5048 14.3149 27.3326 14.6711 27.446 14.9971C27.5595 15.323 27.9154 15.4952 28.2413 15.3821L28.2415 15.382L28.2495 15.3793C28.2575 15.3767 28.2709 15.3723 28.2894 15.3665C28.3264 15.355 28.3839 15.3376 28.4601 15.3167C28.6126 15.2749 28.8391 15.2188 29.1252 15.1655C29.6985 15.0585 30.5036 14.9638 31.4266 15.0126C33.2635 15.1099 35.5587 15.7723 37.46 18.0531C37.681 18.3182 38.0751 18.354 38.3403 18.133C38.6054 17.912 38.6412 17.5179 38.4202 17.2527C36.2452 14.6435 33.5885 13.8753 31.4926 13.7644C30.4491 13.7092 29.5426 13.816 28.8959 13.9367C28.572 13.9971 28.3114 14.0613 28.1292 14.1113C28.0381 14.1363 27.9664 14.1578 27.9161 14.1736C27.891 14.1814 27.8711 14.1879 27.8568 14.1926L27.8396 14.1984L27.8341 14.2002L27.8322 14.2009L27.8314 14.2012C27.8311 14.2013 27.8308 14.2014 28.0363 14.7916ZM28.2406 15.3823L28.2409 15.3822L28.2411 15.3822C28.2408 15.3822 28.2407 15.3823 28.2406 15.3823Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        d: "M21.3461 7.68476C21.3461 8.13198 20.9835 8.49452 20.5363 8.49452C20.0891 8.49452 19.7266 8.13198 19.7266 7.68476C19.7266 7.23754 20.0891 6.875 20.5363 6.875C20.9835 6.875 21.3461 7.23754 21.3461 7.68476Z",
        fill: "#2A0062"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", {
        className: "choose-page-item__title"
    }, "MobileID"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", {
        className: "choose-page-item__subtitle"
    }, "Use MobileID to authenticate"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "choose-page-item__arrow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.1303 7.63044C11.4265 7.3343 11.9066 7.3343 12.2028 7.63044L18.0361 13.4638C18.3322 13.7599 18.3322 14.2401 18.0361 14.5362L12.2028 20.3696C11.9066 20.6657 11.4265 20.6657 11.1303 20.3696C10.8342 20.0734 10.8342 19.5933 11.1303 19.2971L16.4274 14L11.1303 8.70289C10.8342 8.40674 10.8342 7.92659 11.1303 7.63044Z",
        fill: "#5F36BC"
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "powered-by"
    }, "Powered by:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $171a0bbc376ef44a$export$909477bc2c8ad221), null))));
});



var $hJwnw = parcelRequire("hJwnw");






const $f80100dff50c65a0$export$f0531b8d0686404e = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const [loading, setLoading] = (0, $hJwnw.useState)(false);
    const [phone, setPhone] = (0, $hJwnw.useState)("+47");
    const [isError, setIsError] = (0, $hJwnw.useState)(false);
    (0, $hJwnw.useEffect)(()=>{
        setLoading(true);
        const storedPhone = localStorage.getItem("phone-value");
        if (storedPhone) setPhone(storedPhone);
        setLoading(false);
    }, []);
    const proceed = async ()=>{
        setLoading(true);
        try {
            localStorage.setItem("phone-value", phone);
            const res = await (0, $cd771979e180c558$export$2e2bcd8739ae039).post(`${"https://web-api.prod-eu.identity.signicat.global"}/payment-authorization/mobile-id`, {
                phoneNumber: phone.replaceAll(" ", "")
            }, {
                withCredentials: true
            });
            if (res.status === 200) store.AppState.setActivePage("waiting-for-auth");
            else {
                setIsError(true);
                setLoading(false);
            }
        } catch (e) {
            console.log(e);
            setIsError(true);
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "page-wrap"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "block-centered"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $080f38168f2caab9$export$df24742afae8dff9), {
        bgIframe: "#fff",
        bgColor: "#f7f9fc",
        primary: "#5F36BC",
        width: "48px"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "provide-phone-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h1", null, "Verify your payment"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("p", null, "To complete your purchase securely with ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("b", null, "SampleShop"), ", please enter your mobile number. We\u2019ll send you a one-time payment authorization through ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("b", null, "Sample Bank"), " to authorize your payment."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("label", null, "Phone number"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("input", {
        className: isError ? "error-class" : "",
        placeholder: "+47123123123",
        type: "text",
        id: "phone",
        value: phone,
        onChange: (e)=>{
            if (!/^[0-9+]+$/.test(e.target.value.at(-1))) return;
            if (e.target.value.at(-1) === "+" && e.target.value.length > 1) return;
            setIsError(false);
            setPhone(e.target.value);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: isError ? "error-class visible" : "error-class"
    }, "Provided phone number is invalid"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("button", {
        type: "button",
        onClick: proceed
    }, "Continue"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("p", {
        className: "info"
    }, "Your information is used only to confirm your identity and authorize this payment in compliance with PSD2 security standards."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "powered-by"
    }, "Powered by:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $171a0bbc376ef44a$export$909477bc2c8ad221), null))));
});



var $hJwnw = parcelRequire("hJwnw");






var $hJwnw = parcelRequire("hJwnw");
var $aba716809a80902b$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $aba716809a80902b$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $aba716809a80902b$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $aba716809a80902b$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $aba716809a80902b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $aba716809a80902b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $aba716809a80902b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $aba716809a80902b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $aba716809a80902b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $aba716809a80902b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $aba716809a80902b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $aba716809a80902b$var$root = $aba716809a80902b$var$freeGlobal || $aba716809a80902b$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $aba716809a80902b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $aba716809a80902b$var$objectToString = $aba716809a80902b$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $aba716809a80902b$var$nativeMax = Math.max, $aba716809a80902b$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $aba716809a80902b$var$now = function() {
    return $aba716809a80902b$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $aba716809a80902b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($aba716809a80902b$var$FUNC_ERROR_TEXT);
    wait = $aba716809a80902b$var$toNumber(wait) || 0;
    if ($aba716809a80902b$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $aba716809a80902b$var$nativeMax($aba716809a80902b$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $aba716809a80902b$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $aba716809a80902b$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($aba716809a80902b$var$now());
    }
    function debounced() {
        var time = $aba716809a80902b$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $aba716809a80902b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $aba716809a80902b$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $aba716809a80902b$var$isSymbol(value) {
    return typeof value == "symbol" || $aba716809a80902b$var$isObjectLike(value) && $aba716809a80902b$var$objectToString.call(value) == $aba716809a80902b$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $aba716809a80902b$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($aba716809a80902b$var$isSymbol(value)) return $aba716809a80902b$var$NAN;
    if ($aba716809a80902b$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $aba716809a80902b$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($aba716809a80902b$var$reTrim, "");
    var isBinary = $aba716809a80902b$var$reIsBinary.test(value);
    return isBinary || $aba716809a80902b$var$reIsOctal.test(value) ? $aba716809a80902b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $aba716809a80902b$var$reIsBadHex.test(value) ? $aba716809a80902b$var$NAN : +value;
}
$aba716809a80902b$exports = $aba716809a80902b$var$debounce;


// src/useBoolean/useBoolean.ts
function $0c014fe2eee02257$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $hJwnw.useState)(defaultValue);
    const setTrue = (0, $hJwnw.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $hJwnw.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $hJwnw.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $0c014fe2eee02257$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $hJwnw.useLayoutEffect) : (0, $hJwnw.useEffect);
// src/useEventListener/useEventListener.ts
function $0c014fe2eee02257$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $hJwnw.useRef)(handler);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $hJwnw.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $0c014fe2eee02257$export$5139c081cbc6c8bb(handler) {
    $0c014fe2eee02257$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $0c014fe2eee02257$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $hJwnw.useState)(null);
    const copy = (0, $hJwnw.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $0c014fe2eee02257$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $hJwnw.useState)(initialValue ?? 0);
    const increment = (0, $hJwnw.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $hJwnw.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $hJwnw.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $0c014fe2eee02257$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $hJwnw.useRef)(callback);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $hJwnw.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $0c014fe2eee02257$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $0c014fe2eee02257$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $0c014fe2eee02257$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $hJwnw.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $hJwnw.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $0c014fe2eee02257$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $0c014fe2eee02257$export$ee5b5d04074a389e(fn) {
    const ref = (0, $hJwnw.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $hJwnw.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $0c014fe2eee02257$var$IS_SERVER = typeof window === "undefined";
function $0c014fe2eee02257$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $hJwnw.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $hJwnw.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $hJwnw.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($0c014fe2eee02257$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $hJwnw.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $0c014fe2eee02257$export$ee5b5d04074a389e((value)=>{
        if ($0c014fe2eee02257$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $0c014fe2eee02257$export$ee5b5d04074a389e(()=>{
        if ($0c014fe2eee02257$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $hJwnw.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $hJwnw.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $0c014fe2eee02257$export$7080b3e976bc91ab("storage", handleStorageChange);
    $0c014fe2eee02257$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $0c014fe2eee02257$var$IS_SERVER2 = typeof window === "undefined";
function $0c014fe2eee02257$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($0c014fe2eee02257$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $hJwnw.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $0c014fe2eee02257$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $0c014fe2eee02257$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $0c014fe2eee02257$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $0c014fe2eee02257$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $0c014fe2eee02257$export$32d5543ab307c01($0c014fe2eee02257$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $0c014fe2eee02257$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $0c014fe2eee02257$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $hJwnw.useRef)(func);
    funcRef.current = func;
    (0, $hJwnw.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $0c014fe2eee02257$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $hJwnw.useRef)();
    $0c014fe2eee02257$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $hJwnw.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($aba716809a80902b$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $hJwnw.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($aba716809a80902b$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $0c014fe2eee02257$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $hJwnw.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $hJwnw.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $0c014fe2eee02257$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $0c014fe2eee02257$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $hJwnw.useRef)(null);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $0c014fe2eee02257$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $0c014fe2eee02257$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $hJwnw.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $0c014fe2eee02257$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $0c014fe2eee02257$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $0c014fe2eee02257$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $hJwnw.useState)(null);
    const [state, setState] = (0, $hJwnw.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $hJwnw.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $hJwnw.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $hJwnw.useRef)(null);
    (0, $hJwnw.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $0c014fe2eee02257$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $hJwnw.useState)(false);
    (0, $hJwnw.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $0c014fe2eee02257$export$80c2a3957bcb42ea() {
    const isMounted = (0, $hJwnw.useRef)(false);
    (0, $hJwnw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $hJwnw.useCallback)(()=>isMounted.current, []);
}
function $0c014fe2eee02257$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $hJwnw.useState)(new Map(initialState));
    const actions = {
        set: (0, $hJwnw.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $hJwnw.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $hJwnw.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $hJwnw.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $0c014fe2eee02257$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $0c014fe2eee02257$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $0c014fe2eee02257$var$IS_SERVER3 = typeof window === "undefined";
function $0c014fe2eee02257$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($0c014fe2eee02257$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $hJwnw.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $hJwnw.useCallback)(()=>{
        if ($0c014fe2eee02257$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $hJwnw.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $hJwnw.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $hJwnw.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $0c014fe2eee02257$export$7080b3e976bc91ab("storage", handleStorageChange);
    $0c014fe2eee02257$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $0c014fe2eee02257$var$initialSize = {
    width: void 0,
    height: void 0
};
function $0c014fe2eee02257$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $hJwnw.useState)($0c014fe2eee02257$var$initialSize);
    const isMounted = $0c014fe2eee02257$export$80c2a3957bcb42ea();
    const previousSize = (0, $hJwnw.useRef)({
        ...$0c014fe2eee02257$var$initialSize
    });
    const onResize = (0, $hJwnw.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $hJwnw.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $0c014fe2eee02257$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $0c014fe2eee02257$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $0c014fe2eee02257$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $0c014fe2eee02257$var$IS_SERVER4 = typeof window === "undefined";
function $0c014fe2eee02257$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($0c014fe2eee02257$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($0c014fe2eee02257$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $hJwnw.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $0c014fe2eee02257$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $0c014fe2eee02257$export$7080b3e976bc91ab("resize", handleSize);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $0c014fe2eee02257$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $0c014fe2eee02257$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $0c014fe2eee02257$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $hJwnw.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $0c014fe2eee02257$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $hJwnw.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $0c014fe2eee02257$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $0c014fe2eee02257$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $0c014fe2eee02257$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $0c014fe2eee02257$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $0c014fe2eee02257$var$IS_SERVER5 = typeof window === "undefined";
function $0c014fe2eee02257$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $hJwnw.useState)(false);
    const target = (0, $hJwnw.useRef)(null);
    const originalStyle = (0, $hJwnw.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        if ($0c014fe2eee02257$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $0c014fe2eee02257$var$IS_SERVER6 = typeof window === "undefined";
function $0c014fe2eee02257$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $hJwnw.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $hJwnw.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $hJwnw.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($0c014fe2eee02257$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $hJwnw.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $0c014fe2eee02257$export$ee5b5d04074a389e((value)=>{
        if ($0c014fe2eee02257$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $0c014fe2eee02257$export$ee5b5d04074a389e(()=>{
        if ($0c014fe2eee02257$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $hJwnw.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $hJwnw.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $0c014fe2eee02257$export$7080b3e976bc91ab("storage", handleStorageChange);
    $0c014fe2eee02257$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $0c014fe2eee02257$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $hJwnw.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $hJwnw.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $hJwnw.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $hJwnw.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $hJwnw.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $0c014fe2eee02257$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $0c014fe2eee02257$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $0c014fe2eee02257$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $0c014fe2eee02257$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $0c014fe2eee02257$export$32d5543ab307c01($0c014fe2eee02257$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $0c014fe2eee02257$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $0c014fe2eee02257$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $hJwnw.useRef)(callback);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $hJwnw.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $0c014fe2eee02257$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $hJwnw.useState)(!!defaultValue);
    const toggle = (0, $hJwnw.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $0c014fe2eee02257$var$IS_SERVER7 = typeof window === "undefined";
function $0c014fe2eee02257$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($0c014fe2eee02257$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $hJwnw.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $0c014fe2eee02257$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $0c014fe2eee02257$export$7080b3e976bc91ab("resize", handleSize);
    $0c014fe2eee02257$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}


const $e2d6c825a1e95384$export$b1cb658812ce91e2 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const [shouldPoll, setShouldPoll] = (0, $hJwnw.useState)(true);
    const url = new URL(window.location.href);
    //   check query param branding
    const branding = url.searchParams.get("branding");
    const poll = async ()=>{
        try {
            const { data: data } = await (0, $cd771979e180c558$export$2e2bcd8739ae039).get(`${"https://web-api.prod-eu.identity.signicat.global"}/payment-authorization/mobile-id`, {
                withCredentials: true
            });
            if (data?.result === "COMPLETED") window.location.href = "/success?themeId=signicat";
        } catch (e) {
            console.log(e);
        }
    // store.AppState.setActivePage('waiting-for-auth')
    };
    (0, $0c014fe2eee02257$export$f4b266cd2aae9cb1)(poll, shouldPoll ? 3000 : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "page-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "waiting-for-auth-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h1", null, "Waiting for authorization on mobile device"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "block-centered"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $080f38168f2caab9$export$df24742afae8dff9), {
        bgIframe: "#fff",
        bgColor: "#f7f9fc",
        primary: "#5F36BC",
        width: "48px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("p", null, "Please do not close this page."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "powered-by"
    }, "Powered by:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $171a0bbc376ef44a$export$909477bc2c8ad221), null))));
});



var $hJwnw = parcelRequire("hJwnw");



const $222321c6977695b6$export$344477b643f8d2bb = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const url = new URL(window.location.href);
    //   check query param branding
    const branding = url.searchParams.get("branding");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "page-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "demo-payment-success-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "checkmark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        d: "M50.794 34.1419C51.2406 33.7034 51.247 32.9858 50.8084 32.5392C50.3698 32.0927 49.6523 32.0862 49.2057 32.5248L36.4313 45.0711L31.4679 40.1077C31.0253 39.6651 30.3077 39.6651 29.8652 40.1077C29.4226 40.5503 29.4226 41.2679 29.8651 41.7105L36.4169 48.2623L50.794 34.1419Z",
        fill: "#2A0062"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M72 40C72 57.6731 57.6731 72 40 72C22.3269 72 8 57.6731 8 40C8 22.3269 22.3269 8 40 8C57.6731 8 72 22.3269 72 40ZM69.7333 40C69.7333 56.4213 56.4213 69.7333 40 69.7333C23.5787 69.7333 10.2667 56.4213 10.2667 40C10.2667 23.5787 23.5787 10.2667 40 10.2667C56.4213 10.2667 69.7333 23.5787 69.7333 40Z",
        fill: "#2A0062"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "spacer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h1", null, "Success!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h2", null, "Payment sent successfully"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "powered-by"
    }, "Powered by:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $171a0bbc376ef44a$export$909477bc2c8ad221), null))));
});


const $07448a00cc83fad3$export$7c6e2c02157bb7d2 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { currentScreen: currentScreen } = store.AppState;
    const { page: page } = currentScreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $hJwnw.Fragment), null, page === "consent" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $ea6a4695036d0bc2$export$e7db60a978123476), null), page === "error" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $ced530a4f4fdd691$export$edf27be85e5f6da0), null), page === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $8ef125b0f2d984c5$export$ffa3d9fee6fd705a), null), page === "select-method" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $af84bac34fc70d89$export$1a564522130d3eef), null), page === "provide-phone" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $f80100dff50c65a0$export$f0531b8d0686404e), null), page === "waiting-for-auth" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $e2d6c825a1e95384$export$b1cb658812ce91e2), null), page === "demo-payment-success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $222321c6977695b6$export$344477b643f8d2bb), null));
});



var $hJwnw = parcelRequire("hJwnw");



var $hJwnw = parcelRequire("hJwnw");

const $d0b85cf72e72922d$export$2b77a92f1a5ad772 = ({ children: children, modalVisible: modalVisible, setModalVisible: setModalVisible })=>{
    return modalVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "modal-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "modal-overlay-bg",
        onClick: ()=>setModalVisible(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "modal-close",
        onClick: ()=>setModalVisible(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "modal--inner"
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", null);
};



const $041b2bb75165fa83$export$f106132e98c732b9 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { t: t } = (0, $264e5bf5cf964d1b$export$9fc83ad70ead8663)();
    const { modalVisible: modalVisible, themeId: themeId } = store.AppState;
    const handleContinue = async ()=>{
        window.location.href = `${"https://web-api.prod-eu.identity.signicat.global"}/visa-payment-authorization/user-cancel`;
    };
    const handleCancel = ()=>{
        store.AppState.setModalVisible(false);
    };
    const handleModalVisibility = ()=>{
        store.AppState.setModalVisible(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $d0b85cf72e72922d$export$2b77a92f1a5ad772), {
        modalVisible: modalVisible,
        setModalVisible: handleModalVisibility
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "modal--decline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "line centered"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h2", null, t("modal.header")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("p", null, t("modal.desc")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("button", {
        className: `btn btn--primary btn--primary--${themeId}`,
        onClick: ()=>handleContinue()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", null, t("modal.continue")), themeId === "visa" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "btn--primary-arrow"
    }) : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("button", {
        className: `btn btn--secondary btn--secondary--${themeId}`,
        onClick: ()=>handleCancel()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("span", null, t("modal.cancel"))))));
});



var $hJwnw = parcelRequire("hJwnw");

const $d190bd6efaec3c35$export$edb96db66d2c8b6 = (0, $aeb02c6ea4661e47$export$2e2bcd8739ae039).div`
  h1 {
    margin: 0;
    color: var(--Text-header-primary, #2b253a);
    text-align: center;

    /* Headline 4 */
    font-family: Inter;
    font-size: var(--Fonts-Size-Headline-4, 24px);
    font-style: normal;
    font-weight: 600;
    line-height: var(--Fonts-Line-height-Headline-4, 36px); /* 150% */
  }

  h2 {
    margin: 10px 0 00;
    color: var(--Text-header-primary, #2b253a);
    text-align: center;

    /* Paragraph 3 - Regular */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
    letter-spacing: -0.16px;
  }

  select {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid var(--Border-primary, #d9d9e3);
    border-radius: 8px;
    background-color: var(--Background-secondary, #ffffff);
    color: var(--Text-body-primary, #2b253a);
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px);
    letter-spacing: -0.16px;
  }
`;



const $bb1b0590f483814e$var$brandingOptions = [
    {
        value: "signicat",
        label: "Signicat"
    },
    {
        value: "experian",
        label: "Experian"
    },
    {
        value: "equifax",
        label: "Equifax"
    },
    {
        value: "mastercard",
        label: "Mastercard"
    }
];
const $bb1b0590f483814e$export$8f6dcfe950367406 = ()=>{
    const [branding, setBranding] = (0, $hJwnw.useState)("signicat");
    (0, $hJwnw.useEffect)(()=>{
        const restoreBranding = localStorage.getItem("branding");
        if ($bb1b0590f483814e$var$brandingOptions.some((option)=>option.value === restoreBranding)) setBranding(restoreBranding);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "page-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $d190bd6efaec3c35$export$edb96db66d2c8b6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h1", null, "Settings Page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("h2", null, "Select branding"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("select", {
        name: "branding",
        id: "branding",
        onChange: (e)=>{
            console.log(e.target.value);
            localStorage.setItem("branding", e.target.value);
            setBranding(e.target.value);
        },
        value: branding
    }, $bb1b0590f483814e$var$brandingOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("option", {
            key: option.value,
            value: option.value
        }, option.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "powered-by"
    }, "Powered by:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $171a0bbc376ef44a$export$909477bc2c8ad221), null)));
};


const $7683e80cab633ed9$export$554ccc96b126a426 = /*#__PURE__*/ (0, $hJwnw.createContext)((0, $6a0b0eac07d647c3$export$8ee67b622d91e484));
const $7683e80cab633ed9$export$86fbec116b87613f = ()=>{
    const path = window.location.pathname;
    const store = (0, $hJwnw.useContext)($7683e80cab633ed9$export$554ccc96b126a426);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useState(true);
    function changeTheme(themeId) {
        if (themeId === "signicat") store.AppState.setThemeId("sample-shop-demo-theme");
        if (themeId === "visa") store.AppState.setThemeId("bootz");
        if (themeId === "sparTheme") store.AppState.setThemeId("spar");
        if (themeId === "checkout") store.AppState.setThemeId("checkout");
        if (themeId === "sample-shop-demo-theme") store.AppState.setThemeId("sample-shop-demo-theme");
    }
    (0, $hJwnw.useEffect)(()=>{
        if (path === "/settings") {
            setLoading(false);
            return;
        }
        const sgncBrand = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("sgncBrand");
        sgncBrand && store.AppState.setsgncBrand(sgncBrand === "true");
        const themeId = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("themeId");
        if (themeId) changeTheme(themeId);
        if (path === "/success") {
            if (themeId === "sample-shop-demo-theme" || themeId === "signicat") store.AppState.changePage("demo-payment-success");
            else store.AppState.changePage("success");
        }
        if (path === "/mobile-id") store.AppState.setActivePage("provide-phone");
        setLoading(false);
    }, []);
    const renderContent = ()=>{
        console.log("path", path);
        const scenario = loading ? "loading" : path === "/settings" ? "settings" : "content";
        switch(scenario){
            case "loading":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Fragment, null);
            case "settings":
                console.log("settings");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $bb1b0590f483814e$export$8f6dcfe950367406), null);
            case "content":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $07448a00cc83fad3$export$7c6e2c02157bb7d2), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement((0, $041b2bb75165fa83$export$f106132e98c732b9), null));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($7683e80cab633ed9$export$554ccc96b126a426.Provider, {
        value: (0, $6a0b0eac07d647c3$export$8ee67b622d91e484)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement("div", {
        className: "app"
    }, renderContent()));
};


(0, (/*@__PURE__*/$parcel$interopDefault($a7721eb599d74a7a$exports))).render(/*#__PURE__*/ $hJwnw.createElement((0, $7683e80cab633ed9$export$86fbec116b87613f), null), document.getElementById("root"));

})();
//# sourceMappingURL=index.9154fb0a.js.map
